import React, { useEffect, useState, useRef, useMemo } from "react"
import { Tabs, Tab, Dropdown, Modal, Button } from "react-bootstrap"
import Table from "react-bootstrap/Table"
import { useNavigate, Link, useLocation } from "react-router-dom"
import { api } from "../../utils/variables"
import { buildKeywordSearchParams, KEYWORD_SEARCH_PATH, normalizeSearchGames } from "../../utils/keywordSearch"
import axios from "axios"
import { userProfileApi } from "../../services/userProfileApi"
import { getSessionItem, setSessionItem, getLocalItem, setLocalItem } from "../../utils/storage"
import { POLL_INTERVAL_MS } from '../../config/syncConfig'
import { useOnboarding } from "../../contexts/OnboardingContext"
import { usePlatforms } from "../../contexts/PlatformsContext"
import GetCSVModal from "../../additional_components/common/Modals/GetCSVModal"
import CreateTagModal from "../../additional_components/common/Modals/CreateTagModal"
import { AnimatePresence, motion } from "framer-motion"
import a1 from "../../assets/images/a1.png"
import a2 from "../../assets/images/a2.png"
import a3 from "../../assets/images/a3.png"
import a5 from "../../assets/images/a5.png"
import a6 from "../../assets/images/a6.png"
import AppsTrackingPlanModal from "../../components/Common/Modal/AppsTrackingPlanModal"
import KeywordTrackingDetailsModal from "../../components/Common/Modal/KeywordTrackingDetailsModal"
import PlatformIcon from "../../components/Common/PlatformIcon"
// Toast notifications (reuse toastr used elsewhere for consistent UI)
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import "../../styles/all-games-button.css"
import SEO from "../../components/Common/SEO"
import { generateSlug } from "../../utils/seoUtils"
import { PAGE_SEO, STRUCTURED_DATA } from "../../config/seoConfig"
import { generateCanonicalUrl } from "../../utils/seoUtils"
import { Info, ChevronDown } from "lucide-react"
import { useAnalytics, ANALYTICS_EVENTS } from "../../analytics"

export default function AppTrackingv2() {
  // Platforms context
  const { getActivePlatforms, normalizePlatformName, loading: platformsLoading } = usePlatforms();
  const { trackEvent } = useAnalytics()

  const [activeTab1, setactiveTab1] = useState("5")

  const [modal_toggle, setmodal_toggle] = useState(false)
  const [tag_Modal, settag_Modal] = useState(false)
  const [csvModal_toggle, setcsvModal_toggle] = useState(false)

  const [comparisonList, setComparisonList] = useState([])
  const [comparisonBetween, setComparisonBetween] = useState([])

  const storedComparisonApps = getSessionItem("comparisonBetween") || getLocalItem("comparisonBetween")
  const storedCamparisonList = sessionStorage.getItem("comparisonList")
  // Load remainingApps from cache on initial render (similar to storedComparisonApps)
  const storedRemainingApps = (() => {
    try {
      const cached = getSessionItem('appTrackingRemaining') || getLocalItem('appTrackingRemaining')
      return cached !== null && cached !== undefined ? Number(cached) : null
    } catch (e) {
      return null
    }
  })()
  const [loading, setLoading] = useState(false)
  const [apiResponded, setApiResponded] = useState(false)
  const [removingAppId, setRemovingAppId] = useState(null)
  const [gamesInTags, setGamesInTags] = useState([])
  const [selectedBox, setSelectedBox] = useState([])

  const [gameList, setGameList] = useState([])
  const [activeGameTab, setActiveGameTab] = useState("all")
  const [expandManageTag, setExpandManageTag] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [isAllGamesHovered, setIsAllGamesHovered] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])

  // Onboarding tutorial state for App & Game Tracking
  const { onboardingState, markPageCompleted } = useOnboarding()
  const [showAppTrackingOnboarding, setShowAppTrackingOnboarding] = useState(false)
  const [appTrackingOnboardingStep, setAppTrackingOnboardingStep] = useState(0) // 0 = search/add, 1 = filter, 2 = Track More
  const addButtonRef = useRef(null)
  const filterToggleRef = useRef(null)
  const cardsSectionRef = useRef(null)
  const trackMoreButtonRef = useRef(null)

  // Filter toggle for All / Apps only / Games only
  const [platformFilter, setPlatformFilter] = useState("all")

  // Filter for tracked apps/games by platform (Meta Quest / Steam / Apple Vision / etc.), default All Platforms
  const [selectedPlatform, setSelectedPlatform] = useState("all")

  // Separate state for modal search
  const [modalSearchTerm, setModalSearchTerm] = useState("")

  // Performance tab state variables
  const [performanceData, setPerformanceData] = useState({})
  const [performanceLoading, setPerformanceLoading] = useState(false)
  const [lastUpdated, setLastUpdated] = useState(null)
  const [lastFeatureUpdated, setLastFeatureUpdated] = useState(null)
  const [trendData, setTrendData] = useState({})
  const isFetchingPerformance = useRef(false)
  const isFetchingApps = useRef(false)
  const isFetchingTagsRef = useRef(false)
  const hasFetchedPerformanceOnce = useRef(false)
  // Adaptive sync refs: only poll when there's a reason to sync, or as a fallback
  const needsSyncRef = useRef(false)
  const lastFetchAt = useRef(0)
  // drag & drop refs/state for manual reorder
  const dragItem = useRef(null)
  const dragOverItem = useRef(null)
  const [dragOverIndex, setDragOverIndex] = useState(null)
  const [draggingIndex, setDraggingIndex] = useState(null)

  // Social media state variables
  const [socialMediaData, setSocialMediaData] = useState({})
  const [socialMediaLoading, setSocialMediaLoading] = useState(false)
  const [lastSocialUpdated, setLastSocialUpdated] = useState(null)
  const isFetchingSocialMedia = useRef(false)
  // refs to support moving an app between groups by dragging
  const draggedItemId = useRef(null)
  const dragSourceGroup = useRef(null)
  const [dropHoverGroup, setDropHoverGroup] = useState(null)
  // element used as drag preview (kept in DOM briefly for setDragImage)
  const dragPreviewRef = useRef(null)
  // Track pending optimistic moves: { [itemId]: targetGroupName }
  const pendingMovesRef = useRef({})
  // Timers for clearing stale pending moves
  const pendingMoveTimersRef = useRef({})
  // suppression registry to avoid duplicate toasts when moving an app between groups
  const moveToastSuppress = useRef(new Map())

  // Custom groups state variables
  const [activeGroup, setActiveGroup] = useState(null)
  const [groups, setGroups] = useState([])
  const [createTag, setCreateTag] = useState("")
  const [createTagDirty, setCreateTagDirty] = useState(false)
  const [showDiscardModal, setShowDiscardModal] = useState(false)
  const discardActionRef = useRef(null)
  const [showCreateErrorModal, setShowCreateErrorModal] = useState(false)
  const [createErrorMsg, setCreateErrorMsg] = useState("")
  const [createGroupLoading, setCreateGroupLoading] = useState(false)
  const [detailsShowModal, setDetailsShowModal] = useState(false)
  const [trackedGames, setTrackedGames] = useState([])
  const [filteredGames, setFilteredGames] = useState([])
  // Pagination: how many tracked apps to show initially; Show More increases this by 10
  const [visibleCount, setVisibleCount] = useState(10)

  // Confirm delete group modal state
  const [showGroupDeleteModal, setShowGroupDeleteModal] = useState(false)
  const [groupToDelete, setGroupToDelete] = useState(null)

  // Confirm removal of a tracked app (overlay X)
  const [showRemoveConfirm, setShowRemoveConfirm] = useState(false)
  const [pendingRemoveId, setPendingRemoveId] = useState(null)
  const [pendingRemoveName, setPendingRemoveName] = useState("")
  const [showUntrackConfirm, setShowUntrackConfirm] = useState(false)

  // Upgrade modal state
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const [upgradeModalTitle, setUpgradeModalTitle] = useState("Upgrade your plan to unlock this feature")
  const defaultModalTitle = "Upgrade your plan to unlock this feature"
  const subscriptionEndedTitle = "Your subscription has ended. Please reactivate to continue."

  // Helper function to open upgrade modal with default title
  const openUpgradeModal = () => {
    setUpgradeModalTitle(defaultModalTitle)
    setShowUpgradeModal(true)
  }

  // `hasPaidPlan` is `null` while we check the server; only explicitly
  // treat users as locked when this is `false`. This avoids briefly
  // showing gated/blurred UI to paid users on first render before the
  // profile API responds.
  const [hasPaidPlan, setHasPaidPlan] = useState(null)
  // Store remaining apps count from API response
  // Initialize from cache to prevent flash on first load
  const [remainingApps, setRemainingApps] = useState(storedRemainingApps)

  const navigate = useNavigate()
  const location = useLocation()

  // Check if user has any active paid plan (Basic or Premium)
  useEffect(() => {
    let cancelled = false
    const tokenPresent = Boolean(localStorage.getItem('authToken'))
    const checkPlan = async () => {
      try {
        const res = await userProfileApi.fetchCurrentPlan()
        // Debug: expose plan response and token presence when diagnosing QA issues
        try {
          const token = localStorage.getItem('authToken') || null
          console.debug('[DEBUG] fetchCurrentPlan tokenPresent=', !!token, 'tokenSnippet=', token ? token.slice(0, 6) + '...' : null)
          console.debug('[DEBUG] fetchCurrentPlan response=', res)
        } catch (e) { }
        if (res && res.data) {
          const subscriptionId = res.data.subscription_id || res.data.id || null
          const status = res.data.status || res.data.subscription_status || null
          const isActive = subscriptionId && status !== 'cancelled' && status !== 'canceled'
          if (!cancelled) setHasPaidPlan(!!isActive)
        } else {
          if (!cancelled) setHasPaidPlan(false)
        }
      } catch (err) {
        // Don't immediately treat network errors as "no plan". Leave
        // `hasPaidPlan` as `null` so the UI won't flash gated content on
        // transient failures. We'll fall back to `false` after a short
        // timeout if the check never completes.
        if (!cancelled) {
          try { /* leave as null for now */ } catch (e) { }
        }
      }
    }
    checkPlan()

    // If there's no auth token we can assume anonymous user -> mark as no-plan quickly
    if (!tokenPresent) {
      // set to false on next tick to avoid flashing null state
      setTimeout(() => { if (!cancelled) setHasPaidPlan(false) }, 50)
      return () => { cancelled = true }
    }

    // For logged-in users, allow a longer window for the plan check to complete
    // (some QA environments are slower). Only fall back to `false` after 12s.
    const fallback = setTimeout(() => {
      if (!cancelled) {
        setHasPaidPlan(prev => (prev === null ? false : prev))
      }
    }, 12000)

    return () => { cancelled = true; clearTimeout(fallback) }
  }, [])

  // Helper to pick a default app id for quick CTA navigation (prefer comparisonList first)
  const getDefaultAppId = () => {
    const first = (comparisonList && comparisonList.length > 0 && comparisonList[0]) ||
      (trackedGames && trackedGames.length > 0 && trackedGames[0]) ||
      null
    if (!first) return null
    return first.game_details?.item_id || first.item_id || null
  }

  const openAnalyticsForDefault = () => {
    const id = getDefaultAppId()
    if (!id) {
      triggerToast('No tracked app available', 'warning')
      return
    }
    trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_SHORTCUT_CLICKED, { shortcut: "analytics" })
    // open tracking tab (selected_tab index used by GameDashboard)
    confirmDiscardThen(() => navigate(`/xr/app?id=${id}`, { state: { selected_tab: 2, source_surface: "app_tracking_default_shortcut" } }))
  }

  const openAiReportsForDefault = () => {
    const id = getDefaultAppId()
    if (!id) {
      triggerToast('No tracked app available', 'warning')
      return
    }
    trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_SHORTCUT_CLICKED, { shortcut: "ai_reports" })
    // open AI Reports tab (use selected_tab index)
    confirmDiscardThen(() => navigate(`/xr/app?id=${id}`, { state: { selected_tab: 3, source_surface: "app_tracking_default_shortcut" } }))
  }

  const openKeywordTrackingForDefault = () => {
    const id = getDefaultAppId()
    if (!id) {
      triggerToast('No tracked app available', 'warning')
      return
    }
    trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_SHORTCUT_CLICKED, { shortcut: "keyword_tracking" })
    confirmDiscardThen(() => navigate(`/xr/keyword?id=${id}`, { state: { item_id: id } }))
  }

  // Export functions for Feature and Performance data
  const exportFeatureData = (format) => {
    if (comparisonList.length === 0) {
      triggerToast("No data to export", 'warning')
      return
    }

    // Prepare feature data for export
    const headers = ['Feature', ...comparisonList.map(app => app.game_details.name)]
    const rows = [
      ['App Store Score', ...comparisonList.map(app => app.game_details.asr || 'N/A')],
      ['Downloads', ...comparisonList.map(app => app.game_details.d || 'N/A')],
      ['Rating', ...comparisonList.map(app => app.game_details.rating || 'N/A')],
      ['Price', ...comparisonList.map(app => app.game_details.price || 'N/A')],
      ['Size', ...comparisonList.map(app => app.game_details.size || 'N/A')],
      ['Category', ...comparisonList.map(app => app.game_details.category || 'N/A')],
      ['Platform', ...comparisonList.map(app => app.game_details.platform || 'N/A')],
      ['Last Updated', ...comparisonList.map(app => app.game_details.last_updated || 'N/A')]
    ]

    downloadData([headers, ...rows], `app-features-comparison-${new Date().toISOString().split('T')[0]}`, format)
    try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_COMPARISON_EXPORTED, { format, tab: "feature", app_count: comparisonList.length }) } catch (e) { }
  }

  const exportPerformanceData = (format) => {
    if (comparisonList.length === 0) {
      triggerToast("No data to export", 'warning')
      return
    }

    // Prepare performance data for export
    const headers = ['Metric', ...comparisonList.map(app => app.game_details.name)]
    const rows = [
      ['App Score', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.app_score || 'N/A'
      })],
      ['Engagement Index', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.engagement_index || 'N/A'
      })],
      ['Conversion Ratio', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.conversion_ratio || 'N/A'
      })],
      ['Downloads', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.d || 'N/A'
      })],
      ['Rating', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.rating || 'N/A'
      })],
      ['URV', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics?.urv || 'N/A'
      })],
      ['Data Date', ...comparisonList.map(app => {
        const metrics = getLatestMetrics(app.game_details.item_id)
        return metrics ? formatPerformanceDate(metrics.created_at_date) : 'N/A'
      })]
    ]

    downloadData([headers, ...rows], `app-performance-comparison-${new Date().toISOString().split('T')[0]}`, format)
    try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_COMPARISON_EXPORTED, { format, tab: "performance", app_count: comparisonList.length }) } catch (e) { }
  }

  const exportSocialData = (format) => {
    if (comparisonList.length === 0) {
      triggerToast("No data to export", 'warning')
      return
    }

    const platforms = ['youtube', 'x', 'instagram', 'facebook', 'linkedin', 'tiktok', 'snapchat', 'discord', 'reddit', 'telegram','pinterest']
    
    const headers = ['Social Platform', ...comparisonList.map(game => {
    const socialData = socialMediaData[game.game_details.item_id]
    const publisherName = socialData ? Object.values(socialData)[0]?.publisher_name : null
    return publisherName ? `${game.game_details.name} (${publisherName})` : game.game_details.name
  })]
    
    const rows = platforms.map(platform => {
      const platformMeta = getPlatformMetadata(platform)
      const row = [platformMeta.displayName]
      
      comparisonList.forEach(game => {
        const socialData = socialMediaData[game.game_details.item_id]
        const platformData = socialData?.[platformMeta.key]
        
        if (platformData) {
          const displayText = platformData.handle || 'Link'
          const followerInfo = platformData.followers_display ? ` (${platformData.followers_display} ${platformData.metric_label})` : ''
          row.push(`${displayText}${followerInfo} (${platformData.url})`)
        } else {
          row.push('—')
        }
      })
      
      return row
    })

    downloadData([headers, ...rows], `app-social-media-comparison-${new Date().toISOString().split('T')[0]}`, format)
    try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_COMPARISON_EXPORTED, { format, tab: "social", app_count: comparisonList.length }) } catch (e) { }
  }

  const downloadData = (data, filename, format) => {
    try {
      if (format === 'csv') {
        const csvContent = data.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${filename}.csv`
        link.click()
        triggerToast("CSV export completed successfully", 'success')
      } else if (format === 'xlsx') {
        // For XLSX, we'll create a simple tab-separated format that Excel can open
        const tsvContent = data.map(row => row.join('\t')).join('\n')
        const blob = new Blob([tsvContent], { type: 'application/vnd.ms-excel;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${filename}.xls`
        link.click()
        triggerToast("Excel export completed successfully", 'success')
      } else if (format === 'pdf') {
        // For PDF, we'll create an HTML table and print it
        const htmlTable = `
          <html>
            <head>
              <title>${filename}</title>
              <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { border-collapse: collapse; width: 100%; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; font-weight: bold; }
                h1 { color: #333; margin-bottom: 20px; }
              </style>
            </head>
            <body>
              <h1>App Comparison Report</h1>
              <table>
                ${data.map((row, index) => `
                  <tr>
                    ${row.map(cell => `<${index === 0 ? 'th' : 'td'}>${cell}</${index === 0 ? 'th' : 'td'}>`).join('')}
                  </tr>
                `).join('')}
              </table>
              <p><small>Generated on: ${new Date().toLocaleString()}</small></p>
            </body>
          </html>
        `
        const printWindow = window.open('', '_blank')
        printWindow.document.write(htmlTable)
        printWindow.document.close()
        printWindow.print()
        triggerToast("PDF export initiated - please use browser print dialog", 'success')
      }
    } catch (error) {
      console.error('Export error:', error)
      triggerToast("Export failed. Please try again.", 'error')
    }
  }

  // Map a platform name to icon, color, label and normalized key (e.g. "twitter" -> "x")
  const getPlatformMetadata = (platformName) => {
    const platform = platformName.toLowerCase()
    const metadata = {
      youtube: {
        icon: "fab fa-youtube",
        color: "#FF0000",
        displayName: "YouTube",
        key: "youtube"
      },
      x: {
        icon: "fab fa-twitter",
        color: "#1DA1F2",
        displayName: "X (Twitter)",
        key: "x"
      },
      twitter: {
        icon: "fab fa-twitter",
        color: "#1DA1F2",
        displayName: "X (Twitter)",
        key: "x"
      },
      instagram: {
        icon: "fab fa-instagram",
        color: "#E4405F",
        displayName: "Instagram",
        key: "instagram"
      },
      facebook: {
        icon: "fab fa-facebook",
        color: "#1877F2",
        displayName: "Facebook",
        key: "facebook"
      },
      linkedin: {
        icon: "fab fa-linkedin",
        color: "#0077B5",
        displayName: "LinkedIn",
        key: "linkedin"
      },
      tiktok: {
        icon: "fab fa-tiktok",
        color: "#000000",
        displayName: "TikTok",
        key: "tiktok"
      },
      snapchat: {
        icon: "fab fa-snapchat",
        color: "#FFFC00",
        displayName: "Snapchat",
        key: "snapchat"
      },
      discord: {
        icon: "fab fa-discord",
        color: "#5865F2",
        displayName: "Discord",
        key: "discord"
      },
      reddit: {
        icon: "fab fa-reddit",
        color: "#FF4500",
        displayName: "Reddit",
        key: "reddit"
      },
      telegram: {
        icon: "fab fa-telegram",
        color: "#0088CC",
        displayName: "Telegram",
        key: "telegram"
      },
      pinterest: {
        icon: "fab fa-pinterest",
        color: "#E60023",
        displayName: "Pinterest",
        key: "pinterest"
      }
    }

    // Return metadata if found, otherwise create default
    if (metadata[platform]) {
      return metadata[platform]
    }

    // Default for unknown platforms
    return {
      icon: "fab fa-globe",
      color: "#6c757d",
      displayName: platformName.charAt(0).toUpperCase() + platformName.slice(1),
      key: platform
    }
  }

  // Date range validation functions
  const validateDateRange = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const diffTime = Math.abs(end - start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    // For explorer pack or no pack users, restrict to 7 days
    // You can replace this with actual user tier check
    const userTier = 'explorer' // This should come from user context/state

    if (userTier === 'explorer' || userTier === 'free') {
      if (diffDays > 7) {
        return {
          isValid: false,
          message: 'Explorer Pack users are limited to 7-day date ranges. Unlock extended ranges with KeyQuest Premium.'
        }
      }
    }

    return { isValid: true, message: '' }
  }

  const handleDateRangeChange = () => {
    const startInput = document.getElementById('dateRangeStart')
    const endInput = document.getElementById('dateRangeEnd')

    if (startInput && endInput && startInput.value && endInput.value) {
      const validation = validateDateRange(startInput.value, endInput.value)

      if (!validation.isValid) {
        setDateRangeError(validation.message)
        openUpgradeModal()
        // Reset to 7-day range
        const endDate = new Date(endInput.value)
        const startDate = new Date(endDate.setDate(endDate.getDate() - 7))
        startInput.value = startDate.toISOString().split('T')[0]
      } else {
        setDateRangeError('')
      }
    }
  }

  const handleCompareRange = () => {
    const startInput = document.getElementById('dateRangeStart')
    const endInput = document.getElementById('dateRangeEnd')

    if (!startInput.value || !endInput.value) {
      triggerToast('Please select both start and end dates', 'warning')
      return
    }

    const validation = validateDateRange(startInput.value, endInput.value)

    if (!validation.isValid) {
      setDateRangeError(validation.message)
      openUpgradeModal()
      return
    }

    // Proceed with comparison logic
    triggerToast('Date range comparison initiated', 'info')
    try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_DATE_RANGE_COMPARED, { start_date: startInput.value, end_date: endInput.value }) } catch (e) { }
    // Add your comparison logic here
  }

  // Upgrade error detection functions
  const isUpgradeError = error => {
    const response = error?.response
    const data = response?.data || {}
    const status = data?.status
    const action = data?.action || ""
    const current_tier = data?.current_tier || ""
    return status === 400 && action === "UPGRADE" && current_tier
  }

  const isUpgradeResponse = data => {
    if (!data || typeof data !== "object") return false
    const status = data?.status
    const action = data?.action || ""
    const current_tier = data?.current_tier || ""
    return status === 400 && action === "UPGRADE" && current_tier
  }

  const toggleGameTab = tabId => {
    if (activeGameTab !== tabId) setActiveGameTab(tabId)
    const gameListItem = gameList.find(g => g.name === tabId)
    const games = gameListItem
      ? comparisonList.filter(comp =>
        gameListItem.game_ids.includes(comp.game_details.item_id)
      ) // 2. Filter by matching IDs
      : []
    setGamesInTags(games)
  }

  function toggle_tagModal() {
    settag_Modal(!tag_Modal)
  }

  const [showModal, setShowModal] = useState(false)

  const handleOpen = () => setShowModal(true)
  const handleClose = () => setShowModal(false)

  const [showKeywordModal, setShowKeywordModal] = useState(false)
  const handleOpenKeywordModal = (tag = null) => {
    confirmDiscardThen(() => {
      try { setModalSearchTerm("") } catch (e) { }
      try { setSearchResults([]) } catch (e) { }
      try { setLoading(false) } catch (e) { }
      try { setCreateTag(tag) } catch (e) { }
      setShowKeywordModal(true)
    })
  }

  // Date range state variables
  const [dateRangeError, setDateRangeError] = useState('')

  // small toast helper - uses toastr for consistent styling/timing
  const triggerToast = (msg, type = 'info', title = '') => {
    try {
      if (type === 'success') toastr.success(msg, title)
      else if (type === 'error') toastr.error(msg, title)
      else if (type === 'warning') toastr.warning(msg, title)
      else toastr.info(msg, title)
    } catch (err) {
      console.warn('toastr error', err)
    }
  }

  // Inline toast shown directly under the Add button (1s)
  const [inlineToastMsg, setInlineToastMsg] = useState("")
  const [showInlineToast, setShowInlineToast] = useState(false)
  const triggerInlineToast = msg => {
    setInlineToastMsg(msg)
    setShowInlineToast(true)
    setTimeout(() => setShowInlineToast(false), 1000)
  }

  // Onboarding: show tutorial for App Tracking when backend flag not completed
  useEffect(() => {
    const seenKey = 'appTrackingOnboardingSeen'
    const sessionSeen = sessionStorage.getItem(seenKey) === 'true'
    if (sessionSeen) return

    if (onboardingState.app_tracking !== true) {
      setShowAppTrackingOnboarding(true)
      setAppTrackingOnboardingStep(0)
      // Don't mark as completed here - only mark when user clicks "Done" or "Skip All"
    }
  }, [onboardingState.app_tracking, markPageCompleted])

  // Mark tutorial as completed when user leaves the page while tutorial is active
  // This component only exists on app-tracking page, so cleanup runs when navigating away
  useEffect(() => {
    // Cleanup function runs when component unmounts (user navigates away)
    return () => {
      try {
        const tutorialSeen = sessionStorage.getItem('appTrackingOnboardingSeen') === 'true'

        // If tutorial hasn't been seen (meaning it's active), mark it as completed
        if (!tutorialSeen) {
          sessionStorage.setItem('appTrackingOnboardingSeen', 'true')

          // Try to mark as completed via API (non-blocking)
          if (typeof markPageCompleted === 'function') {
            markPageCompleted('app_tracking').catch(() => null)
          } else {
            fetch('/api/onboarding/complete', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ page: 'app_tracking' })
            }).catch(() => null)
          }
        }
      } catch (e) {
        // ignore storage errors
      }
    }
  }, [markPageCompleted])

  // Position onboarding highlight boxes and explanation tooltips
  useEffect(() => {
    if (!showAppTrackingOnboarding) return

    const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024

    const updatePositions = () => {
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight
      const isMobileNow = viewportWidth <= 768

      if (appTrackingOnboardingStep === 0 && addButtonRef.current) {
        const rect = addButtonRef.current.getBoundingClientRect()
        const highlightBox = document.querySelector('.kt-highlight-box--apptrack-search')
        if (highlightBox) {
          highlightBox.style.top = `${rect.top - 4}px`
          highlightBox.style.left = `${rect.left - 4}px`
          highlightBox.style.width = `${rect.width + 8}px`
          highlightBox.style.height = `${rect.height + 8}px`
        }
        const explanationBox = document.querySelector('.kt-explanation-box--apptrack-search')
        if (explanationBox) {
          // First reset so we can measure actual size
          explanationBox.style.top = '0px'
          explanationBox.style.left = '0px'

          requestAnimationFrame(() => {
            const boxRect = explanationBox.getBoundingClientRect()

            if (isMobileNow) {
              // Mobile: Position box below the Add button, centered
              const gap = 16
              let boxTop = rect.bottom + gap
              const boxLeft = 16 // Use CSS left: 16px from media query

              // Ensure box stays within viewport
              if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = Math.max(16, viewportHeight - boxRect.height - 16)
              }

              explanationBox.style.top = `${boxTop}px`
            } else {
              // Desktop/Tablet: Position to the right of button
              const gap = isTablet ? 40 : 56
              let boxTop = rect.top + rect.height / 2 - boxRect.height / 2
              let boxLeft = rect.right + gap

              // Ensure box stays within viewport — vertically centering a
              // tall box on an anchor near the top/bottom edge can push it
              // off-screen with no way to scroll it back (it's
              // position:fixed).
              if (boxTop < 16) {
                boxTop = 16
              } else if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = viewportHeight - boxRect.height - 16
              }
              if (boxLeft + boxRect.width > viewportWidth - 16) {
                boxLeft = viewportWidth - boxRect.width - 16
              }

              explanationBox.style.top = `${boxTop}px`
              explanationBox.style.left = `${boxLeft}px`

              // Arrow + line should sit between button and box, arrowhead touches button, line touches box
              const arrow = document.querySelector('.kt-arrow-to-apptrack-search')
              if (arrow) {
                // Arrowhead end is pinned to the button's actual center;
                // the box end can sit above/below that once the viewport
                // clamp moves the box, so angle the line instead of
                // assuming both ends share the same height.
                const buttonCenterY = rect.top + rect.height / 2
                const boxCenterY = boxTop + boxRect.height / 2
                const highlightRight = rect.right + 4 // outer edge of highlight
                const arrowheadStartX = highlightRight // arrowhead touches the highlight edge
                const endAtBox = boxLeft // line touches tutorial box
                const dx = endAtBox - arrowheadStartX
                const dy = boxCenterY - buttonCenterY
                const length = Math.max(Math.sqrt(dx * dx + dy * dy), 0)
                const angle = (Math.atan2(dy, dx) * 180) / Math.PI

                arrow.style.top = `${buttonCenterY}px`
                arrow.style.left = `${arrowheadStartX}px`
                arrow.style.width = `${length}px`
                arrow.style.transform = `rotate(${angle}deg)`
                arrow.style.transformOrigin = '0 50%'
              }
            }
          })
        }
      } else if (appTrackingOnboardingStep === 1 && filterToggleRef.current) {
        const rect = filterToggleRef.current.getBoundingClientRect()
        const highlightBox = document.querySelector('.kt-highlight-box--apptrack-filter')
        if (highlightBox) {
          highlightBox.style.top = `${rect.top - 4}px`
          highlightBox.style.left = `${rect.left - 4}px`
          highlightBox.style.width = `${rect.width + 8}px`
          highlightBox.style.height = `${rect.height + 8}px`
        }
        const explanationBox = document.querySelector('.kt-explanation-box--apptrack-filter')
        if (explanationBox) {
          // First reset so we can measure actual size
          explanationBox.style.top = '0px'
          explanationBox.style.left = '0px'

          requestAnimationFrame(() => {
            const boxRect = explanationBox.getBoundingClientRect()

            if (isMobileNow) {
              // Mobile: Position box below the filter toggles, centered
              const gap = 16
              let boxTop = rect.bottom + gap
              const boxLeft = 16 // Use CSS left: 16px from media query

              // Ensure box stays within viewport
              if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = Math.max(16, viewportHeight - boxRect.height - 16)
              }

              explanationBox.style.top = `${boxTop}px`
            } else {
              // Desktop/Tablet: Position to the right of toggles
              const gap = isTablet ? 40 : 56
              let boxTop = rect.top + rect.height / 2 - boxRect.height / 2
              let boxLeft = rect.right + gap

              // Ensure box stays within viewport — vertically centering a
              // tall box on an anchor near the top/bottom edge can push it
              // off-screen with no way to scroll it back (it's
              // position:fixed).
              if (boxTop < 16) {
                boxTop = 16
              } else if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = viewportHeight - boxRect.height - 16
              }
              if (boxLeft + boxRect.width > viewportWidth - 16) {
                boxLeft = viewportWidth - boxRect.width - 16
              }

              explanationBox.style.top = `${boxTop}px`
              explanationBox.style.left = `${boxLeft}px`

              // Arrow + line should sit between toggles and box, arrowhead touches toggles, line touches box
              const arrow = document.querySelector('.kt-arrow-to-apptrack-filter')
              if (arrow) {
                // Arrowhead end is pinned to the toggles' actual center;
                // the box end can sit above/below that once the viewport
                // clamp moves the box, so angle the line instead of
                // assuming both ends share the same height.
                const toggleCenterY = rect.top + rect.height / 2
                const boxCenterY = boxTop + boxRect.height / 2
                const highlightRight = rect.right + 4 // outer edge of highlight
                const arrowheadStartX = highlightRight // arrowhead touches the highlight edge
                const endAtBox = boxLeft // line touches tutorial box
                const dx = endAtBox - arrowheadStartX
                const dy = boxCenterY - toggleCenterY
                const length = Math.max(Math.sqrt(dx * dx + dy * dy), 0)
                const angle = (Math.atan2(dy, dx) * 180) / Math.PI

                arrow.style.top = `${toggleCenterY}px`
                arrow.style.left = `${arrowheadStartX}px`
                arrow.style.width = `${length}px`
                arrow.style.transform = `rotate(${angle}deg)`
                arrow.style.transformOrigin = '0 50%'
              }
            }
          })
        }
      } else if (appTrackingOnboardingStep === 2 && trackMoreButtonRef.current) {
        const rect = trackMoreButtonRef.current.getBoundingClientRect()
        const highlightBox = document.querySelector('.kt-highlight-box--apptrack-trackmore')
        if (highlightBox) {
          highlightBox.style.top = `${rect.top - 4}px`
          highlightBox.style.left = `${rect.left - 4}px`
          highlightBox.style.width = `${rect.width + 8}px`
          highlightBox.style.height = `${rect.height + 8}px`
        }
        const explanationBox = document.querySelector('.kt-explanation-box--apptrack-trackmore')
        if (explanationBox) {
          // First reset so we can measure actual size
          explanationBox.style.top = '0px'
          explanationBox.style.left = '0px'

          requestAnimationFrame(() => {
            const boxRect = explanationBox.getBoundingClientRect()

            if (isMobileNow) {
              // Mobile: Position box below the Track More button, centered
              const gap = 16
              let boxTop = rect.bottom + gap
              const boxLeft = 16 // Use CSS left: 16px from media query

              // Ensure box stays within viewport
              if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = Math.max(16, viewportHeight - boxRect.height - 16)
              }

              explanationBox.style.top = `${boxTop}px`
            } else {
              // Desktop/Tablet: Position to the right of button
              const gap = isTablet ? 40 : 56
              let boxTop = rect.top + rect.height / 2 - boxRect.height / 2
              let boxLeft = rect.right + gap

              // Ensure box stays within viewport — vertically centering a
              // tall box on an anchor near the top/bottom edge can push it
              // off-screen with no way to scroll it back (it's
              // position:fixed).
              if (boxTop < 16) {
                boxTop = 16
              } else if (boxTop + boxRect.height > viewportHeight - 16) {
                boxTop = viewportHeight - boxRect.height - 16
              }
              if (boxLeft + boxRect.width > viewportWidth - 16) {
                boxLeft = viewportWidth - boxRect.width - 16
              }

              explanationBox.style.top = `${boxTop}px`
              explanationBox.style.left = `${boxLeft}px`

              // Arrow + line should sit between button and box, arrowhead touches button, line touches box
              const arrow = document.querySelector('.kt-arrow-to-apptrack-trackmore')
              if (arrow) {
                // Arrowhead end is pinned to the button's actual center;
                // the box end can sit above/below that once the viewport
                // clamp moves the box, so angle the line instead of
                // assuming both ends share the same height.
                const buttonCenterY = rect.top + rect.height / 2
                const boxCenterY = boxTop + boxRect.height / 2
                const highlightRight = rect.right + 4 // outer edge of highlight
                const arrowheadStartX = highlightRight // arrowhead touches the highlight edge
                const endAtBox = boxLeft // line touches tutorial box
                const dx = endAtBox - arrowheadStartX
                const dy = boxCenterY - buttonCenterY
                const length = Math.max(Math.sqrt(dx * dx + dy * dy), 0)
                const angle = (Math.atan2(dy, dx) * 180) / Math.PI

                arrow.style.top = `${buttonCenterY}px`
                arrow.style.left = `${arrowheadStartX}px`
                arrow.style.width = `${length}px`
                arrow.style.transform = `rotate(${angle}deg)`
                arrow.style.transformOrigin = '0 50%'
              }
            }
          })
        }
      }
    }

    updatePositions()
    window.addEventListener('resize', updatePositions)
    window.addEventListener('scroll', updatePositions, true)

    return () => {
      window.removeEventListener('resize', updatePositions)
      window.removeEventListener('scroll', updatePositions, true)
    }
  }, [showAppTrackingOnboarding, appTrackingOnboardingStep])

  // When the tutorial reaches step 2 (Track More), automatically scroll the
  // page so that the Track More tile is brought into view for the user.
  useEffect(() => {
    if (!showAppTrackingOnboarding) return
    if (appTrackingOnboardingStep !== 2) return
    if (!trackMoreButtonRef.current) return

    try {
      trackMoreButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      })
    } catch (e) {
      // best-effort scroll; ignore failures (e.g. older browsers)
    }
  }, [showAppTrackingOnboarding, appTrackingOnboardingStep])

  const completeAppTrackingOnboarding = async () => {
    setShowAppTrackingOnboarding(false)
    try {
      sessionStorage.setItem('appTrackingOnboardingSeen', 'true')
      // Mark as completed when user clicks "Done"
      await markPageCompleted('app_tracking')
    } catch (e) {
      // ignore storage errors
      console.error('Error marking app_tracking as completed:', e)
    }
  }

  const skipAllTutorials = async () => {
    setShowAppTrackingOnboarding(false)
    try {
      sessionStorage.setItem('keywordExplorerOnboardingSeen', 'true')
      sessionStorage.setItem('appTrackingOnboardingSeen', 'true')
      // Mark both keyword_explorer and app_tracking as completed
      await markPageCompleted('app_tracking', { keyword_explorer: true })
    } catch (e) {
      // ignore storage errors
    }
  }
  useEffect(() => {
    // Show cached groups immediately for snappier UI, then refresh from server
    try {
      const cached = getLocalItem('appTrackingGroups')
      if (cached && Array.isArray(cached) && cached.length > 0) {
        setGroups(cached)
      }
    } catch (err) { }
    getGameTags()
    fetchTrackedAppList()
    // If there is a stored (already-parsed) value, set it
    if (storedComparisonApps) setComparisonBetween(storedComparisonApps)

    // Toast configuration is centralized in `src/utils/toast.js` and applied at app startup
  }, [])

  useEffect(() => {
    setComparisonBetween(comparisonList)
  }, [comparisonList])

  // Initialize trackedGames and filteredGames when comparisonList changes
  useEffect(() => {
    setTrackedGames(comparisonList)
    setFilteredGames(comparisonList)
  }, [comparisonList])

  // Initialize filteredGames when trackedGames changes and no group is selected
  useEffect(() => {
    if (!activeGroup && trackedGames.length > 0) {
      setFilteredGames(trackedGames)
    }
  }, [trackedGames, activeGroup])

  // Add filtering effect based on activeGroup
  useEffect(() => {
    filterGamesByGroup()
  }, [activeGroup, trackedGames, groups])

  // Fetch performance data when comparison list changes
  useEffect(() => {
    if (comparisonList.length > 0 && !hasFetchedPerformanceOnce.current) {
      hasFetchedPerformanceOnce.current = true
      fetchPerformanceData()
    }
  }, [comparisonList])

  useEffect(() => {
    if (comparisonList.length > 0) {
      fetchSocialMediaData()
    }
  }, [comparisonList])

  // Listen for keyword group updates
  useEffect(() => {
    const handleKeywordGroupsUpdated = () => {
      getGameTags()
      fetchTrackedAppList()
    }

    window.addEventListener("keywordGroupsUpdated", handleKeywordGroupsUpdated)

    return () => {
      window.removeEventListener(
        "keywordGroupsUpdated",
        handleKeywordGroupsUpdated
      )
    }
  }, [])

  // Cleanup effect when component unmounts
  useEffect(() => {
    return () => {
      isFetchingPerformance.current = false
      isFetchingApps.current = false
      hasFetchedPerformanceOnce.current = false
    }
  }, [])

  const fetchTrackedAppList = () => {
    if (storedComparisonApps) {
      setComparisonList(storedComparisonApps)
      setComparisonBetween(storedComparisonApps)
    }
    // Load remainingApps from cache immediately (if available) to prevent flash
    // This follows the same pattern as storedComparisonApps
    if (storedRemainingApps !== null) {
      setRemainingApps(storedRemainingApps)
    }
    // Always call canonical API once on mount so we know server state.
    // This ensures UI elements that depend on a completed API response
    // (like the Track More tile) don't appear until the backend has replied.
    setLoading(true)
    callAppTrackapi()
  }
  const handleSearch = async () => {
    if (!searchTerm.trim()) return

    setLoading(true)
    try {
      // Use first active platform from API instead of hardcoded 'meta'
      const activePlatforms = getActivePlatforms()
      const defaultPlatform = activePlatforms.length > 0 ? activePlatforms[0].id : 'meta'
      trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_SEARCH, { keyword: searchTerm, platform: defaultPlatform })
      const params = new URLSearchParams(buildKeywordSearchParams(searchTerm, { page: 1, platform: defaultPlatform }))
      const url = `${api}${KEYWORD_SEARCH_PATH}?${params.toString()}`

      // Initial request
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      if (isUpgradeResponse(response.data)) {
        openUpgradeModal()
        setShowKeywordModal(false) // Close the keyword details modal
        setSearchResults([])
        return
      }

      // If backend is still processing unknown keyword, poll until action changes
      const pollIntervalMs = POLL_INTERVAL_MS || 5000
      const maxAttempts = 12
      let attempts = 0
      let action = (response.data?.action || "").toLowerCase()

      while (action === 'loading' && attempts < maxAttempts) {
        attempts += 1
        // show loading skeleton while waiting
        setLoading(true)
        await new Promise(resolve => setTimeout(resolve, pollIntervalMs))
        try {
          response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          })
        } catch (err) {
          console.error('Polling keyword fetch failed:', err)
          if (isUpgradeError(err)) {
            setShowUpgradeModal(true)
            setShowKeywordModal(false)
          }
          setSearchResults([])
          setLoading(false)
          return
        }

        if (isUpgradeResponse(response.data)) {
          setShowUpgradeModal(true)
          setShowKeywordModal(false)
          setSearchResults([])
          setLoading(false)
          return
        }

        action = (response.data?.action || "").toLowerCase()
      }

      if (action === 'loading') {
        // Reached max attempts without getting a non-loading response
        console.warn('Keyword polling stopped after max attempts without non-loading action')
        setSearchResults([])
      } else {
        // Final response - set games if present
        setSearchResults(normalizeSearchGames(response.data?.games || []))
      }
    } catch (error) {
      console.error("Search failed:", error)
      if (isUpgradeError(error)) {
        openUpgradeModal()
        setShowKeywordModal(false) // Close the keyword details modal
      }
      setSearchResults([])
    } finally {
      setLoading(false)
    }
  }

  // Function to filter games based on active group
  const filterGamesByGroup = () => {
    if (!activeGroup) {
      // Show all games when no group is selected
      setFilteredGames(trackedGames)
      return
    }

    // Find the selected group
    const selectedGroup = groups.find(group => group.name === activeGroup)

    if (selectedGroup && selectedGroup.game_ids && trackedGames.length > 0) {
      // Filter games that belong to this group
      const filtered = trackedGames.filter(game =>
        selectedGroup.game_ids.includes(game.game_details.item_id)
      )
      setFilteredGames(filtered)
    } else if (
      selectedGroup &&
      (!selectedGroup.game_ids || selectedGroup.game_ids.length === 0)
    ) {
      // Group exists but has no games
      setFilteredGames([])
    } else {
      // Fallback to all games
      setFilteredGames(trackedGames)
    }
  }

  const callAppTrackapi = async () => {
    // Prevent duplicate API calls
    if (isFetchingApps.current) {
      return
    }

    isFetchingApps.current = true
    setLoading(true)

    await axios
      .get(`${api}/tracker/tracking/app`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then(res => {
        if (isUpgradeResponse(res.data)) {
          openUpgradeModal()
          return
        }

        // Store remaining apps count if present in response
        // Cache it so it's available on next page load to prevent flash
        if (res.data.remaining !== undefined) {
          const remainingValue = res.data.remaining
          setRemainingApps(remainingValue)
          // Cache the remaining value (similar to how comparisonBetween is cached)
          try {
            setSessionItem('appTrackingRemaining', remainingValue)
            setLocalItem('appTrackingRemaining', remainingValue)
          } catch (err) {
            // best-effort caching
          }
        } else {
          // If remaining is not in response, clear cache (subscription might be active now)
          setRemainingApps(null)
          try {
            sessionStorage.removeItem('appTrackingRemaining')
            localStorage.removeItem('appTrackingRemaining')
          } catch (err) {
            // best-effort cleanup
          }
        }

        // Check if the data has actually changed to prevent unnecessary re-renders
        let newData = res.data.games || []
        const currentData = comparisonList || []

        // Merge server response with any locally stored ordering to avoid the
        // "random placement" caused by server ordering differences. Server
        // objects are authoritative for content, but we preserve the user's
        // ordering stored in session/local storage when possible.
        try {
          const localStored = getSessionItem('comparisonBetween') || getLocalItem('comparisonBetween') || []
          if (Array.isArray(localStored) && localStored.length > 0) {
            // Build a map of server items for quick lookup
            const serverById = {}
            newData.forEach(item => {
              const id = (item && item.game_details && item.game_details.item_id) || (item && item.item_id) || null
              if (id) serverById[id] = item
            })

            // Reconstruct final list following localStored order but using server objects
            const merged = []
            const added = new Set()
            localStored.forEach(localItem => {
              const id = (localItem && localItem.game_details && localItem.game_details.item_id) || (localItem && localItem.item_id) || null
              if (id && serverById[id]) {
                merged.push(serverById[id])
                added.add(id)
              }
            })

            // Append any server items not present in localStored
            newData.forEach(item => {
              const id = (item && item.game_details && item.game_details.item_id) || (item && item.item_id) || null
              if (id && !added.has(id)) {
                merged.push(item)
                added.add(id)
              }
            })

            newData = merged
          }
        } catch (e) {
          console.warn('Error merging local ordering with server data', e)
        }

        // If a tracked item id was recently recorded (from Track More flow),
        // ensure that item is placed at the front of the list so it doesn't
        // appear 'randomly' positioned due to server ordering.
        try {
          const trackedId = localStorage.getItem('tracked_item_id')
          if (trackedId) {
            const idx = newData.findIndex(n => n.game_details && n.game_details.item_id === trackedId)
            if (idx !== -1) {
              const item = newData[idx]
              const without = [...newData.slice(0, idx), ...newData.slice(idx + 1)]
              newData = [item, ...without]
            }
            // clear stored marker so subsequent fetches are unaffected
            try { localStorage.removeItem('tracked_item_id') } catch (e) { }
          }
        } catch (e) { console.warn('Error applying tracked_item_id ordering', e) }

        // Simple check: if lengths are different or any item_id has changed
        const hasChanged =
          currentData.length !== newData.length ||
          newData.some(
            (newItem, index) =>
              !currentData[index] ||
              currentData[index].game_details.item_id !==
              newItem.game_details.item_id
          )

        if (hasChanged) {
          setComparisonList(newData)
          // persist per-user comparison list (session + best-effort local)
          setSessionItem("comparisonBetween", newData)
          try { setLocalItem("comparisonBetween", newData) } catch (err) { /* best-effort */ }
        } else {
          console.log("App data unchanged, skipping update")
        }
        // record last successful fetch and clear pending sync flag
        try { lastFetchAt.current = Date.now(); needsSyncRef.current = false } catch (e) { }
      })
      .catch(error => {
        console.error("Error fetching app data:", error)
        if (isUpgradeError(error)) {
          openUpgradeModal()
        }
      })
      .finally(() => {
        setLoading(false)
        isFetchingApps.current = false
        try { setApiResponded(true) } catch (e) { }
      })
  }

  // Fetch performance data for all tracked apps
  const fetchPerformanceData = async () => {
    if (comparisonList.length === 0) return

    // Prevent duplicate API calls
    if (isFetchingPerformance.current) {
      return
    }

    // Check if data was fetched recently (within last 60 seconds)
    if (lastUpdated && new Date() - lastUpdated < 60000) {
      return
    }

    // Check if we already have data for all apps
    const appsWithData = comparisonList.filter(
      app =>
        performanceData[app.game_details.item_id] &&
        performanceData[app.game_details.item_id].historic_entries
    )

    if (appsWithData.length === comparisonList.length) {
      return
    }

    // Additional safety check - if we have data for most apps, don't fetch again
    if (appsWithData.length >= comparisonList.length * 0.8) {
      return
    }

    // Final safety check - if we've already fetched once and have some data, don't fetch again
    if (
      hasFetchedPerformanceOnce.current &&
      Object.keys(performanceData).length > 0
    ) {
      console.log(
        "Performance data already fetched once and has data, skipping..."
      )
      return
    }

    isFetchingPerformance.current = true
    setPerformanceLoading(true)

    try {

      // Only fetch for apps that don't have data yet
      const appsToFetch = comparisonList.filter(
        app =>
          !performanceData[app.game_details.item_id] ||
          !performanceData[app.game_details.item_id].historic_entries
      )

      if (appsToFetch.length === 0) {
        setPerformanceLoading(false)
        isFetchingPerformance.current = false
        return
      }

      const itemIds = appsToFetch.map(a => a.game_details.item_id)

      // Call the new single performance endpoint.
      // Per API shape provided, no query params are required; the endpoint
      // returns performance for the user's tracked apps based on the auth token.
      const res = await axios.get(
        `${api}/tracker/tracking/performance`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }

      // The new API returns a `performance` map keyed by item id.
      const perfMap = res.data?.performance || res.data?.data || null
      if (!perfMap) {
        console.warn('Performance endpoint returned no data')
        setPerformanceLoading(false)
        isFetchingPerformance.current = false
        return
      }

      const newPerformanceMap = { ...performanceData }
      Object.keys(perfMap).forEach(id => {
        try {
          const p = perfMap[id]
          // Normalize to existing shape: { historic_entries: [ ... ] }
          const latest = p && p.latest_entry ? p.latest_entry : null
          const normalized = {}
          if (latest) {
            normalized.historic_entries = [latest]
          } else if (p && p.history && Array.isArray(p.history.historic_entries)) {
            normalized.historic_entries = p.history.historic_entries
          } else {
            normalized.historic_entries = []
          }
          // copy summary metrics if present
          ;['ktr', 'ku', 'aur', 'd', 'urv', 'asr', 'revenue'].forEach(k => {
            if (p && Object.prototype.hasOwnProperty.call(p, k)) normalized[k] = p[k]
          })
          newPerformanceMap[id] = normalized
        } catch (e) {
          console.warn('Error normalizing performance for', id, e)
        }
      })

      setPerformanceData(newPerformanceMap)
      setLastUpdated(new Date())
      hasFetchedPerformanceOnce.current = true
    } catch (error) {
      console.error("Error fetching performance data:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
    } finally {
      setPerformanceLoading(false)
      isFetchingPerformance.current = false
    }
  }

  // Automatic refresh (visibility/focus/polling) removed — API calls now
  // happen only on explicit user actions or after successful mutations.

  // Manual refresh function for performance data
  const refreshPerformanceData = async () => {
    // Reset the lastUpdated to force a fresh fetch
    setLastUpdated(null)
    // Clear existing performance data to force a complete refresh
    setPerformanceData({})
    // Reset the flag to allow fetching again
    hasFetchedPerformanceOnce.current = false
    // Trigger the fetch
    await fetchPerformanceData()
  }

  // Fetch social media data for all tracked apps
  const fetchSocialMediaData = async () => {
    if (comparisonList.length === 0) return

    // Prevent duplicate API calls
    if (isFetchingSocialMedia.current) {
      return
    }

    isFetchingSocialMedia.current = true
    setSocialMediaLoading(true)

    try {
      // Extract game_ids from comparisonList
      const gameIds = comparisonList.map(game => game.game_details.item_id)
      
      const response = await axios.post(
        `${api}/tracker/publisher/socials/all`,
        {
          game_ids: gameIds
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        }
      )

      const socialDataResponse = response.data?.data || []
      
      // Transform social data to match our structure
      const newSocialMediaData = {}
      
      // Process each game's social data from the array
      socialDataResponse.forEach(gameData => {
        const gameId = gameData.game_id
        const transformedSocialData = {}
        
        if (gameData.social_platforms && Array.isArray(gameData.social_platforms)) {
          gameData.social_platforms.forEach(social => {
            const platformMeta = getPlatformMetadata(social.platform)
            if (platformMeta) {
              // Use the first account if handle or profile_url is null
              let handle = social.handle
              let profileUrl = social.profile_url
              
              if (!handle || !profileUrl) {
                const firstAccount = social.accounts?.[0]
                if (firstAccount) {
                  handle = handle || firstAccount.handle
                  profileUrl = profileUrl || firstAccount.link
                }
              }
              
              transformedSocialData[platformMeta.key] = {
                url: profileUrl,
                handle: handle,
                username: handle,
                followers: social.followers,
                platform: social.platform,
                followers_display: social.followers_display,
                metric_label: social.metric_label,
                publisher_name: gameData.publisher_name
              }
            }
          })
        }
        
        newSocialMediaData[gameId] = transformedSocialData
      })

      setSocialMediaData(newSocialMediaData)
      setLastSocialUpdated(new Date())
    } catch (error) {
      console.error('Error fetching social media data:', error)
      triggerToast('Failed to load social media data', 'error')
    } finally {
      setSocialMediaLoading(false)
      isFetchingSocialMedia.current = false
    }
  }

  // Manual refresh function for social media data
  const refreshSocialMediaData = async () => {
    // Reset the lastSocialUpdated to force a fresh fetch
    setLastSocialUpdated(null)
    // Clear existing social media data to force a complete refresh
    setSocialMediaData({})
    await fetchSocialMediaData()
  }

  // Helper function to get sorted comparison list by social media data count
  const getSortedComparisonList = () => {
    return [...comparisonList].sort((a, b) => {
      const socialDataA = socialMediaData[a.game_details.item_id] || {}
      const socialDataB = socialMediaData[b.game_details.item_id] || {}
      
      const countA = Object.keys(socialDataA).length
      const countB = Object.keys(socialDataB).length
      
      // Sort by count (descending)
      return countB - countA
    })
  }

  // Helper function to format numbers with proper decimal places
  const formatMetricValue = (value) => {
    if (value === null || value === undefined || value === '') return 'N/A'
    const num = Number(value)
    if (isNaN(num)) return 'N/A'

    // For integers or numbers that are already whole numbers, show as-is
    if (Number.isInteger(num)) return num.toLocaleString()

    // For decimals, show 2 decimal places
    return num.toFixed(2)
  }

  // Option 3 compact formatter (strict display rules):
  // - Aim to keep at most 2 integer digits before the suffix.
  // - If the integer part would exceed 2 digits at a suffix level, increase
  //   the suffix (divide further) until the integer part has <= 2 digits.
  // - Formatting rules after choosing suffix:
  //   * If value >= 10 -> show rounded integer (no decimals), e.g. "12k"
  //   * If 1 <= value < 10 -> show one decimal if needed, e.g. "1.2k"
  //   * If value < 1 -> show one decimal, e.g. "0.1M"
  // Full original value should be available via the element `title` attribute.
  const formatCompactOption3 = (value) => {
    if (value === null || value === undefined || value === '') return 'N/A'
    const num = Number(value)
    if (isNaN(num)) return 'N/A'

    const abs = Math.abs(num)
    const sign = num < 0 ? '-' : ''
    const suffixes = ['', 'k', 'M', 'B', 'T']

    // Collect candidate indices where integer part has <= 2 digits
    const candidates = []
    for (let i = 0; i < suffixes.length; i++) {
      const cand = abs / Math.pow(1000, i)
      if (Number.isFinite(cand) && Math.floor(cand) < 100) candidates.push(i)
    }

    // Prefer a candidate that also has scaled value >= 1 so we avoid tiny
    // fractional numbers like "0.1T" for mid-range values. Otherwise fall
    // back to the smallest candidate index.
    let chosen = 0
    if (candidates.length > 0) {
      const withGeOne = candidates.find(i => abs / Math.pow(1000, i) >= 1)
      chosen = withGeOne !== undefined ? withGeOne : candidates[0]
    }

    let v = abs / Math.pow(1000, chosen)

    let out
    if (v >= 10) {
      out = Math.round(v).toString()
    } else {
      // show one decimal place when < 10 to keep it compact but readable
      out = Number.isInteger(v) ? v.toString() : v.toFixed(1).replace(/\.0$/, '')
    }

    return sign + out + suffixes[chosen]
  }

  // Memoized cache for metrics to avoid repeated computations
  const metricsCache = useRef(new Map())
  // Fast lookup map for analytics provided directly in comparisonList
  const analyticsMap = useRef(new Map())

  // Helper function to check if a value requires upgrade
  const isUpgradeRequired = (value) => {
    return value === '%UPGRADE_KEYQ%'
  }

  // Helper component to render upgrade-gated content
  const UpgradeGatedContent = ({ value, isLocked, onClick, title, style = {} }) => {
    // Only locked when we have positively determined the user does NOT
    // have a paid plan. While `hasPaidPlan` is `null` (unknown) we avoid
    // locking so paid users won't see a flash of blurred content.
    const locked = (hasPaidPlan === false) || Boolean(isLocked)
    if (!locked) {
      return <span title={title}>{value}</span>
    }

    const clickHandler = onClick || (() => openUpgradeModal())

    return (
      <div
        onClick={clickHandler}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') clickHandler() }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          cursor: 'pointer',
          position: 'relative',
          ...style
        }}
        title={"Unlock detailed analytics powered by KeyQuest’s proprietary models."}
      >
        <span
          style={{
            filter: 'blur(3px)',
            userSelect: 'none',
            pointerEvents: 'none'
          }}
        >
          ●●●
        </span>
        <button
          onClick={(e) => { e.stopPropagation(); clickHandler() }}
          aria-label="Unlock detailed analytics"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'inherit',
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 17a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" />
            <path d="M17 8V7a5 5 0 10-10 0v1H5v11h14V8h-2zm-8-1a4 4 0 118 0v1H9V7z" fill="currentColor" />
          </svg>
        </button>
      </div>
    )
  }

  // Helper function to get latest performance metrics for an app (optimized with caching)
  const getLatestMetrics = appId => {
    // Check cache first for fast access
    if (metricsCache.current.has(appId)) {
      return metricsCache.current.get(appId)
    }

    // Get analytics data quickly from analyticsMap (built from comparisonList)
    let metrics = analyticsMap.current.get(appId) ?? null
    if (!metrics) {
      // Fall back to performance data from separate API call
      const appData = performanceData[appId]
      if (appData?.historic_entries?.length > 0) {
        metrics = appData.historic_entries[0]
      }
    }

    // Cache the result for next time
    metricsCache.current.set(appId, metrics)
    return metrics
  }

  // Clear metrics cache and rebuild analytics lookup when comparisonList changes
  useEffect(() => {
    metricsCache.current.clear()
    analyticsMap.current.clear()
    // Build a quick lookup of item_id -> analytics to avoid find() calls during render
    if (Array.isArray(comparisonList)) {
      comparisonList.forEach(game => {
        const id = game?.game_details?.item_id
        const analytics = game?.game_details?.analytics ?? null
        if (id) analyticsMap.current.set(id, analytics)
      })
    }
    // Update feature timestamp when the comparison list changes
    try {
      if (Array.isArray(comparisonList) && comparisonList.length > 0) {
        setLastFeatureUpdated(new Date())
      }
    } catch (err) { }
  }, [comparisonList])

  // Helper function to format the date from the API response
  const formatPerformanceDate = dateString => {
    if (!dateString) return "N/A"
    const date = new Date(dateString)
    return date.toLocaleDateString()
  }

  // Helper function to calculate trend between two values
  const calculateTrend = (current, previous) => {
    if (!previous || previous === 0) return null
    return current - previous
  }

  // Helper function to get trend data for an app
  const getTrendData = appId => {
    const appData = performanceData[appId]
    if (!appData) return null

    // Preferred: compute trends from historic_entries when we have >=2 entries
    if (appData.historic_entries && appData.historic_entries.length >= 2) {
      const latest = appData.historic_entries[0]
      const previous = appData.historic_entries[1]
      return {
        ktr: calculateTrend(latest.ktr, previous.ktr),
        ku: calculateTrend(latest.ku, previous.ku),
        aur: calculateTrend(latest.aur, previous.aur),
        urv: calculateTrend(latest.urv, previous.urv),
        asr: calculateTrend(latest.asr, previous.asr),
        revenue: calculateTrend(latest.revenue, previous.revenue),
      }
    }

    // Fallback: if server provided top-level delta fields (e.g. p.ktr, p.ku...),
    // use those directly. This matches the new `/performance` response shape
    // where `performance[id].ktr` represents the change.
    const keys = ['ktr', 'ku', 'aur', 'urv', 'asr', 'revenue']
    const hasDeltas = keys.some(k => typeof appData[k] === 'number')
    if (hasDeltas) {
      return {
        ktr: typeof appData.ktr === 'number' ? appData.ktr : null,
        ku: typeof appData.ku === 'number' ? appData.ku : null,
        aur: typeof appData.aur === 'number' ? appData.aur : null,
        urv: typeof appData.urv === 'number' ? appData.urv : null,
        asr: typeof appData.asr === 'number' ? appData.asr : null,
        revenue: typeof appData.revenue === 'number' ? appData.revenue : null,
      }
    }

    return null
  }

  // Helper function to render trend indicator
  const renderTrendIndicator = (value, trend, format = "number") => {
    // Defensive: ensure we have a numeric value before calling Math.round
    if (value === null || value === undefined || value === "") return "N/A"
    const v = Number(value)
    if (isNaN(v)) return "N/A"

    // If trend isn't present or is zero, just show the formatted value
    if (trend === null || trend === 0) {
      return (
        <span>
          {format === "percentage"
            ? `${Math.round(v * 100)}%`
            : format === "currency"
              ? `$${Math.round(v).toLocaleString()}`
              : Math.round(v)}
        </span>
      )
    }

    const t = Number(trend)
    const isPositive = !isNaN(t) && t > 0
    const arrow = isPositive ? "↗" : "↘"
    const color = isPositive ? "#00ff88" : "#ff4444"
    const formattedTrend =
      format === "percentage"
        ? (isNaN(t) ? 0 : Math.round(t * 100))
        : format === "currency"
          ? (isNaN(t) ? 0 : Math.round(t))
          : (isNaN(t) ? 0 : Math.round(Math.abs(t)))

    return (
      <span>
        {format === "percentage"
          ? `${Math.round(v * 100)}%`
          : format === "currency"
            ? `$${Math.round(v).toLocaleString()}`
            : Math.round(v)}
        <span
          style={{
            marginLeft: "8px",
            color: color,
            fontWeight: "bold",
            fontSize: "0.9em",
          }}
        >
          {arrow} {formattedTrend}
        </span>
      </span>
    )
  }

  // Open platform/store link for a given game. Tries explicit `platform_url` first,
  // falls back to platform-specific heuristics (Meta, Steam, Apple, Pico), then
  // finally performs a site-constrained Google search as a last resort.
  const openPlatformLink = (e, game) => {
    if (e) {
      try { e.stopPropagation(); e.preventDefault() } catch (err) { }
    }
    if (!game) return
    const details = game.game_details || game
    const platformRaw = details.platform || details.platforms || details.platform_name || ''
    const platform = String(platformRaw || '').toLowerCase()
    const platformUrl = details.platform_url || details.platformUrl || (details.game && (details.game.platform_url || details.game.platformUrl)) || ''
    const name = details.name || game.name || ''

    try {
      if (platformUrl && platformUrl !== '#') {
        window.open(platformUrl, '_blank', 'noopener')
        return
      }

      // Meta / Oculus: prefer meta_item_id / item_id and optional slug
      const metaItemId = details.meta_item_id || details.metaItemId || details.item_id || details.itemId || details.game_id || (details.game && details.game.item_id) || (details.game && details.game.meta_item_id) || (details.game && details.game.oculus_id)
      if (!platformUrl && (platform.includes('meta') || platform.includes('oculus')) && metaItemId) {
        // const rawSlug = details.slug || details.slug_name || details.slugName || (details.game && (details.game.slug || details.game.slug_name || details.game.name)) || name || ''
        // const slug = String(rawSlug).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
        const rawSlug = details.slug || details.slug_name || details.slugName || (details.game && (details.game.slug || details.game.slug_name || details.game.name)) || name || ''
        const slug = generateSlug(rawSlug || '')
        const metaUrl = `https://www.meta.com/experiences/${slug}/${metaItemId}`
        window.open(metaUrl, '_blank', 'noopener')
        return
      }

      // Steam
      const steamAppId = details.steam_appid || details.steamAppId || (details.game && (details.game.steam_appid || (details.game.steam && details.game.steam.appid)))
      if (!platformUrl && platform.includes('steam') && steamAppId) {
        const steamUrl = `https://store.steampowered.com/app/${steamAppId}/`
        window.open(steamUrl, '_blank', 'noopener')
        return
      }

      // Apple Vision
      const appleId = details.apple_item_id || details.appleItemId || (details.game && (details.game.apple_item_id || details.game.appleItemId))
      if (!platformUrl && platform.includes('apple') && appleId) {
        const appleUrl = `https://apps.apple.com/app/id${appleId}`
        window.open(appleUrl, '_blank', 'noopener')
        return
      }

      // Pico: item_id is prefixed with its platform (e.g. "pico_7472678219464949801")
      const picoRawId = details.item_id || details.itemId || (details.game && details.game.item_id) || ''
      const picoId = String(picoRawId).replace(/^pico_/i, '')
      if (!platformUrl && platform.includes('pico') && /^\d+$/.test(picoId)) {
        const picoUrl = `https://store-global.picoxr.com/global/detail/1/${picoId}`
        window.open(picoUrl, '_blank', 'noopener')
        return
      }

    } catch (err) {
      console.warn('Error constructing platform URL', err)
    }

    // Fallback: site-specific Google search
    let domain = ''
    if (platform.includes('meta') || platform.includes('oculus')) domain = 'oculus.com'
    else if (platform.includes('steam')) domain = 'store.steampowered.com'
    else if (platform.includes('apple')) domain = 'apps.apple.com'
    else if (platform.includes('pico')) domain = 'store-global.picoxr.com'
    const q = domain ? `${name} site:${domain}` : name
    const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(q)}`
    window.open(searchUrl, '_blank', 'noopener')
  }

  function toggle_modal() {
    setmodal_toggle(!modal_toggle)
  }

  function toggle_modalcsv() {
    setcsvModal_toggle(!csvModal_toggle)
  }
  const handleselectedapp = async app => {
    setLoading(true)
    // Add the selected app to the array
    const appExists = comparisonList.some(
      item => item.game_details.item_id === app.item_id
    )
    if (!appExists) {
      // Add the selected app to the array
      const gameid = { item_id: app.item_id }
      try {
        const res = await axios.post(`${api}/tracker/tracking/app/`, gameid, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })

        if (isUpgradeResponse(res.data)) {
          setShowUpgradeModal(true)
          setLoading(false)
          return
        }

        trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_ADDED, { app_id: app.item_id, app_name: app.name, search_keyword: modalSearchTerm || searchTerm })

        // Optimistically add the tracked app to local lists so other pages
        // (like GameDashboard) see it immediately without waiting for network.
        try {
          setComparisonList(prev => {
            const exists = Array.isArray(prev) && prev.some(p => p.game_details && p.game_details.item_id === app.item_id)
            if (exists) return prev
            const entry = { game_details: { item_id: app.item_id, name: app.name || (app.game_details && app.game_details.name) || '', image_url: app.image_url || (app.game_details && app.game_details.image_url) || '' }, tracked_on: new Date().toISOString() }
            const next = Array.isArray(prev) ? [entry, ...prev] : [entry]
            try { setSessionItem('comparisonBetween', next) } catch (err) { }
            try { setLocalItem('comparisonBetween', next) } catch (err) { }
            try { setTrackedGames(next) } catch (err) { }
            try { setFilteredGames(next) } catch (err) { }
            return next
          })
        } catch (err) { }

        // Ensure the tracked-app list is refreshed first, then add to tag,
        // then refresh the tag list. This avoids races where the tag-add
        // checks `comparisonList` before the tracked-app POST has been
        // acknowledged locally.
        const targetTag = createTag || activeGroup || activeGameTab || null
        // Refresh tracked apps so `comparisonList` reflects the new app
        // before attempting to add it to a tag.
        await callAppTrackapi()
        // Add to tag but suppress createNewGameTag's own sync since we
        // will refresh tags explicitly after.
        await createNewGameTag(app.item_id, targetTag, false, true)
        await getGameTags()

        // Ensure the newly tracked app appears at the top of the comparison list
        setComparisonList(prev => {
          try {
            const idx = prev.findIndex(p => p.game_details && p.game_details.item_id === app.item_id)
            if (idx === -1) return prev
            const item = prev[idx]
            const without = [...prev.slice(0, idx), ...prev.slice(idx + 1)]
            const result = [item, ...without]
            // persist the user-visible order (session + best-effort local)
            try { setSessionItem('comparisonBetween', result) } catch (err) { }
            try { setLocalItem('comparisonBetween', result) } catch (err) { }
            return result
          } catch (err) {
            return prev
          }
        })
        // Refresh performance data immediately after tracking a new app
        try {
          await refreshPerformanceData()
        } catch (err) {
          console.error("Error refreshing performance data:", err)
        }

        setGamesInTagCall()
        toggle_modal()
        // Notify user the app was tracked (after modal closed)
        try { triggerToast(`Tracked "${app.game_details?.name || app.name}"`, 'success') } catch (e) { }
      } catch (error) {
        console.error("Error sending data:", error)
        if (isUpgradeError(error)) {
          openUpgradeModal()
        }
        setLoading(false)
      }
    } else {
      await removeApp(app.item_id)
      toggle_modal()
    }
  }

  async function removeApp(val) {
    // mark which app is being removed to show per-item spinner
    setRemovingAppId(val)
    setLoading(true)
    try {
      const res = await axios.delete(`${api}/tracker/tracking/app.remove`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        data: { item_id: val },
      })

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }

      // Wait for all tag deletions to finish
      await Promise.all(
        gameList
          .filter(tag => tag.game_ids.includes(val))
          .map(tag => deleteGamefromTag(val, tag.name))
      )

      // Only call callAppTrackapi if this function is called directly (not from handleselectedapp)
      if (!isFetchingApps.current) {
        await callAppTrackapi()
      }
    } catch (error) {
      console.error("Error sending data:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
    } finally {
      setLoading(false)
      setRemovingAppId(null)
    }
  }

  // Drag & drop handlers for manual reorder
  const handleDragStart = (e, position) => {
    dragItem.current = position
    setDraggingIndex(position)
    // determine item id for potential group-move drops
    try {
      const id = displayedGames?.[position]?.game_details?.item_id
      draggedItemId.current = id || null
      // determine source group. Prefer the currently active group
      // (the user is most likely dragging from the active group view),
      // otherwise fall back to the first group that contains this item.
      if (activeGroup) {
        const active = groups.find(g => g.name === activeGroup)
        if (active && Array.isArray(active.game_ids) && active.game_ids.includes(id)) {
          dragSourceGroup.current = activeGroup
        } else {
          const found = groups.find(g => g.game_ids && g.game_ids.includes(id))
          dragSourceGroup.current = found ? found.name : null
        }
      } else {
        const found = groups.find(g => g.game_ids && g.game_ids.includes(id))
        dragSourceGroup.current = found ? found.name : null
      }
    } catch (err) {
      draggedItemId.current = null
      dragSourceGroup.current = null
    }
    // small data transfer so some browsers allow drag
    try { e.dataTransfer.setData('text/plain', 'drag') } catch (err) { }

    // Create a small drag preview so the dragged thumbnail is compact
    try {
      const imgSrc = displayedGames?.[position]?.game_details?.image_url
      if (imgSrc && e && e.dataTransfer) {
        const w = 56
        const h = 36

        // Prefer using an <img> element for setDragImage (more reliable across browsers)
        const imgEl = new Image()
        imgEl.src = imgSrc
        imgEl.width = w
        imgEl.height = h
        imgEl.style.width = w + 'px'
        imgEl.style.height = h + 'px'
        imgEl.style.borderRadius = '8px'
        imgEl.style.boxShadow = '0 14px 36px rgba(246,37,90,0.28)'
        imgEl.style.border = '3px solid rgba(255,45,150,0.95)'
        imgEl.style.transform = 'scale(1.12)'
        imgEl.style.position = 'absolute'
        imgEl.style.top = '-9999px'
        imgEl.style.left = '-9999px'
        imgEl.style.zIndex = '9999'

        // Append and keep reference so we can clean it up later
        try {
          document.body.appendChild(imgEl)
          dragPreviewRef.current = imgEl
        } catch (err) {
          // fallback - ignore append errors
        }

        const applyDragImage = () => {
          try {
            if (e && e.dataTransfer && dragPreviewRef.current) {
              e.dataTransfer.setDragImage(dragPreviewRef.current, Math.floor(w / 2), Math.floor(h / 2))
            }
          } catch (err) {
            // ignore if setDragImage fails
          }

          // Remove preview shortly after setting drag image (give browser time to snapshot)
          setTimeout(() => {
            try {
              if (dragPreviewRef.current && dragPreviewRef.current.parentNode) {
                dragPreviewRef.current.parentNode.removeChild(dragPreviewRef.current)
              }
            } catch (e) { }
            dragPreviewRef.current = null
          }, 300)
        }

        if (imgEl.complete) {
          applyDragImage()
        } else {
          imgEl.onload = applyDragImage
          imgEl.onerror = () => {
            // fallback to div-based preview if image fails to load
            try {
              const fallback = document.createElement('div')
              fallback.style.width = w + 'px'
              fallback.style.height = h + 'px'
              fallback.style.backgroundImage = `url(${imgSrc})`
              fallback.style.backgroundSize = 'cover'
              fallback.style.backgroundPosition = 'center'
              fallback.style.borderRadius = '8px'
              fallback.style.boxShadow = '0 14px 36px rgba(246,37,90,0.28)'
              fallback.style.border = '3px solid rgba(255,45,150,0.95)'
              fallback.style.transform = 'scale(1.12)'
              fallback.style.position = 'absolute'
              fallback.style.top = '-9999px'
              fallback.style.left = '-9999px'
              fallback.style.zIndex = '9999'
              try { document.body.appendChild(fallback); dragPreviewRef.current = fallback } catch (err) { }
              try { e.dataTransfer.setDragImage(fallback, Math.floor(w / 2), Math.floor(h / 2)) } catch (err) { }
              setTimeout(() => {
                try { if (dragPreviewRef.current && dragPreviewRef.current.parentNode) dragPreviewRef.current.parentNode.removeChild(dragPreviewRef.current) } catch (err) { }
                dragPreviewRef.current = null
              }, 300)
            } catch (err) {
              // ignore fallback errors
            }
          }
        }
      }
    } catch (err) {
      // swallow errors - drag should still work without preview
    }
  }

  const handleDragEnd = () => {
    // cleanup refs used for cross-group moves
    draggedItemId.current = null
    dragSourceGroup.current = null
    setDropHoverGroup(null)
    setDraggingIndex(null)
    // remove any lingering drag preview element
    try {
      if (dragPreviewRef.current && dragPreviewRef.current.parentNode) {
        dragPreviewRef.current.parentNode.removeChild(dragPreviewRef.current)
      }
    } catch (err) { }
    dragPreviewRef.current = null
  }

  const handleDragEnter = (e, position) => {
    dragOverItem.current = position
    setDragOverIndex(position)
  }

  const handleDragOver = e => {
    e.preventDefault()
  }

  const handleDrop = async () => {
    const fromIdx = dragItem.current
    const toIdx = dragOverItem.current
    if (fromIdx == null || toIdx == null) {
      setDragOverIndex(null)
      dragItem.current = null
      dragOverItem.current = null
      return
    }

    // Map displayed index to item ids
    const draggedId = displayedGames[fromIdx]?.game_details?.item_id
    const targetId = displayedGames[toIdx]?.game_details?.item_id
    if (!draggedId || !targetId) {
      setDragOverIndex(null)
      dragItem.current = null
      dragOverItem.current = null
      return
    }

    // Create a copy of comparisonList and reorder by matching ids
    const listCopy = Array.from(comparisonList)
    const dragIndexInComp = listCopy.findIndex(i => i.game_details.item_id === draggedId)
    const dropIndexInComp = listCopy.findIndex(i => i.game_details.item_id === targetId)
    if (dragIndexInComp === -1 || dropIndexInComp === -1) {
      // If not found (filtered views), do nothing
      setDragOverIndex(null)
      dragItem.current = null
      dragOverItem.current = null
      return
    }

    const [moved] = listCopy.splice(dragIndexInComp, 1)
    listCopy.splice(dropIndexInComp, 0, moved)

    // Update state and persist the order to sessionStorage
    setComparisonList(listCopy)
    try {
      setSessionItem('comparisonBetween', listCopy)
    } catch (err) {
      console.warn('Could not persist comparison order to sessionStorage', err)
    }
    try {
      setLocalItem('comparisonBetween', listCopy)
    } catch (err) {
      console.warn('Could not persist comparison order to localStorage', err)
    }

    // cleanup
    setDragOverIndex(null)
    dragItem.current = null
    dragOverItem.current = null
    // also clear any move refs
    handleDragEnd()
  }

  // Drop handler for dropping a tracked app onto a group in the left-hand list
  const handleDropOnGroup = async (e, targetGroupName) => {
    e.preventDefault()
    // Clear temporary hover. We'll only activate (open) the target group
    // if the move is actually going to proceed. This prevents switching
    // the active group when the drop is a no-op (app already present).
    setDropHoverGroup(null)
    const itemId = draggedItemId.current
    if (!itemId || !targetGroupName) return

    // Prevent no-op (dropping into same group). If the app already exists
    // in the target group, show a warning and abort. This keeps the error
    // localized to the group the user attempted to drop into.
    if (dragSourceGroup.current === targetGroupName) {
      try {
        const tg = groups.find(g => g.name === targetGroupName)
        const present = tg && Array.isArray(tg.game_ids) && tg.game_ids.includes(itemId)
        if (present) {
          try { triggerToast(`App already exists in "${targetGroupName}"`, 'warning') } catch (e) { }
        }
      } catch (e) { }
      handleDragEnd()
      return
    }

    // Optimistically update local `groups` so the moved app appears in the
    // target group immediately for snappy UX. Do NOT remove it from the
    // source group because an app may belong to multiple groups. We'll
    // revert on failure.
    const previousGroups = Array.isArray(groups) ? groups.map(g => ({ ...g, game_ids: Array.isArray(g.game_ids) ? [...g.game_ids] : [] })) : []
    try {
      // If the app already exists in the target group, abort and show a
      // warning localized to that group.
      const alreadyInTarget = (() => {
        try {
          const tg = groups.find(g => g.name === targetGroupName)
          return tg && Array.isArray(tg.game_ids) && tg.game_ids.includes(itemId)
        } catch (e) { return false }
      })()
      if (alreadyInTarget) {
        try { triggerToast(`App already exists in "${targetGroupName}"`, 'warning') } catch (e) { }
        // cleanup and stop
        handleDragEnd()
        setLoading(false)
        return
      }

      // Activate the target group now that we've confirmed this is a
      // real move (not a duplicate). This opens the group while the
      // network move completes so the UI feels responsive.
      try { setActiveGroup(targetGroupName) } catch (e) { }

      // Perform optimistic local mutation: only add to target group
      const newGroups = (previousGroups || []).map(g => {
        if (g.name === targetGroupName) {
          const existing = Array.isArray(g.game_ids) ? g.game_ids : []
          if (!existing.includes(itemId)) {
            return { ...g, game_ids: [...existing, itemId] }
          }
        }
        return g
      })
      setGroups(newGroups)

      // Update visible filtered list for the active (target) group immediately
      try {
        const tg = newGroups.find(g => g.name === targetGroupName)
        if (tg) {
          const shown = comparisonList.filter(comp => (tg.game_ids || []).includes(comp.game_details.item_id))
          setFilteredGames(shown)
          setGamesInTags(shown)
        }
      } catch (err) {
        console.warn('Error updating filtered games optimistically', err)
      }

      setLoading(true)
      // Do not mark moveToastSuppress; allow the server-confirmation toast
      // from `createNewGameTag` to display. We removed the optimistic toast
      // so only the canonical success message should appear.
      // Track this optimistic move so subsequent tag fetches re-apply it
      try {
        pendingMovesRef.current = pendingMovesRef.current || {}
        pendingMovesRef.current[itemId] = targetGroupName
        // Clear any existing timer and set a stale-clear timer (15s)
        try { if (pendingMoveTimersRef.current[itemId]) clearTimeout(pendingMoveTimersRef.current[itemId]) } catch (e) { }
        pendingMoveTimersRef.current[itemId] = setTimeout(() => {
          try { delete pendingMovesRef.current[itemId]; delete pendingMoveTimersRef.current[itemId] } catch (e) { }
        }, 15000)
      } catch (err) { }

      // Do not show an optimistic toast here to avoid duplicating the
      // server-confirmation toast from `createNewGameTag`. The server-side
      // call (which may be suppressed via `moveToastSuppress`) will show the
      // canonical success message when appropriate.

      // Server-side operations: add to target (do not remove from source;
      // apps are allowed to be in multiple groups). Show the server
      // confirmation toast (suppress only the internal sync since we'll
      // reconcile explicitly below).
      await createNewGameTag(itemId, targetGroupName, false, true)

      // Reconcile canonical data after successful move. Merge server result
      // with our optimistic `newGroups` to avoid flicker if server is slow.
      await getGameTags({ mergeLocal: true, localGroups: newGroups })
      await callAppTrackapi()
      setGamesInTagCall()
    } catch (err) {
      console.error('Error moving app between groups:', err)
      try { triggerToast('Could not move app. Try again.', 'error') } catch (e) { }
      // Revert optimistic update
      try { setGroups(previousGroups) } catch (e) { }
      // Clear any pending move for this item
      try { delete pendingMovesRef.current[itemId]; if (pendingMoveTimersRef.current[itemId]) { clearTimeout(pendingMoveTimersRef.current[itemId]); delete pendingMoveTimersRef.current[itemId] } } catch (e) { }
      try {
        const prevActive = previousGroups.find(g => g.name === targetGroupName)
        const shown = prevActive ? comparisonList.filter(comp => (prevActive.game_ids || []).includes(comp.game_details.item_id)) : []
        setFilteredGames(shown)
        setGamesInTags(shown)
      } catch (e) { }
    } finally {
      setLoading(false)
      // clear suppression flag and cleanup refs used for cross-group moves
      try { moveToastSuppress.current.delete(itemId) } catch (err) { }
      // cleanup drag refs
      handleDragEnd()
      // If reconciliation succeeded (groups state contains the item in target), clear pending move
      try {
        const tg = (Array.isArray(groups) ? groups.find(g => g.name === targetGroupName) : null)
        const present = tg && Array.isArray(tg.game_ids) && tg.game_ids.includes(itemId)
        if (present) {
          delete pendingMovesRef.current[itemId]
          if (pendingMoveTimersRef.current[itemId]) { clearTimeout(pendingMoveTimersRef.current[itemId]); delete pendingMoveTimersRef.current[itemId] }
        }
      } catch (e) { }
    }
  }

  function toggle1(tab) {
    confirmDiscardThen(() => {
      if (activeTab1 !== tab) {
        setactiveTab1(tab)
      }
    })
  }
  function convertEpochToDate(epochTime) {
    const date = new Date(epochTime * 1000) // Multiply by 1000 to convert from seconds to milliseconds

    const day = String(date.getDate()).padStart(2, "0") // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0") // Get month (0-based, so add 1)
    const year = date.getFullYear().toString().slice(-4) // Get last 2 digits of the year
    const hours = String(date.getHours()).padStart(2, "0") // Get hours
    const minutes = String(date.getMinutes()).padStart(2, "0") // Get minutes

    // Format the date as dd-mm-yy hh:mm
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`

    return formattedDate
  }

  const addButtonStyle = {
    width: "84px",
    padding: "8px 16px",
    borderRadius: "6px",
    background: isHovered ? "#e11d4c" : "#F6255A", // lighter on hover
    color: "#FFFFFF",
    border: "none",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background 0.2s ease-in-out",
  }

  // Style for the inline Show More / Show Less tile so it visually matches the
  // full-covered pink Add button tile used elsewhere.
  const showTileStyle = {
    background: isHovered ? '#e11d4c' : '#F6255A',
    color: '#FFFFFF',
    borderRadius: 10,
    padding: '10px 14px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: '1px solid rgba(255,255,255,0.06)',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    boxShadow: '0 6px 20px rgba(246,37,90,0.12)',
    transition: 'transform 0.14s ease, box-shadow 0.14s ease, background 0.14s ease',
    transform: 'translateY(0px)',
  }

  const handleCheckboxChange = app => {
    setSelectedBox(prevSelected =>
      prevSelected.includes(app)
        ? prevSelected.filter(item => item !== app)
        : [...prevSelected, app]
    )
  }

  useEffect(() => {
    // Modal-related automatic refresh removed to avoid unnecessary API calls.
    // API reconciliation will occur in mutation handlers (create/delete/track/untrack)
    // so we don't trigger an extra fetch when the modal toggles.
  }, [modal_toggle])

  const getGameTags = async (options = {}) => {
    // Prevent overlapping fetches for the same resource
    if (isFetchingTagsRef.current) {
      return
    }
    isFetchingTagsRef.current = true
    try {
      const res = await axios.get(`${api}/tracker/tags.keywords?tag_type=APP_TRACKING`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }
      const serverGroups = res.data.data || []
      // If caller requested a merge with local optimistic groups, perform union
      if (options && options.mergeLocal && Array.isArray(options.localGroups)) {
        try {
          const local = options.localGroups
          const merged = serverGroups.map(sg => {
            const lg = local.find(l => l.name === sg.name)
            if (!lg) return sg
            const serverIds = Array.isArray(sg.game_ids) ? sg.game_ids : []
            const localIds = Array.isArray(lg.game_ids) ? lg.game_ids : []
            const union = Array.from(new Set([...serverIds, ...localIds]))
            return { ...sg, game_ids: union }
          })
          // also include any local-only groups
          local.forEach(lg => {
            if (!merged.find(m => m.name === lg.name)) merged.push(lg)
          })
          setGroups(merged)
          try { setLocalItem('appTrackingGroups', merged) } catch (err) { }
        } catch (e) {
          console.warn('Error merging local groups with server response', e)
          setGroups(serverGroups)
          try { setLocalItem('appTrackingGroups', serverGroups) } catch (err) { }
        }
        // After we set groups, ensure any pending optimistic moves are re-applied
        try {
          const pending = pendingMovesRef.current || {}
          let mutated = false
          const ensure = (sgs) => {
            const byName = {}
            sgs.forEach(s => { byName[s.name] = s })
            Object.keys(pending).forEach(itemId => {
              const target = pending[itemId]
              // If server already reported the item in any group, clear pending
              const foundOnServer = sgs.some(sg => Array.isArray(sg.game_ids) && sg.game_ids.includes(itemId))
              if (foundOnServer) {
                // clear pending move and its timer
                try { delete pendingMovesRef.current[itemId] } catch (e) { }
                try { if (pendingMoveTimersRef.current[itemId]) { clearTimeout(pendingMoveTimersRef.current[itemId]); delete pendingMoveTimersRef.current[itemId] } } catch (e) { }
                return
              }
              // Otherwise ensure target group contains the id (optimistic re-apply)
              if (target && byName[target]) {
                const ids = Array.isArray(byName[target].game_ids) ? byName[target].game_ids : []
                if (!ids.includes(itemId)) {
                  byName[target].game_ids = [...ids, itemId]
                  mutated = true
                }
              } else if (target) {
                // target group not present in server response; add a local-only group
                sgs.push({ name: target, game_ids: [itemId], tag_type: 'APP_TRACKING' })
                mutated = true
              }
            })
            return Object.values(byName)
          }
          if (mutated) {
            const reapplied = ensure(serverGroups)
            setGroups(reapplied)
            try { setLocalItem('appTrackingGroups', reapplied) } catch (err) { }
          }
        } catch (e) {
          console.warn('Error re-applying pending optimistic moves', e)
        }
      } else {
        // If there are pending optimistic moves, re-apply them onto the
        // serverGroups so moved items don't vanish while backend lags.
        try {
          const pending = pendingMovesRef.current || {}
          let mutated = false
          const byName = {}
          serverGroups.forEach(s => { byName[s.name] = { ...s, game_ids: Array.isArray(s.game_ids) ? [...s.game_ids] : [] } })
          Object.keys(pending).forEach(itemId => {
            const target = pending[itemId]
            const foundOnServer = serverGroups.some(sg => Array.isArray(sg.game_ids) && sg.game_ids.includes(itemId))
            if (foundOnServer) {
              try { delete pendingMovesRef.current[itemId] } catch (e) { }
              try { if (pendingMoveTimersRef.current[itemId]) { clearTimeout(pendingMoveTimersRef.current[itemId]); delete pendingMoveTimersRef.current[itemId] } } catch (e) { }
              return
            }
            if (target && byName[target]) {
              if (!byName[target].game_ids.includes(itemId)) {
                byName[target].game_ids.push(itemId)
                mutated = true
              }
            } else if (target) {
              // create a local-only group
              byName[target] = { name: target, game_ids: [itemId], tag_type: 'APP_TRACKING' }
              mutated = true
            }
          })
          const finalGroups = mutated ? Object.values(byName) : serverGroups
          setGroups(finalGroups)
          try { setLocalItem('appTrackingGroups', finalGroups) } catch (err) { }
        } catch (e) {
          console.warn('Error re-applying pending optimistic moves (no-merge branch)', e)
          setGroups(serverGroups)
          try { setLocalItem('appTrackingGroups', serverGroups) } catch (err) { }
        }
      }
    } catch (error) {
      console.error("Error fetching game tags:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
    } finally {
      isFetchingTagsRef.current = false
    }
  }

  // Helper to prompt user to discard unsaved create-group input before navigating/changing tabs
  const confirmDiscardThen = (action) => {
    try {
      if (createTagDirty) {
        // open modal and store pending action
        discardActionRef.current = action
        setShowDiscardModal(true)
        return
      }
    } catch (err) {
      // fallback: if something goes wrong, proceed with action
    }
    try { action && action() } catch (e) { }
  }

  const handleDiscardConfirm = () => {
    try { setCreateTag(''); setCreateTagDirty(false) } catch (e) { }
    try { const toggle = document.getElementById('createGroup-abcz082458wer'); if (toggle) toggle.click() } catch (e) { }
    setShowDiscardModal(false)
    const action = discardActionRef.current
    discardActionRef.current = null
    try { action && action() } catch (e) { }
  }

  const handleDiscardCancel = () => {
    setShowDiscardModal(false)
    discardActionRef.current = null
  }

  const createGroup = async tagName => {
    if (!tagName) return
    setCreateGroupLoading(true)
    setLoading(true)
    try {
      const payload = { tag_name: tagName, tag_type: "APP_TRACKING" }
      const res = await axios.post(`${api}/tracker/tags.keywords/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }

      // Refresh groups from server so UI shows the new group
      await getGameTags()
      try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_GROUP_CREATED, { group_name: tagName }) } catch (e) { }
      // Notify user that the group was created
      try { triggerToast(`${tagName} is created`, 'success') } catch (e) { }
      // Clear the input and close the dropdown (best-effort)
      try { setCreateTag(""); setCreateTagDirty(false) } catch (e) { }
      try { const toggle = document.getElementById('createGroup-abcz082458wer'); if (toggle) toggle.click() } catch (e) { }
    } catch (error) {
      console.error("Error creating group:", error)
      // If the API returned a 400 with the specific detail message, show
      // a toast only (no modal). For other errors, keep the existing
      // modal behavior so users can retry or see details.
      try {
        const status = error && error.response && error.response.status
        const detail = error && error.response && error.response.data && error.response.data.detail
        if (status === 400 && detail === "Failed to add game to tag.") {
          try {
            toastr.error("Unable to create the group due to duplicate issues or a technical problem")
          } catch (e) { }
          // Close the create-group dropdown/modal and clear input immediately
          try {
            try { setCreateTag(""); setCreateTagDirty(false) } catch (e) { }
            const toggle = document.getElementById('createGroup-abcz082458wer')
            if (toggle) try { toggle.click() } catch (e) { }
          } catch (e) { }
        } else {
          try { setCreateErrorMsg((error && (error.response && error.response.data && error.response.data.detail)) || (error && error.message) || 'Could not create group. Please try again.') } catch (e) { }
          try { setShowCreateErrorModal(true) } catch (e) { }
        }
      } catch (e) {
        try { setCreateErrorMsg((error && error.message) || 'Could not create group. Please try again.') } catch (er) { }
        try { setShowCreateErrorModal(true) } catch (er) { }
      }
    } finally {
      setCreateGroupLoading(false)
      setLoading(false)
    }
  }

  const createNewGameTag = async (itemID, tagName) => {
    // added optional suppressToast via third arg if callers want to avoid duplicate toasts
    const Data = { item_id: itemID, tag_name: tagName, tag_type: "APP_TRACKING" }
    // Support suppression of toast via optional 3rd parameter
    const suppressToast = arguments.length >= 3 ? arguments[2] : false
    // optional 4th arg: suppressSync - when true, do not call getGameTags/callAppTrackapi
    const suppressSync = arguments.length >= 4 ? arguments[3] : false
    if (tagName != "all") {
      // Safety: only attempt to add an item to a tag if the app is currently
      // tracked (present in `comparisonList`). This prevents cases where a
      // failed tracking request would otherwise still attempt to add the
      // app to a tag.
      try {
        let isTrackedNow = Array.isArray(comparisonList) && comparisonList.some(c => c && c.game_details && c.game_details.item_id === itemID)
        if (!isTrackedNow) {
          // Fallback: check session/local storage copy which may have been
          // updated synchronously earlier in the flow (avoids race with state updates).
          try {
            const sess = getSessionItem('comparisonBetween') || getLocalItem('comparisonBetween')
            if (Array.isArray(sess) && sess.some(c => c && ((c.game_details && c.game_details.item_id) || c.item_id) === itemID)) {
              isTrackedNow = true
            }
          } catch (e) {
            // ignore
          }
        }

        if (!isTrackedNow) {
          console.warn(`createNewGameTag: item ${itemID} not tracked — skipping add to tag ${tagName}`)
          return null
        }
      } catch (err) {
        // If something goes wrong checking tracked state, proceed conservatively
        // and do not attempt the add to avoid inconsistent server state.
        console.warn('createNewGameTag: error checking tracked state, skipping add', err)
        return null
      }
      try {
        const res = await axios.post(`${api}/tracker/tags.keywords/`, Data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })

        if (isUpgradeResponse(res.data)) {
          setShowUpgradeModal(true)
          return res
        }

        // Optimistically update local `groups` state so the UI reflects
        // the addition immediately without waiting for a full refetch.
        try {
          setGroups(prev => {
            if (!Array.isArray(prev)) return prev
            return prev.map(g => {
              if (g.name !== tagName) return g
              const existing = Array.isArray(g.game_ids) ? g.game_ids : []
              if (existing.includes(itemID)) return g
              return { ...g, game_ids: [...existing, itemID] }
            })
          })
          try { setLocalItem('appTrackingGroups', Array.isArray(groups) ? groups : getLocalItem('appTrackingGroups')) } catch (err) { }
          // update derived UI lists
          try { setGamesInTagCall() } catch (err) { }
        } catch (err) {
          console.warn('Could not apply optimistic add to local state', err)
        }

        // Refresh groups after creating new tag (keeps local state authoritative)
        if (!suppressSync) {
          await getGameTags()
          // Reconcile canonical tracked-app list so other browsers/devices pick up the change
          try { await callAppTrackapi() } catch (e) { }
        }
        // If callers didn't request suppression, only show the "Added" toast
        // when this action wasn't part of a drag-move operation. A short-lived
        // entry in `moveToastSuppress` is set by the drag handler to avoid
        // causing both "Added" and "Moved" to appear.
        const isMoveSuppressed = (moveToastSuppress && moveToastSuppress.current && moveToastSuppress.current.get(itemID) === tagName)
        if (!suppressToast && !isMoveSuppressed) {
          try { triggerToast('Added app to "' + tagName + '"', 'success') } catch (err) { }
        }
        return res
      } catch (error) {
        console.error("Error sending data:", error)
        if (isUpgradeError(error)) {
          openUpgradeModal()
        }
        throw error
      }
    }
    return null
  }

  const deleteGamefromTag = async (item, tagname) => {
    setLoading(true)
    try {
      const payload = { item_id: item, tag_name: tagname, tag_type: "APP_TRACKING" }
      const res = await axios.patch(
        `${api}/tracker/tags.keywords/${tagname}/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }
      // Optimistically update local `groups` state so the UI removes the
      // item immediately from the tag view without waiting for a refetch.
      try {
        setGroups(prev => {
          if (!Array.isArray(prev)) return prev
          return prev.map(g => {
            if (g.name !== tagname) return g
            const existing = Array.isArray(g.game_ids) ? g.game_ids : []
            return { ...g, game_ids: existing.filter(id => id !== item) }
          })
        })
        try { setLocalItem('appTrackingGroups', Array.isArray(groups) ? groups : getLocalItem('appTrackingGroups')) } catch (err) { }
        try { setGamesInTagCall() } catch (err) { }
      } catch (err) {
        console.warn('Could not apply optimistic delete to local state', err)
      }

      // Reconcile canonical tracked-app list so other browsers/devices pick up the change
      try { await callAppTrackapi() } catch (e) { }

      return res
    } catch (error) {
      console.error("Error deleting data:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteCallforTags = async (item, tag) => {
    try {
      await deleteGamefromTag(item, tag)
      setGamesInTagCall()
    } finally {
      setLoading(false)
    }
  }

  // Handler passed to KeywordTrackingDetailsModal to remove an item from any groups it belongs to.
  // Remove an item from a specific tag or from all tags if tagName is omitted
  const handleModalRemoveFromTag = async (itemId, tagName = null) => {
    if (!itemId) return
    setLoading(true)
    try {
      if (tagName) {
        // Remove from a specific tag
        await deleteGamefromTag(itemId, tagName)
        try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_REMOVED_FROM_GROUP, { app_id: itemId, group_name: tagName }) } catch (e) { }
      } else {
        // If the caller did not provide a tagName but the user currently has
        // an `activeGroup` selected in the UI, treat this as "remove from
        // that group" (do NOT untrack the app). Otherwise, perform a full
        // untrack (removeApp) as before.
        if (activeGroup) {
          await deleteGamefromTag(itemId, activeGroup)
          try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_REMOVED_FROM_GROUP, { app_id: itemId, group_name: activeGroup }) } catch (e) { }
        } else {
          // When tagName is omitted (null) and no active group is selected
          // we should untrack the app entirely. Use the existing removeApp
          // function which calls the DELETE endpoint
          // `/tracker/tracking/app.remove` with the expected payload.
          await removeApp(itemId)
          // Close the keyword/search modal after successful untrack so the user
          // returns to the page view (requested behavior).
          try {
            setCreateTag("")
          } catch (err) { }
          try {
            setShowKeywordModal(false)
          } catch (err) { }
        }
      }

      // Refresh tags and UI
      await getGameTags()
      setGamesInTagCall()
    } catch (err) {
      console.error('Error removing item from tags via modal:', err)
    } finally {
      setLoading(false)
    }
  }

  // Handler to bulk-add multiple items to a tag (used by modal)
  const handleBulkAddToTag = async (itemIds, tagName) => {
    if (!Array.isArray(itemIds) || itemIds.length === 0 || !tagName) return
    setLoading(true)
    try {
      // Call createNewGameTag for each item (API expects single item_id per request)
      await Promise.all(itemIds.map(id => createNewGameTag(id, tagName, false, true)))
      try { itemIds.forEach(id => trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_ADDED_TO_GROUP, { app_id: id, group_name: tagName })) } catch (e) { }
      // Refresh tags and tracked list
      await getGameTags()
      await callAppTrackapi()
      setGamesInTagCall()
    } catch (err) {
      console.error('bulk add to tag failed:', err)
    } finally {
      setLoading(false)
    }
  }

  // Handler to add/move a single item to a tag (used by modal per-item dropdown)
  const handleAddSingleToTag = async (itemId, tagName) => {
    if (!itemId || !tagName) return
    setLoading(true)
    try {
      const res = await createNewGameTag(itemId, tagName, false, true)
      // If the create call triggered an upgrade response, do not close modal
      if (res && isUpgradeResponse(res.data)) {
        return
      }

      try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_ADDED_TO_GROUP, { app_id: itemId, group_name: tagName }) } catch (e) { }

      // Refresh tags and tracked list
      await getGameTags()
      await callAppTrackapi()
      setGamesInTagCall()

      // Close the keyword modal after successful add
      try { setShowKeywordModal(false) } catch (err) { }
    } catch (err) {
      console.error('add single to tag failed:', err)
    } finally {
      setLoading(false)
    }
  }

  const deleteTag = async tagName => {
    try {
      const res = await axios.delete(
        `${api}/tracker/tags.keywords/${tagName}/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (isUpgradeResponse(res.data)) {
        openUpgradeModal()
        return
      }
    } catch (error) {
      console.error("Error deleting data:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
    }
  }

  const deleteTagFunction = tagName => {
    deleteTag(tagName)
    setGamesInTagCall()
  }
  // const handleAddNewGameTag = () => {
  //   const newName = prompt("Enter name for the new game:")
  //   if (newName && newName.trim() !== "" && newName != "all") {
  //     const newGame = {
  //       name: newName.trim(),
  //       game_ids: [],
  //     }
  //     setGameList(prev => [...prev, newGame])
  //     setActiveGameTab(newGame.name) // Activate the new tab
  //   } else {
  //     setActiveGameTab("all")
  //   }
  // }

  const handleAddNewGameTag2 = newName => {
    toggleGameTab("new")
    if (newName && newName.trim() !== "" && newName != "all") {
      const newGame = {
        name: newName.trim(),
        game_ids: [],
      }
      setGameList(prev => [...prev, newGame])
      setActiveGameTab(newGame.name) // Activate the new tab
    } else {
      setActiveGameTab("all")
    }
  }

  const setGamesInTagCall = () => {
    getGameTags()
    const gameListItem = gameList.find(g => g.name === activeGameTab)
    const games = gameListItem
      ? comparisonList.filter(comp =>
        gameListItem.game_ids.includes(comp.game_details.item_id)
      ) // 2. Filter by matching IDs
      : []
    setGamesInTags(games)
  }

  const addExistingGameToTag = itemId => {
    createNewGameTag(itemId, activeGameTab, false, true)
    setGamesInTagCall()
  }

  useEffect(() => {
    const gameListItem = gameList.find(g => g.name === activeGameTab)
    const games = gameListItem
      ? comparisonList.filter(comp =>
        gameListItem.game_ids.includes(comp.game_details.item_id)
      ) // 2. Filter by matching IDs
      : []
    setGamesInTags(games)
  }, [gameList])

  const handleTagChange = event => {
    const selectedTag = event.target.value
    if (activeGameTab !== selectedTag) setActiveGameTab(selectedTag)
    const gameListItem = gameList.find(g => g.name === selectedTag)
    const games = gameListItem
      ? comparisonList.filter(comp =>
        gameListItem.game_ids.includes(comp.game_details.item_id)
      ) // 2. Filter by matching IDs
      : []
    setGamesInTags(games)
  }
  const handleRemoveGroup = async groupName => {
    try {
      const response = await fetch(
        `${api}/tracker/tags.keywords/${groupName}/?tag_type=APP_TRACKING`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to delete group: ${response.statusText}`)
      }

      // Update UI only if API call succeeded
      setGroups(prevGroups => prevGroups.filter(g => g.name !== groupName))

      if (activeGroup === groupName) {
        setActiveGroup(null)
        setFilteredGames(trackedGames) // Reset if active group was deleted
      }

      try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_GROUP_DELETED, { group_name: groupName }) } catch (e) { }
      try { triggerToast(`${groupName} is deleted`, 'success') } catch (e) { }
    } catch (error) {
      console.error("Error deleting group:", error)
      try { triggerToast("Could not delete the group. Please try again.", 'error') } catch (e) { }
    }
  }

  // Compute a small derived list that applies the new platform filter (All/Apps/Games)
  const trackedIds = comparisonList.map(g => g.game_details.item_id)
  const displayedGames = useMemo(() => {
    const list = (filteredGames || [])
    return list.filter(game => {
      if (!platformFilter || platformFilter === "all") return true

      // Prefer authoritative category from API when available.
      // Normalize to lowercase and check for substrings like 'game' or 'app'.
      const rawCat = (game?.game_details?.category || "")
      const cat = String(rawCat).toLowerCase()

      // Determine type from category when present
      const catIsGame = cat.includes("game") || cat.includes("games")
      const catIsApp = cat.includes("app") || cat.includes("apps")

      // Fallback heuristic: treat items with game_modes as games
      const heuristicIsGame = Array.isArray(game.game_details.game_modes) && game.game_details.game_modes.length > 0

      const isGame = cat ? catIsGame : heuristicIsGame
      const isApp = cat ? catIsApp : !heuristicIsGame

      if (platformFilter === "games") return isGame
      if (platformFilter === "apps") return isApp
      return true
    }).filter(game => {
      if (!selectedPlatform || selectedPlatform === "all") return true
      return normalizePlatformName(game?.game_details?.platform) === selectedPlatform
    })
  }, [filteredGames, platformFilter, selectedPlatform, normalizePlatformName])

  // Reset pagination when the underlying list or filters change
  useEffect(() => {
    setVisibleCount(10)
  }, [filteredGames, platformFilter, selectedPlatform, activeGroup, comparisonList])

  return (
    <div>
      <SEO
        title={PAGE_SEO.appTracking.title}
        description={PAGE_SEO.appTracking.description}
        keywords={PAGE_SEO.appTracking.keywords}
        canonical={generateCanonicalUrl('/app-tracking')}
        robots={PAGE_SEO.appTracking.robots}
        structuredData={[STRUCTURED_DATA.organization, STRUCTURED_DATA.website]}
      />
      <div
        className="container-fluid"
        style={{ maxWidth: "100vw", padding: 32, position: 'relative' }}
      >
        <div className="app_tracking_sec">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="mb-3 d-flex align-items-center justify-content-between">
                <span
                  style={{
                    fontFamily: "Rubik",
                    fontWeight: 600,
                    fontSize: "32px",
                    color: "#fff",
                  }}
                >
                  App and Game Tracking
                </span>
              </h3>
              <div className="keyword_subhead">
                Track and manage all your apps and games in one place. Monitor
                weekly metrics, compare performance across tracked titles, and
                unlock the power of graphical analytics, AI-generated insights,
                and custom KeyQuest data reports.
              </div>
            </div>
          </div>

          <div className="apps_track_sec key_track_sec">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <h6 style={{ marginBottom: '8px' }}>Track Apps and Games from Meta and Steam</h6>

              {/* CTAs side by side next to section title */}
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <button
                  type="button"
                  onClick={openAnalyticsForDefault}
                  className="btn btn-sm"
                  style={{
                    background: '#F6255A',
                    color: '#fff',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: 6,
                    whiteSpace: 'nowrap',
                    fontSize: '13px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#E01E4F';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(246, 37, 90, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#F6255A';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                  aria-label="Open analytics for default app"
                >
                  Analytics
                </button>

                <button
                  type="button"
                  onClick={openAiReportsForDefault}
                  className="btn btn-sm"
                  style={{
                    background: '#F6255A',
                    color: '#fff',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: 6,
                    whiteSpace: 'nowrap',
                    fontSize: '13px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#E01E4F';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(246, 37, 90, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#F6255A';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                  aria-label="Open AI reports for default app"
                >
                  AI reports
                </button>

                <button
                  type="button"
                  onClick={openKeywordTrackingForDefault}
                  className="btn btn-sm"
                  style={{
                    background: '#F6255A',
                    color: '#fff',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: 6,
                    whiteSpace: 'nowrap',
                    fontSize: '13px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#E01E4F';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(246, 37, 90, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#F6255A';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                  aria-label="Go to keyword tracking for default app"
                >
                  Looking for keyword tracking?
                </button>
              </div>
            </div>
            <div className="apps_perfrom_sec">
              <div className="mt-5">
                <Tabs defaultActiveKey="home" id="my-tabs" className="mb-3" onSelect={(tab) => {
                  try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_COMPARISON_TAB_CHANGED, { tab }) } catch (e) { }
                }}>
                  <Tab eventKey="home" title="Feature">
                    {/* Feature Description for Feature Tab */}
                    <div style={{ marginBottom: '20px', paddingTop: '12px' }}>
                      <p style={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: 0,
                        maxWidth: '600px'
                      }}>
                        Track and compare all major features of your tracked apps and games in one place.<br />
                        Updated daily with the latest KeyQuest data and platform changes.
                      </p>
                    </div>

                    <div className="apps_table_main">
                      {/* Export Options for Feature Tab */}
                      {comparisonList.length > 0 && (
                        <div onClick={e => e.stopPropagation()} role="presentation" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <div>
                            {(lastFeatureUpdated || lastUpdated) && (
                              <small className="text-muted" style={{ cursor: 'default', userSelect: 'none', pointerEvents: 'none' }}>
                                Updated on: {(lastFeatureUpdated || lastUpdated).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })}, {(lastFeatureUpdated || lastUpdated).toLocaleTimeString('en-US', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                })} (UTC+5:30)
                              </small>
                            )}
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span
                              style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '13px',
                                marginRight: '8px',
                                cursor: 'default',
                                userSelect: 'none',
                                pointerEvents: 'none'
                              }}
                              aria-hidden="true"
                            >
                              Export:
                            </span>

                            <button
                              onClick={() => exportFeatureData('csv')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as CSV"
                            >
                              CSV
                            </button>

                            <button
                              onClick={() => exportFeatureData('xlsx')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as Excel"
                            >
                              XLSX
                            </button>

                            <button
                              onClick={() => exportFeatureData('pdf')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as PDF"
                            >
                              PDF
                            </button>
                          </div>
                        </div>
                      )}

                      {comparisonList.length > 0 ? (
                        <div style={{ overflowX: 'auto' }}>
                          <Table bordered hover onClick={e => e.stopPropagation()}>
                            <thead>
                              <tr>
                                <th>
                                  <div className="backbg">
                                    <svg
                                      width="12"
                                      height="13"
                                      viewBox="0 0 12 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.666667 0.5C0.489856 0.5 0.320286 0.570238 0.195262 0.695262C0.0702379 0.820286 0 0.989856 0 1.16667V5.16667C0 5.34348 0.0702379 5.51305 0.195262 5.63807C0.320286 5.7631 0.489856 5.83333 0.666667 5.83333H4.66667C4.84348 5.83333 5.01305 5.7631 5.13807 5.63807C5.2631 5.51305 5.33333 5.34348 5.33333 5.16667V1.16667C5.33333 0.989856 5.2631 0.820286 5.13807 0.695262C5.01305 0.570238 4.84348 0.5 4.66667 0.5H0.666667ZM0.666667 7.16667C0.489856 7.16667 0.320286 7.23691 0.195262 7.36193C0.0702379 7.48695 0 7.65652 0 7.83333V11.8333C0 12.0101 0.0702379 12.1797 0.195262 12.3047C0.320286 12.4298 0.489856 12.5 0.666667 12.5H4.66667C4.84348 12.5 5.01305 12.4298 5.13807 12.3047C5.2631 12.1797 5.33333 12.0101 5.33333 11.8333V7.83333C5.33333 7.65652 5.2631 7.48695 5.13807 7.36193C5.01305 7.23691 4.84348 7.16667 4.66667 7.16667H0.666667ZM7.33333 7.16667C7.15652 7.16667 6.98695 7.23691 6.86193 7.36193C6.73691 7.48695 6.66667 7.65652 6.66667 7.83333V11.8333C6.66667 12.0101 6.73691 12.1797 6.86193 12.3047C6.98695 12.4298 7.15652 12.5 7.33333 12.5H11.3333C11.5101 12.5 11.6797 12.4298 11.8047 12.3047C11.9298 12.1797 12 12.0101 12 11.8333V7.83333C12 7.65652 11.9298 7.48695 11.8047 7.36193C11.6797 7.23691 11.5101 7.16667 11.3333 7.16667H7.33333ZM8.66667 5.83333V3.83333H6.66667V2.5H8.66667V0.5H10V2.5H12V3.83333H10V5.83333H8.66667Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Feature
                                  </div>
                                </th>
                                {comparisonList.map(game => (
                                  <th key={game.game_details.item_id}>
                                    <div className="keysec1" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <img
                                        src={
                                          (game.game_details && (game.game_details.image_url || game.game_details.image)) ||
                                          game.image_url ||
                                          'https://via.placeholder.com/32'
                                        }
                                        alt={game.game_details?.name || 'app'}
                                        style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6 }}
                                      />
                                      <span
                                        style={{
                                          verticalAlign: 'middle',
                                          fontSize: '13px',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: 'inline-block',
                                          maxWidth: 160,
                                        }}
                                        title={game.game_details?.name}
                                      >
                                        {game.game_details.name}
                                      </span>
                                    </div>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="12"
                                      height="10"
                                      viewBox="0 0 12 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0 0.166992H12V1.50033H0V0.166992ZM0 4.16699H12V5.50033H0V4.16699ZM0 8.16699H12V9.50033H0V8.16699Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Category
                                  </div>
                                </td>

                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {game.game_details.category || "N/A"}
                                  </td>
                                ))}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M10.9594 0.821955C9.89688 0.999615 9.05692 1.15493 9.05892 1.17335C9.06284 1.20986 11.4901 4.15664 11.5183 4.15918C11.528 4.16004 11.6428 3.87483 11.7734 3.52532C11.904 3.17581 12.0264 2.88988 12.0455 2.88988C12.1932 2.88988 13.1909 3.82 13.5502 4.29281C15.2101 6.4767 15.4762 9.33261 14.242 11.7187C13.6557 12.8523 12.7043 13.8637 11.6031 14.5243C10.1139 15.4177 8.27759 15.7248 6.55561 15.3687C4.35317 14.9131 2.44884 13.3597 1.55557 11.2899C0.624329 9.13204 0.852052 6.6367 2.1572 4.69811L2.38436 4.36068L2.1228 4.04335C1.9789 3.86883 1.83604 3.6941 1.80529 3.65505C1.77458 3.61603 1.74307 3.59128 1.73533 3.60009C1.72758 3.6089 1.63913 3.72751 1.53878 3.86368C0.766992 4.91079 0.264578 6.13379 0.060554 7.46179C-0.0201847 7.98741 -0.0201847 9.11484 0.060554 9.64046C0.331323 11.4031 1.12169 12.9617 2.36442 14.1835C3.96101 15.7533 6.00896 16.5635 8.20994 16.4961C8.89777 16.475 9.32177 16.4176 9.95502 16.2599C11.8671 15.7837 13.5531 14.5846 14.6908 12.892C14.8128 12.7104 15.0311 12.3258 15.1758 12.0372C15.974 10.446 16.1974 8.67696 15.8244 6.90061C15.5864 5.76728 14.9827 4.50272 14.2404 3.58309C13.8002 3.0377 13.1895 2.46523 12.5892 2.03541C12.4933 1.96668 12.4147 1.89165 12.4147 1.86864C12.4147 1.83662 12.7327 0.971127 12.8976 0.554407C12.9102 0.522618 12.9076 0.498191 12.892 0.500105C12.8763 0.502053 12.0067 0.646869 10.9594 0.821955ZM6.47302 0.73593C6.16934 0.797197 6.13693 0.810401 6.17599 0.856978C6.20012 0.88573 6.35993 1.07811 6.53118 1.28446L6.84257 1.65969L7.02339 1.63856C7.12285 1.62697 7.31511 1.60816 7.45059 1.59677C7.58611 1.58541 7.69271 1.56475 7.68752 1.55088C7.68237 1.53702 7.5166 1.33127 7.31923 1.09369C7.05005 0.769666 6.94202 0.662383 6.88711 0.66443C6.84683 0.665915 6.66049 0.6981 6.47302 0.73593ZM5.05216 1.15275C4.88763 1.22075 4.72754 1.29053 4.6965 1.3078C4.6478 1.33487 4.68137 1.3892 4.94001 1.70191C5.10501 1.90139 5.25332 2.07822 5.26958 2.09483C5.28736 2.11298 5.38256 2.09096 5.50807 2.03973C5.62298 1.99283 5.79553 1.92978 5.89149 1.8996C6.04841 1.85029 6.06184 1.83883 6.02445 1.78595C5.91433 1.63011 5.39715 1.02507 5.37571 1.02698C5.36232 1.02817 5.21673 1.08478 5.05216 1.15275ZM3.64184 1.8833L3.33777 2.08159L3.6448 2.45843C3.99581 2.88925 3.91135 2.87281 4.35416 2.59648C4.48214 2.51663 4.58515 2.42975 4.58309 2.40337C4.57797 2.33808 4.03453 1.68501 3.98531 1.68501C3.96367 1.68501 3.8091 1.77423 3.64184 1.8833ZM2.47786 2.7991L2.2043 3.05493L2.43163 3.32152C2.55667 3.46818 2.69894 3.63901 2.74777 3.70114L2.83658 3.81416L3.11849 3.5375L3.40036 3.26085L3.1011 2.90206C2.93653 2.70472 2.79051 2.54327 2.77665 2.54327C2.76276 2.54327 2.62834 2.65841 2.47786 2.7991ZM7.38477 3.20532C5.91253 3.37526 4.58445 4.14251 3.67398 5.34914C3.41359 5.69426 3.03014 6.42886 2.89548 6.84067C2.69644 7.44941 2.65885 7.71738 2.66025 8.51811C2.66138 9.1559 2.67171 9.306 2.73347 9.58048C3.22778 11.7776 4.92462 13.3971 7.12175 13.7688C7.48852 13.8309 7.62516 13.838 8.14347 13.822C8.55912 13.8092 8.83934 13.7829 9.06141 13.7359C10.9651 13.3325 12.4807 11.9892 13.0948 10.1609C13.4376 9.14029 13.4364 7.8932 13.0915 6.83836C13.0463 6.70011 12.9061 6.37905 12.7799 6.12487C11.7871 4.12542 9.61182 2.94827 7.38477 3.20532ZM4.5433 7.38751C4.50683 7.49193 4.35526 7.9264 4.20645 8.35306C3.84809 9.38054 3.84889 9.37908 3.63121 9.42454C3.54495 9.4426 3.5398 9.45385 3.5398 9.62458V9.80551H4.12149H4.70318V9.61174C4.70318 9.44913 4.69384 9.41804 4.64501 9.4182C4.37487 9.41926 4.3646 9.40404 4.45594 9.13781L4.50786 8.98649L4.82989 8.97349C5.00699 8.96632 5.16807 8.96557 5.18784 8.97174C5.20759 8.97794 5.24977 9.06503 5.28158 9.16524C5.35175 9.38631 5.32133 9.4424 5.13124 9.4424H5.00233V9.62455V9.8067L5.79177 9.79785L6.58121 9.789L6.59198 9.67717C6.61199 9.46917 6.57865 9.41087 6.44273 9.41596C6.23761 9.42361 6.25673 9.46752 5.7463 7.81665L5.55494 7.19771H5.08224H4.60958L4.5433 7.38751ZM7.6827 7.23388C7.04493 7.32681 6.63277 7.82645 6.63147 8.50824C6.63037 9.07783 6.86564 9.49317 7.30224 9.69238C7.48895 9.77758 7.54831 9.78808 7.84431 9.78834C8.13934 9.78861 8.19914 9.77824 8.37614 9.69605C8.57551 9.60345 8.57558 9.60345 8.62118 9.67145C8.65984 9.72912 8.70146 9.73949 8.89451 9.73949H9.1222L9.13144 9.26909L9.14065 8.7987L9.2653 8.78847C9.3954 8.77777 9.39826 8.77229 9.39826 8.53462C9.39826 8.50738 9.39639 8.46995 9.3941 8.4514C9.39138 8.42941 9.15644 8.42083 8.71685 8.42664L8.04375 8.43559V8.60064C8.04375 8.75975 8.04734 8.76605 8.14347 8.77599C8.19831 8.78167 8.2619 8.81048 8.28473 8.84006C8.3425 8.91483 8.33768 9.24648 8.27762 9.33165C8.156 9.50409 7.80675 9.42942 7.69224 9.20651C7.56354 8.95596 7.53379 8.31926 7.63314 7.94241C7.65202 7.87091 7.7188 7.76139 7.78155 7.69906C7.89001 7.59135 7.90487 7.58653 8.0832 7.60122C8.24691 7.61469 8.2848 7.63189 8.38123 7.73637C8.4512 7.81219 8.51212 7.92905 8.54739 8.05505L8.6031 8.25403H8.81371H9.02431V7.75888V7.26373H8.8271C8.65951 7.26373 8.62677 7.27356 8.60895 7.32935C8.58828 7.39402 8.58618 7.39408 8.46542 7.33338C8.25588 7.22804 7.97112 7.19183 7.6827 7.23388ZM9.6891 7.37926C9.6891 7.55091 9.69362 7.56082 9.7722 7.56082C9.88598 7.56082 9.89695 7.56296 9.96333 7.59825C10.0165 7.62647 10.0215 7.70444 10.0215 8.50082C10.0215 8.98022 10.0092 9.38004 9.99417 9.38925C9.97915 9.39846 9.90436 9.40969 9.82798 9.41414L9.6891 9.42229V9.61392V9.80551H11.0685H12.448V9.26084V8.71617H12.2365H12.0251L12.0055 8.88119C11.9769 9.12035 11.8717 9.3367 11.7641 9.3773C11.7151 9.39582 11.4974 9.41431 11.2803 9.41843L10.8857 9.42589L10.8857 9.02152L10.8857 8.61714H10.9984C11.1602 8.61714 11.2582 8.70951 11.2817 8.8842L11.3012 9.02977L11.4599 9.03987L11.6186 9.04994L11.6094 8.46256L11.6004 7.87514L11.4597 7.8654L11.319 7.85566L11.2972 7.99074C11.2671 8.17765 11.1944 8.25463 11.0267 8.27697L10.8857 8.29572V7.92393V7.5521L11.2493 7.57108C11.4849 7.58336 11.6493 7.60872 11.7161 7.64305C11.834 7.70359 11.9399 7.85844 11.9694 8.01352C11.9968 8.15734 12.0376 8.18276 12.2319 8.17669L12.3981 8.17151L12.4073 7.68461L12.4165 7.19771H11.0528H9.6891V7.37926ZM4.80821 7.99606C4.78791 8.07439 4.74207 8.23878 4.70637 8.36131L4.64139 8.58413H4.86801H5.09461L4.99579 8.24578C4.94141 8.0597 4.88526 7.89531 4.87104 7.88052C4.85678 7.86573 4.82852 7.91772 4.80821 7.99606Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Age Rating
                                  </div>
                                </td>

                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {game.game_details.age_rating || "N/A"}
                                  </td>
                                ))}
                              </tr>

                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.3333 3.16699C12.0707 3.16699 12.6367 3.72899 13.056 4.33366L13.198 4.54766L13.328 4.76099C13.3693 4.83077 13.4089 4.89921 13.4467 4.96633C13.9713 5.90433 14.428 7.12899 14.73 8.33899C15.03 9.53966 15.196 10.7937 15.09 11.7797C14.9833 12.7697 14.4733 13.8337 13.3333 13.8337C12.3107 13.8337 11.5047 13.287 10.85 12.753L10.11 12.1323C9.49467 11.6283 8.82133 11.167 8 11.167C7.17867 11.167 6.50467 11.6283 5.89067 12.1323L5.15067 12.7523C4.49467 13.287 3.68867 13.8337 2.66667 13.8337C1.526 13.8337 1.016 12.7697 0.910001 11.7797C0.804668 10.793 0.970001 9.53966 1.27 8.33899C1.572 7.12899 2.02867 5.90433 2.55333 4.96633L2.672 4.76033L2.802 4.54766L2.944 4.33366C3.36333 3.72899 3.92933 3.16699 4.66667 3.16699C5.00667 3.16699 5.34467 3.24966 5.67667 3.34699L6.072 3.46833C6.13733 3.48833 6.20222 3.50744 6.26667 3.52566C6.84333 3.69099 7.43333 3.83366 8 3.83366C8.56667 3.83366 9.15667 3.69099 9.73334 3.52566L10.3233 3.34766C10.6553 3.24966 10.9933 3.16699 11.3333 3.16699ZM5.66667 5.83366C5.22464 5.83366 4.80072 6.00925 4.48816 6.32181C4.1756 6.63437 4 7.0583 4 7.50033C4 7.94235 4.1756 8.36628 4.48816 8.67884C4.80072 8.9914 5.22464 9.16699 5.66667 9.16699C6.1087 9.16699 6.53262 8.9914 6.84518 8.67884C7.15774 8.36628 7.33333 7.94235 7.33333 7.50033C7.33333 7.0583 7.15774 6.63437 6.84518 6.32181C6.53262 6.00925 6.1087 5.83366 5.66667 5.83366ZM10.3333 5.83366C10.1565 5.83366 9.98695 5.9039 9.86193 6.02892C9.73691 6.15395 9.66667 6.32351 9.66667 6.50033V6.83366H9.33333C9.15652 6.83366 8.98695 6.9039 8.86193 7.02892C8.73691 7.15395 8.66667 7.32351 8.66667 7.50033C8.66667 7.67714 8.73691 7.84671 8.86193 7.97173C8.98695 8.09675 9.15652 8.16699 9.33333 8.16699H9.66667V8.50033C9.66667 8.67714 9.73691 8.84671 9.86193 8.97173C9.98695 9.09675 10.1565 9.16699 10.3333 9.16699C10.5101 9.16699 10.6797 9.09675 10.8047 8.97173C10.9298 8.84671 11 8.67714 11 8.50033V8.16699H11.3333C11.5101 8.16699 11.6797 8.09675 11.8047 7.97173C11.9298 7.84671 12 7.67714 12 7.50033C12 7.32351 11.9298 7.15395 11.8047 7.02892C11.6797 6.9039 11.5101 6.83366 11.3333 6.83366H11V6.50033C11 6.32351 10.9298 6.15395 10.8047 6.02892C10.6797 5.9039 10.5101 5.83366 10.3333 5.83366ZM5.66667 7.16699C5.75507 7.16699 5.83986 7.20211 5.90237 7.26462C5.96488 7.32714 6 7.41192 6 7.50033C6 7.58873 5.96488 7.67352 5.90237 7.73603C5.83986 7.79854 5.75507 7.83366 5.66667 7.83366C5.57826 7.83366 5.49348 7.79854 5.43097 7.73603C5.36845 7.67352 5.33333 7.58873 5.33333 7.50033C5.33333 7.41192 5.36845 7.32714 5.43097 7.26462C5.49348 7.20211 5.57826 7.16699 5.66667 7.16699Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Game modes
                                  </div>
                                </td>

                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {Array.isArray(game.game_details.game_modes)
                                      ? game.game_details.game_modes.join(", ")
                                      : game.game_details.game_modes || "N/A"}
                                  </td>
                                ))}
                              </tr>

                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M2.66659 13.8337C2.29992 13.8337 1.98614 13.7032 1.72525 13.4423C1.46436 13.1814 1.3337 12.8674 1.33325 12.5003V4.50033C1.33325 4.13366 1.46392 3.81988 1.72525 3.55899C1.98659 3.2981 2.30036 3.16744 2.66659 3.16699H6.11659C6.29436 3.16699 6.46392 3.20033 6.62525 3.26699C6.78659 3.33366 6.92814 3.4281 7.04992 3.55033L7.99992 4.50033H13.3333C13.6999 4.50033 14.0139 4.63099 14.2753 4.89233C14.5366 5.15366 14.667 5.46744 14.6666 5.83366V12.5003C14.6666 12.867 14.5361 13.181 14.2753 13.4423C14.0144 13.7037 13.7004 13.8341 13.3333 13.8337H2.66659Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Genres
                                  </div>
                                </td>

                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {Array.isArray(game.game_details.genre)
                                      ? game.game_details.genre.join(", ")
                                      : game.game_details.genre || "N/A"}
                                  </td>
                                ))}
                              </tr>

                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="11"
                                      height="17"
                                      viewBox="0 0 11 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.79545 17.3182V-0.863637H5.96023V17.3182H4.79545ZM8.71591 4.59091C8.63068 3.87121 8.28504 3.3125 7.67898 2.91477C7.07292 2.51705 6.32955 2.31818 5.44886 2.31818C4.80492 2.31818 4.24148 2.42235 3.75852 2.63068C3.2803 2.83901 2.90625 3.12547 2.63636 3.49006C2.37121 3.85464 2.23864 4.26894 2.23864 4.73295C2.23864 5.12121 2.33097 5.45502 2.51562 5.73438C2.70502 6.009 2.9465 6.23864 3.24006 6.4233C3.53362 6.60322 3.84138 6.75237 4.16335 6.87074C4.48532 6.98437 4.78125 7.0767 5.05114 7.14773L6.52841 7.54545C6.9072 7.64489 7.3286 7.7822 7.79261 7.95739C8.26136 8.13258 8.70881 8.37169 9.13494 8.67472C9.56581 8.97301 9.92093 9.35653 10.2003 9.82528C10.4796 10.294 10.6193 10.8693 10.6193 11.5511C10.6193 12.3371 10.4134 13.0473 10.0014 13.6818C9.59422 14.3163 8.99763 14.8205 8.21165 15.1946C7.4304 15.5687 6.48106 15.7557 5.36364 15.7557C4.32197 15.7557 3.41998 15.5876 2.65767 15.2514C1.90009 14.9152 1.3035 14.4465 0.867898 13.8452C0.437027 13.2438 0.193182 12.5455 0.136364 11.75H1.95455C2.00189 12.2992 2.18655 12.7538 2.50852 13.1136C2.83523 13.4687 3.24716 13.7339 3.74432 13.9091C4.24621 14.0795 4.78598 14.1648 5.36364 14.1648C6.03598 14.1648 6.63968 14.0559 7.17472 13.8381C7.70975 13.6155 8.13352 13.3078 8.44602 12.9148C8.75852 12.517 8.91477 12.053 8.91477 11.5227C8.91477 11.0398 8.77983 10.6468 8.50994 10.3438C8.24006 10.0407 7.88494 9.79451 7.4446 9.60511C7.00426 9.41572 6.52841 9.25 6.01705 9.10795L4.22727 8.59659C3.09091 8.26989 2.19129 7.8035 1.52841 7.19744C0.86553 6.59138 0.534091 5.7983 0.534091 4.81818C0.534091 4.00379 0.754261 3.29356 1.1946 2.6875C1.63968 2.0767 2.23627 1.60322 2.98438 1.26705C3.73722 0.926136 4.57765 0.755681 5.50568 0.755681C6.44318 0.755681 7.27652 0.923768 8.00568 1.25994C8.73485 1.59138 9.3125 2.04593 9.73864 2.62358C10.1695 3.20123 10.3968 3.85701 10.4205 4.59091H8.71591Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Price
                                  </div>
                                </td>
                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {typeof game.game_details.price?.amount ===
                                      "number"
                                      ? `$ ${game.game_details.price.amount.toFixed(
                                        2
                                      )}`
                                      : "Free"}
                                  </td>
                                ))}
                              </tr>

                              <tr>
                                <td className="backbg">
                                  <div className="backbg">
                                    <svg
                                      width="12"
                                      height="13"
                                      viewBox="0 0 12 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M6 0L7.33333 4.66667H12L8.26667 7.46667L9.6 12.1333L6 9.33333L2.4 12.1333L3.73333 7.46667L0 4.66667H4.66667L6 0Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Ratings
                                  </div>
                                </td>

                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {game.game_details.rating?.average
                                      ? game.game_details.rating.average.toFixed(1)
                                      : "N/A"}
                                  </td>
                                ))}
                              </tr>

                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.6666 7.16699C13.197 7.16699 13.7057 7.37771 14.0808 7.75278C14.4559 8.12785 14.6666 8.63656 14.6666 9.16699V11.167C14.6666 11.6974 14.4559 12.2061 14.0808 12.5812C13.7057 12.9563 13.197 13.167 12.6666 13.167V13.811C12.6666 14.5177 11.8426 14.9037 11.2999 14.451L9.75858 13.167H7.99992C7.46949 13.167 6.96078 12.9563 6.5857 12.5812C6.21063 12.2061 5.99992 11.6974 5.99992 11.167V9.16699C5.99992 8.63656 6.21063 8.12785 6.5857 7.75278C6.96078 7.37771 7.46949 7.16699 7.99992 7.16699H12.6666ZM10.6666 3.16699C11.197 3.16699 11.7057 3.37771 12.0808 3.75278C12.4559 4.12785 12.6666 4.63656 12.6666 5.16699V5.83366H7.33325C6.62601 5.83366 5.94773 6.11461 5.44763 6.61471C4.94754 7.1148 4.66659 7.79308 4.66658 8.50033V11.167C4.66658 11.863 4.93325 12.4977 5.37058 12.9723L4.66658 13.5003C4.11725 13.9123 3.33325 13.5203 3.33325 12.8337V11.8337C2.80282 11.8337 2.29411 11.6229 1.91904 11.2479C1.54397 10.8728 1.33325 10.3641 1.33325 9.83366V5.16699C1.33325 4.63656 1.54397 4.12785 1.91904 3.75278C2.29411 3.37771 2.80282 3.16699 3.33325 3.16699H10.6666Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>
                                    Total Reviews
                                  </div>
                                </td>
                                {comparisonList.map(game => (
                                  <td key={game.game_details.item_id}>
                                    {game.game_details.reviews?.length || 0}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="text-center p-4">
                          <p style={{ color: "rgba(255, 255, 255, 0.8)" }}>
                            No Apps and Games tracked. Add some Apps and Games to see feature data.
                          </p>
                        </div>
                      )}
                    </div>
                  </Tab>
                  <Tab
                    eventKey="profile"
                    title="Performance"
                  >
                    {/* Feature Description for Performance Tab */}
                    <div onClick={e => e.stopPropagation()} role="presentation" style={{ marginBottom: '10px', paddingTop: '12px' }}>
                      <p style={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: 0,
                        maxWidth: '600px',
                        marginBottom: '8px'
                      }}>
                        Compare the overall performance of your tracked apps and games using KeyQuest's proprietary metrics such as App Score, Engagement Index, and Conversion Ratios.
                      </p>
                      <p style={{
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        lineHeight: '1.4',
                        margin: 0,
                        maxWidth: '600px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          role="img"
                          aria-hidden="true"
                          focusable="false"
                          style={{ flex: '0 0 auto', display: 'block' }}
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="rgba(255,255,255,0.08)" />
                          <path d="M11 10h2v6h-2zM11 7h2v2h-2z" fill="rgba(255,255,255,0.85)" />
                        </svg>
                        <span>Data is updated every 24 hours.</span>
                      </p>
                    </div>

                    {/* Date Range Selector */}
                    <div onClick={e => e.stopPropagation()} role="presentation" style={{ marginBottom: '20px', padding: '16px', backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.1)', pointerEvents: 'none' }}>
                      <div style={{ marginBottom: '12px' }}>
                        <h6 style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px', fontWeight: '600', margin: 0 }}>
                          Date Range Comparison
                        </h6>
                        <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '12px', margin: '4px 0 0 0' }}>
                          Select a custom date range to compare performance metrics
                        </p>
                      </div>

                      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <label style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '13px', minWidth: '70px' }}>
                            Start Date:
                          </label>
                          <input
                            id="dateRangeStart"
                            type="date"
                            style={{
                              padding: '6px 10px',
                              borderRadius: '4px',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              color: '#fff',
                              fontSize: '13px'
                              , pointerEvents: 'auto'
                            }}
                            defaultValue={new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]}
                            onChange={handleDateRangeChange}
                          />
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <label style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '13px', minWidth: '60px' }}>
                            End Date:
                          </label>
                          <input
                            id="dateRangeEnd"
                            type="date"
                            style={{
                              padding: '6px 10px',
                              borderRadius: '4px',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              color: '#fff',
                              fontSize: '13px'
                              , pointerEvents: 'auto'
                            }}
                            defaultValue={new Date().toISOString().split('T')[0]}
                            onChange={handleDateRangeChange}
                          />
                        </div>

                        <button
                          onClick={handleCompareRange}
                          disabled={true}
                          aria-disabled={true}
                          style={{
                            padding: '6px 16px',
                            backgroundColor: '#F6255A',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '13px',
                            cursor: 'not-allowed',
                            fontWeight: '500',
                            transition: 'background-color 0.2s ease',
                            opacity: 0.6
                          }}
                        >
                          Compare Range
                        </button>
                      </div>

                      {/* Date Range Restriction Notice (hidden for paid plans) */}
                      {hasPaidPlan === false && (
                        <div style={{ marginTop: '8px', padding: '6px 8px', backgroundColor: 'rgba(246, 37, 90, 0.1)', borderRadius: '4px', border: '1px solid rgba(246, 37, 90, 0.2)' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px' }}>
                            <span style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                              🔒 Explorer Pack: Limited to 7-day range |
                            </span>
                            <button
                              onClick={() => openUpgradeModal()}
                              style={{
                                background: 'none',
                                border: 'none',
                                color: '#F6255A',
                                fontSize: '11px',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                padding: 0
                              }}
                            >
                              Unlock extended date range with KeyQuest Premium
                            </button>
                          </div>

                          {/* Error message display */}
                          {dateRangeError && (
                            <div style={{ marginTop: '4px', fontSize: '10px', color: '#F6255A', fontStyle: 'italic' }}>
                              ⚠️ {dateRangeError}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="apps_table_main">
                      {/* Header with timestamp and export options */}
                      <div onClick={e => e.stopPropagation()} role="presentation" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', pointerEvents: 'none' }}>
                        <div>
                          {lastUpdated && (
                            <small
                              className="text-muted"
                              style={{ cursor: 'default', userSelect: 'none', pointerEvents: 'none' }}
                            >
                              Updated on: {lastUpdated.toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                              })}, {lastUpdated.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              })} (UTC+5:30)
                            </small>
                          )}
                        </div>

                        {/* Export Options - Always show when there are tracked apps */}
                        {comparisonList.length > 0 && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span
                              style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '13px',
                                marginRight: '8px',
                                cursor: 'default',
                                userSelect: 'none',
                                pointerEvents: 'none'
                              }}
                              aria-hidden="true"
                            >
                              Export:
                            </span>

                            <button
                              onClick={() => exportPerformanceData('csv')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as CSV"
                            >
                              CSV
                            </button>

                            <button
                              onClick={() => exportPerformanceData('xlsx')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as Excel"
                            >
                              XLSX
                            </button>

                            <button
                              onClick={() => exportPerformanceData('pdf')}
                              disabled={true}
                              aria-disabled={true}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'not-allowed',
                                transition: 'all 0.2s ease',
                                fontWeight: '500',
                                opacity: 0.6
                              }}
                              title="Export as PDF"
                            >
                              PDF
                            </button>
                          </div>
                        )}
                      </div>
                      {performanceLoading ? (
                        <div className="text-center p-4">
                          <div
                            className="spinner-border text-light"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 text-light">
                            Loading performance data...
                          </p>
                        </div>
                      ) : comparisonList.length === 0 ? (
                        <div className="text-center p-4">
                          <p style={{ color: "rgba(255, 255, 255, 0.7)" }}>
                            No Apps and Games tracked. Add some Apps and Games to see performance
                            data.
                          </p>
                        </div>
                      ) : (
                        <div style={{ overflowX: 'auto' }}>
                          <Table bordered hover onClick={e => e.stopPropagation()}>
                            <thead>
                              <tr>
                                <th>
                                  <div className="backbg">
                                    <svg
                                      width="12"
                                      height="13"
                                      viewBox="0 0 12 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.666667 0.5C0.489856 0.5 0.320286 0.570238 0.195262 0.695262C0.0702379 0.820286 0 0.989856 0 1.16667V5.16667C0 5.34348 0.0702379 5.51305 0.195262 5.63807C0.320286 5.7631 0.489856 5.83333 0.666667 5.83333H4.66667C4.84348 5.83333 5.01305 5.7631 5.13807 5.63807C5.2631 5.51305 5.33333 5.34348 5.33333 5.16667V1.16667C5.33333 0.989856 5.2631 0.820286 5.13807 0.695262C5.01305 0.570238 4.84348 0.5 4.66667 0.5H0.666667ZM0.666667 7.16667C0.489856 7.16667 0.320286 7.23691 0.195262 7.36193C0.0702379 7.48695 0 7.65652 0 7.83333V11.8333C0 12.0101 0.0702379 12.1797 0.195262 12.3047C0.320286 12.4298 0.489856 12.5 0.666667 12.5H4.66667C4.84348 12.5 5.01305 12.4298 5.13807 12.3047C5.2631 12.1797 5.33333 12.0101 5.33333 11.8333V7.83333C5.33333 7.65652 5.2631 7.48695 5.13807 7.36193C5.01305 7.23691 4.84348 7.16667 4.66667 7.16667H0.666667ZM7.33333 7.16667C7.15652 7.16667 6.98695 7.23691 6.86193 7.36193C6.73691 7.48695 6.66667 7.65652 6.66667 7.83333V11.8333C6.66667 12.0101 6.73691 12.1797 6.86193 12.3047C6.98695 12.4298 7.15652 12.5 7.33333 12.5H11.3333C11.5101 12.5 11.6797 12.4298 11.8047 12.3047C11.9298 12.1797 12 12.0101 12 11.8333V7.83333C12 7.65652 11.9298 7.48695 11.8047 7.36193C11.6797 7.23691 11.5101 7.16667 11.3333 7.16667H7.33333ZM8.66667 5.83333V3.83333H6.66667V2.5H8.66667V0.5H10V2.5H12V3.83333H10V5.83333H8.66667Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Metric
                                  </div>
                                </th>
                                {comparisonList.length > 0 ? (
                                  comparisonList.map(game => (
                                    <th key={game.game_details.item_id}>
                                      <div className="keysec1" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <img
                                          src={
                                            (game.game_details && (game.game_details.image_url || game.game_details.image)) ||
                                            game.image_url ||
                                            'https://via.placeholder.com/32'
                                          }
                                          alt={game.game_details?.name || 'app'}
                                          style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6 }}
                                        />
                                        <span
                                          style={{
                                            verticalAlign: 'middle',
                                            fontSize: '13px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: 'inline-block',
                                            maxWidth: 160,
                                          }}
                                          title={game.game_details?.name}
                                        >
                                          {game.game_details.name}
                                        </span>
                                      </div>
                                    </th>
                                  ))
                                ) : (
                                  <>
                                    <th>
                                      <div className="keysec1">No apps tracked</div>
                                    </th>
                                    <th>
                                      <div className="keysec1">No apps tracked</div>
                                    </th>
                                    <th>
                                      <div className="keysec1">No apps tracked</div>
                                    </th>
                                    <th>
                                      <div className="keysec1">No apps tracked</div>
                                    </th>
                                    <th>
                                      <div className="keysec1">No apps tracked</div>
                                    </th>
                                  </>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M10.9594 0.821955C9.89688 0.999615 9.05692 1.15493 9.05892 1.17335C9.06284 1.20986 11.4901 4.15664 11.5183 4.15918C11.528 4.16004 11.6428 3.87483 11.7734 3.52532C11.904 3.17581 12.0264 2.88988 12.0455 2.88988C12.1932 2.88988 13.1909 3.82 13.5502 4.29281C15.2101 6.4767 15.4762 9.33261 14.242 11.7187C13.6557 12.8523 12.7043 13.8637 11.6031 14.5243C10.1139 15.4177 8.27759 15.7248 6.55561 15.3687C4.35317 14.9131 2.44884 13.3597 1.55557 11.2899C0.624329 9.13204 0.852052 6.6367 2.1572 4.69811L2.38436 4.36068L2.1228 4.04335C1.9789 3.86883 1.83604 3.6941 1.80529 3.65505C1.77458 3.61603 1.74307 3.59128 1.73533 3.60009C1.72758 3.6089 1.63913 3.72751 1.53878 3.86368C0.766992 4.91079 0.264578 6.13379 0.060554 7.46179C-0.0201847 7.98741 -0.0201847 9.11484 0.060554 9.64046C0.331323 11.4031 1.12169 12.9617 2.36442 14.1835C3.96101 15.7533 6.00896 16.5635 8.20994 16.4961C8.89777 16.475 9.32177 16.4176 9.95502 16.2599C11.8671 15.7837 13.5531 14.5846 14.6908 12.892C14.8128 12.7104 15.0311 12.3258 15.1758 12.0372C15.974 10.446 16.1974 8.67696 15.8244 6.90061C15.5864 5.76728 14.9827 4.50272 14.2404 3.58309C13.8002 3.0377 13.1895 2.46523 12.5892 2.03541C12.4933 1.96668 12.4147 1.89165 12.4147 1.86864C12.4147 1.83662 12.7327 0.971127 12.8976 0.554407C12.9102 0.522618 12.9076 0.498191 12.892 0.500105C12.8763 0.502053 12.0067 0.646869 10.9594 0.821955ZM6.47302 0.73593C6.16934 0.797197 6.13693 0.810401 6.17599 0.856978C6.20012 0.88573 6.35993 1.07811 6.53118 1.28446L6.84257 1.65969L7.02339 1.63856C7.12285 1.62697 7.31511 1.60816 7.45059 1.59677C7.58611 1.58541 7.69271 1.56475 7.68752 1.55088C7.68237 1.53702 7.5166 1.33127 7.31923 1.09369C7.05005 0.769666 6.94202 0.662383 6.88711 0.66443C6.84683 0.665915 6.66049 0.6981 6.47302 0.73593ZM5.05216 1.15275C4.88763 1.22075 4.72754 1.29053 4.6965 1.3078C4.6478 1.33487 4.68137 1.3892 4.94001 1.70191C5.10501 1.90139 5.25332 2.07822 5.26958 2.09483C5.28736 2.11298 5.38256 2.09096 5.50807 2.03973C5.62298 1.99283 5.79553 1.92978 5.89149 1.8996C6.04841 1.85029 6.06184 1.83883 6.02445 1.78595C5.91433 1.63011 5.39715 1.02507 5.37571 1.02698C5.36232 1.02817 5.21673 1.08478 5.05216 1.15275ZM3.64184 1.8833L3.33777 2.08159L3.6448 2.45843C3.99581 2.88925 3.91135 2.87281 4.35416 2.59648C4.48214 2.51663 4.58515 2.42975 4.58309 2.40337C4.57797 2.33808 4.03453 1.68501 3.98531 1.68501C3.96367 1.68501 3.8091 1.77423 3.64184 1.8833ZM2.47786 2.7991L2.2043 3.05493L2.43163 3.32152C2.55667 3.46818 2.69894 3.63901 2.74777 3.70114L2.83658 3.81416L3.11849 3.5375L3.40036 3.26085L3.1011 2.90206C2.93653 2.70472 2.79051 2.54327 2.77665 2.54327C2.76276 2.54327 2.62834 2.65841 2.47786 2.7991ZM7.38477 3.20532C5.91253 3.37526 4.58445 4.14251 3.67398 5.34914C3.41359 5.69426 3.03014 6.42886 2.89548 6.84067C2.69644 7.44941 2.65885 7.71738 2.66025 8.51811C2.66138 9.1559 2.67171 9.306 2.73347 9.58048C3.22778 11.7776 4.92462 13.3971 7.12175 13.7688C7.48852 13.8309 7.62516 13.838 8.14347 13.822C8.55912 13.8092 8.83934 13.7829 9.06141 13.7359C10.9651 13.3325 12.4807 11.9892 13.0948 10.1609C13.4376 9.14029 13.4364 7.8932 13.0915 6.83836C13.0463 6.70011 12.9061 6.37905 12.7799 6.12487C11.7871 4.12542 9.61182 2.94827 7.38477 3.20532ZM4.5433 7.38751C4.50683 7.49193 4.35526 7.9264 4.20645 8.35306C3.84809 9.38054 3.84889 9.37908 3.63121 9.42454C3.54495 9.4426 3.5398 9.45385 3.5398 9.62458V9.80551H4.12149H4.70318V9.61174C4.70318 9.44913 4.69384 9.41804 4.64501 9.4182C4.37487 9.41926 4.3646 9.40404 4.45594 9.13781L4.50786 8.98649L4.82989 8.97349C5.00699 8.96632 5.16807 8.96557 5.18784 8.97174C5.20759 8.97794 5.24977 9.06503 5.28158 9.16524C5.35175 9.38631 5.32133 9.4424 5.13124 9.4424H5.00233V9.62455V9.8067L5.79177 9.79785L6.58121 9.789L6.59198 9.67717C6.61199 9.46917 6.57865 9.41087 6.44273 9.41596C6.23761 9.42361 6.25673 9.46752 5.7463 7.81665L5.55494 7.19771H5.08224H4.60958L4.5433 7.38751ZM7.6827 7.23388C7.04493 7.32681 6.63277 7.82645 6.63147 8.50824C6.63037 9.07783 6.86564 9.49317 7.30224 9.69238C7.48895 9.77758 7.54831 9.78808 7.84431 9.78834C8.13934 9.78861 8.19914 9.77824 8.37614 9.69605C8.57551 9.60345 8.57558 9.60345 8.62118 9.67145C8.65984 9.72912 8.70146 9.73949 8.89451 9.73949H9.1222L9.13144 9.26909L9.14065 8.7987L9.2653 8.78847C9.3954 8.77777 9.39826 8.77229 9.39826 8.53462C9.39826 8.50738 9.39639 8.46995 9.3941 8.4514C9.39138 8.42941 9.15644 8.42083 8.71685 8.42664L8.04375 8.43559V8.60064C8.04375 8.75975 8.04734 8.76605 8.14347 8.77599C8.19831 8.78167 8.2619 8.81048 8.28473 8.84006C8.3425 8.91483 8.33768 9.24648 8.27762 9.33165C8.156 9.50409 7.80675 9.42942 7.69224 9.20651C7.56354 8.95596 7.53379 8.31926 7.63314 7.94241C7.65202 7.87091 7.7188 7.76139 7.78155 7.69906C7.89001 7.59135 7.90487 7.58653 8.0832 7.60122C8.24691 7.61469 8.2848 7.63189 8.38123 7.73637C8.4512 7.81219 8.51212 7.92905 8.54739 8.05505L8.6031 8.25403H8.81371H9.02431V7.75888V7.26373H8.8271C8.65951 7.26373 8.62677 7.27356 8.60895 7.32935C8.58828 7.39402 8.58618 7.39408 8.46542 7.33338C8.25588 7.22804 7.97112 7.19183 7.6827 7.23388ZM9.6891 7.37926C9.6891 7.55091 9.69362 7.56082 9.7722 7.56082C9.88598 7.56082 9.89695 7.56296 9.96333 7.59825C10.0165 7.62647 10.0215 7.70444 10.0215 8.50082C10.0215 8.98022 10.0092 9.38004 9.99417 9.38925C9.97915 9.39846 9.90436 9.40969 9.82798 9.41414L9.6891 9.42229V9.61392V9.80551H11.0685H12.448V9.26084V8.71617H12.2365H12.0251L12.0055 8.88119C11.9769 9.12035 11.8717 9.3367 11.7641 9.3773C11.7151 9.39582 11.4974 9.41431 11.2803 9.41843L10.8857 9.42589L10.8857 9.02152L10.8857 8.61714H10.9984C11.1602 8.61714 11.2582 8.70951 11.2817 8.8842L11.3012 9.02977L11.4599 9.03987L11.6186 9.04994L11.6094 8.46256L11.6004 7.87514L11.4597 7.8654L11.319 7.85566L11.2972 7.99074C11.2671 8.17765 11.1944 8.25463 11.0267 8.27697L10.8857 8.29572V7.92393V7.5521L11.2493 7.57108C11.4849 7.58336 11.6493 7.60872 11.7161 7.64305C11.834 7.70359 11.9399 7.85844 11.9694 8.01352C11.9968 8.15734 12.0376 8.18276 12.2319 8.17669L12.3981 8.17151L12.4073 7.68461L12.4165 7.19771H11.0528H9.6891V7.37926ZM4.80821 7.99606C4.78791 8.07439 4.74207 8.23878 4.70637 8.36131L4.64139 8.58413H4.86801H5.09461L4.99579 8.24578C4.94141 8.0597 4.88526 7.89531 4.87104 7.88052C4.85678 7.86573 4.82852 7.91772 4.80821 7.99606Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Keyword Tracking Rate (KTR)
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  const isLocked = isUpgradeRequired(metrics?.ktr)
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics ? (
                                        <UpgradeGatedContent
                                          value={renderTrendIndicator(
                                            metrics.ktr,
                                            trends?.ktr,
                                            "number"
                                          )}
                                          isLocked={isLocked}
                                          onClick={() => openUpgradeModal()}
                                          title={metrics.ktr != null ? String(metrics.ktr) : undefined}
                                        />
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M10.9594 0.821955C9.89688 0.999615 9.05692 1.15493 9.05892 1.17335C9.06284 1.20986 11.4901 4.15664 11.5183 4.15918C11.528 4.16004 11.6428 3.87483 11.7734 3.52532C11.904 3.17581 12.0264 2.88988 12.0455 2.88988C12.1932 2.88988 13.1909 3.82 13.5502 4.29281C15.2101 6.4767 15.4762 9.33261 14.242 11.7187C13.6557 12.8523 12.7043 13.8637 11.6031 14.5243C10.1139 15.4177 8.27759 15.7248 6.55561 15.3687C4.35317 14.9131 2.44884 13.3597 1.55557 11.2899C0.624329 9.13204 0.852052 6.6367 2.1572 4.69811L2.38436 4.36068L2.1228 4.04335C1.9789 3.86883 1.83604 3.6941 1.80529 3.65505C1.77458 3.61603 1.74307 3.59128 1.73533 3.60009C1.72758 3.6089 1.63913 3.72751 1.53878 3.86368C0.766992 4.91079 0.264578 6.13379 0.060554 7.46179C-0.0201847 7.98741 -0.0201847 9.11484 0.060554 9.64046C0.331323 11.4031 1.12169 12.9617 2.36442 14.1835C3.96101 15.7533 6.00896 16.5635 8.20994 16.4961C8.89777 16.475 9.32177 16.4176 9.95502 16.2599C11.8671 15.7837 13.5531 14.5846 14.6908 12.892C14.8128 12.7104 15.0311 12.3258 15.1758 12.0372C15.974 10.446 16.1974 8.67696 15.8244 6.90061C15.5864 5.76728 14.9827 4.50272 14.2404 3.58309C13.8002 3.0377 13.1895 2.46523 12.5892 2.03541C12.4933 1.96668 12.4147 1.89165 12.4147 1.86864C12.4147 1.83662 12.7327 0.971127 12.8976 0.554407C12.9102 0.522618 12.9076 0.498191 12.892 0.500105C12.8763 0.502053 12.0067 0.646869 10.9594 0.821955ZM6.47302 0.73593C6.16934 0.797197 6.13693 0.810401 6.17599 0.856978C6.20012 0.88573 6.35993 1.07811 6.53118 1.28446L6.84257 1.65969L7.02339 1.63856C7.12285 1.62697 7.31511 1.60816 7.45059 1.59677C7.58611 1.58541 7.69271 1.56475 7.68752 1.55088C7.68237 1.53702 7.5166 1.33127 7.31923 1.09369C7.05005 0.769666 6.94202 0.662383 6.88711 0.66443C6.84683 0.665915 6.66049 0.6981 6.47302 0.73593ZM5.05216 1.15275C4.88763 1.22075 4.72754 1.29053 4.6965 1.3078C4.6478 1.33487 4.68137 1.3892 4.94001 1.70191C5.10501 1.90139 5.25332 2.07822 5.26958 2.09483C5.28736 2.11298 5.38256 2.09096 5.50807 2.03973C5.62298 1.99283 5.79553 1.92978 5.89149 1.8996C6.04841 1.85029 6.06184 1.83883 6.02445 1.78595C5.91433 1.63011 5.39715 1.02507 5.37571 1.02698C5.36232 1.02817 5.21673 1.08478 5.05216 1.15275ZM3.64184 1.8833L3.33777 2.08159L3.6448 2.45843C3.99581 2.88925 3.91135 2.87281 4.35416 2.59648C4.48214 2.51663 4.58515 2.42975 4.58309 2.40337C4.57797 2.33808 4.03453 1.68501 3.98531 1.68501C3.96367 1.68501 3.8091 1.77423 3.64184 1.8833ZM2.47786 2.7991L2.2043 3.05493L2.43163 3.32152C2.55667 3.46818 2.69894 3.63901 2.74777 3.70114L2.83658 3.81416L3.11849 3.5375L3.40036 3.26085L3.1011 2.90206C2.93653 2.70472 2.79051 2.54327 2.77665 2.54327C2.76276 2.54327 2.62834 2.65841 2.47786 2.7991ZM7.38477 3.20532C5.91253 3.37526 4.58445 4.14251 3.67398 5.34914C3.41359 5.69426 3.03014 6.42886 2.89548 6.84067C2.69644 7.44941 2.65885 7.71738 2.66025 8.51811C2.66138 9.1559 2.67171 9.306 2.73347 9.58048C3.22778 11.7776 4.92462 13.3971 7.12175 13.7688C7.48852 13.8309 7.62516 13.838 8.14347 13.822C8.55912 13.8092 8.83934 13.7829 9.06141 13.7359C10.9651 13.3325 12.4807 11.9892 13.0948 10.1609C13.4376 9.14029 13.4364 7.8932 13.0915 6.83836C13.0463 6.70011 12.9061 6.37905 12.7799 6.12487C11.7871 4.12542 9.61182 2.94827 7.38477 3.20532ZM4.5433 7.38751C4.50683 7.49193 4.35526 7.9264 4.20645 8.35306C3.84809 9.38054 3.84889 9.37908 3.63121 9.42454C3.54495 9.4426 3.5398 9.45385 3.5398 9.62458V9.80551H4.12149H4.70318V9.61174C4.70318 9.44913 4.69384 9.41804 4.64501 9.4182C4.37487 9.41926 4.3646 9.40404 4.45594 9.13781L4.50786 8.98649L4.82989 8.97349C5.00699 8.96632 5.16807 8.96557 5.18784 8.97174C5.20759 8.97794 5.24977 9.06503 5.28158 9.16524C5.35175 9.38631 5.32133 9.4424 5.13124 9.4424H5.00233V9.62455V9.8067L5.79177 9.79785L6.58121 9.789L6.59198 9.67717C6.61199 9.46917 6.57865 9.41087 6.44273 9.41596C6.23761 9.42361 6.25673 9.46752 5.7463 7.81665L5.55494 7.19771H5.08224H4.60958L4.5433 7.38751ZM7.6827 7.23388C7.04493 7.32681 6.63277 7.82645 6.63147 8.50824C6.63037 9.07783 6.86564 9.49317 7.30224 9.69238C7.48895 9.77758 7.54831 9.78808 7.84431 9.78834C8.13934 9.78861 8.19914 9.77824 8.37614 9.69605C8.57551 9.60345 8.57558 9.60345 8.62118 9.67145C8.65984 9.72912 8.70146 9.73949 8.89451 9.73949H9.1222L9.13144 9.26909L9.14065 8.7987L9.2653 8.78847C9.3954 8.77777 9.39826 8.77229 9.39826 8.53462C9.39826 8.50738 9.39639 8.46995 9.3941 8.4514C9.39138 8.42941 9.15644 8.42083 8.71685 8.42664L8.04375 8.43559V8.60064C8.04375 8.75975 8.04734 8.76605 8.14347 8.77599C8.19831 8.78167 8.2619 8.81048 8.28473 8.84006C8.3425 8.91483 8.33768 9.24648 8.27762 9.33165C8.156 9.50409 7.80675 9.42942 7.69224 9.20651C7.56354 8.95596 7.53379 8.31926 7.63314 7.94241C7.65202 7.87091 7.7188 7.76139 7.78155 7.69906C7.89001 7.59135 7.90487 7.58653 8.0832 7.60122C8.24691 7.61469 8.2848 7.63189 8.38123 7.73637C8.4512 7.81219 8.51212 7.92905 8.54739 8.05505L8.6031 8.25403H8.81371H9.02431V7.75888V7.26373H8.8271C8.65951 7.26373 8.62677 7.27356 8.60895 7.32935C8.58828 7.39402 8.58618 7.39408 8.46542 7.33338C8.25588 7.22804 7.97112 7.19183 7.6827 7.23388ZM9.6891 7.37926C9.6891 7.55091 9.69362 7.56082 9.7722 7.56082C9.88598 7.56082 9.89695 7.56296 9.96333 7.59825C10.0165 7.62647 10.0215 7.70444 10.0215 8.50082C10.0215 8.98022 10.0092 9.38004 9.99417 9.38925C9.97915 9.39846 9.90436 9.40969 9.82798 9.41414L9.6891 9.42229V9.61392V9.80551H11.0685H12.448V9.26084V8.71617H12.2365H12.0251L12.0055 8.88119C11.9769 9.12035 11.8717 9.3367 11.7641 9.3773C11.7151 9.39582 11.4974 9.41431 11.2803 9.41843L10.8857 9.42589L10.8857 9.02152L10.8857 8.61714H10.9984C11.1602 8.61714 11.2582 8.70951 11.2817 8.8842L11.3012 9.02977L11.4599 9.03987L11.6186 9.04994L11.6094 8.46256L11.6004 7.87514L11.4597 7.8654L11.319 7.85566L11.2972 7.99074C11.2671 8.17765 11.1944 8.25463 11.0267 8.27697L10.8857 8.29572V7.92393V7.5521L11.2493 7.57108C11.4849 7.58336 11.6493 7.60872 11.7161 7.64305C11.834 7.70359 11.9399 7.85844 11.9694 8.01352C11.9968 8.15734 12.0376 8.18276 12.2319 8.17669L12.3981 8.17151L12.4073 7.68461L12.4165 7.19771H11.0528H9.6891V7.37926ZM4.80821 7.99606C4.78791 8.07439 4.74207 8.23878 4.70637 8.36131L4.64139 8.58413H4.86801H5.09461L4.99579 8.24578C4.94141 8.0597 4.88526 7.89531 4.87104 7.88052C4.85678 7.86573 4.82852 7.91772 4.80821 7.99606Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Keyword Usage (KU)
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  const isLocked = isUpgradeRequired(metrics?.ku)
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics ? (
                                        <UpgradeGatedContent
                                          value={renderTrendIndicator(
                                            metrics.ku,
                                            trends?.ku,
                                            "number"
                                          )}
                                          isLocked={isLocked}
                                          onClick={() => openUpgradeModal()}
                                          title={metrics.ku != null ? String(metrics.ku) : undefined}
                                        />
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M2.66659 13.8337C2.29992 13.8337 1.98614 13.7032 1.72525 13.4423C1.46436 13.1814 1.3337 12.8674 1.33325 12.5003V4.50033C1.33325 4.13366 1.46392 3.81988 1.72525 3.55899C1.98659 3.2981 2.30036 3.16744 2.66659 3.16699H6.11659C6.29436 3.16699 6.46392 3.20033 6.62525 3.26699C6.78659 3.33366 6.92814 3.4281 7.04992 3.55033L7.99992 4.50033H13.3333C13.6999 4.50033 14.0139 4.63099 14.2753 4.89233C14.5366 5.15366 14.667 5.46744 14.6666 5.83366V12.5003C14.6666 12.867 14.5361 13.181 14.2753 13.4423C14.0144 13.7037 13.7004 13.8341 13.3333 13.8337H2.66659Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    Average User Rating (AUR)
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  const isLocked = isUpgradeRequired(metrics?.aur)
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics ? (
                                        <UpgradeGatedContent
                                          value={renderTrendIndicator(
                                            metrics.aur,
                                            trends?.aur,
                                            "number"
                                          )}
                                          isLocked={isLocked}
                                          onClick={() => openUpgradeModal()}
                                          title={metrics.aur != null ? String(metrics.aur) : undefined}
                                        />
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 12H7v-2H5l3-4 3 4h-2v2z" fill="#E8E8E8" />
                                    </svg>{' '}
                                    Downloads
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  const isLocked = isUpgradeRequired(metrics?.d)
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics ? (
                                        <UpgradeGatedContent
                                          value={renderTrendIndicator(
                                            metrics.d,
                                            trends?.d,
                                            "number"
                                          )}
                                          isLocked={isLocked}
                                          onClick={() => openUpgradeModal()}
                                          title={metrics.d != null ? String(metrics.d) : undefined}
                                        />
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="11"
                                      height="17"
                                      viewBox="0 0 11 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.79545 17.3182V-0.863637H5.96023V17.3182H4.79545ZM8.71591 4.59091C8.63068 3.87121 8.28504 3.3125 7.67898 2.91477C7.07292 2.51705 6.32955 2.31818 5.44886 2.31818C4.80492 2.31818 4.24148 2.42235 3.75852 2.63068C3.2803 2.83901 2.90625 3.12547 2.63636 3.49006C2.37121 3.85464 2.23864 4.26894 2.23864 4.73295C2.23864 5.12121 2.33097 5.45502 2.51562 5.73438C2.70502 6.009 2.9465 6.23864 3.24006 6.4233C3.53362 6.60322 3.84138 6.75237 4.16335 6.87074C4.48532 6.98437 4.78125 7.0767 5.05114 7.14773L6.52841 7.54545C6.9072 7.64489 7.3286 7.7822 7.79261 7.95739C8.26136 8.13258 8.70881 8.37169 9.13494 8.67472C9.56581 8.97301 9.92093 9.35653 10.2003 9.82528C10.4796 10.294 10.6193 10.8693 10.6193 11.5511C10.6193 12.3371 10.4134 13.0473 10.0014 13.6818C9.59422 14.3163 8.99763 14.8205 8.21165 15.1946C7.4304 15.5687 6.48106 15.7557 5.36364 15.7557C4.32197 15.7557 3.41998 15.5876 2.65767 15.2514C1.90009 14.9152 1.3035 14.4465 0.867898 13.8452C0.437027 13.2438 0.193182 12.5455 0.136364 11.75H1.95455C2.00189 12.2992 2.18655 12.7538 2.50852 13.1136C2.83523 13.4687 3.24716 13.7339 3.74432 13.9091C4.24621 14.0795 4.78598 14.1648 5.36364 14.1648C6.03598 14.1648 6.63968 14.0559 7.17472 13.8381C7.70975 13.6155 8.13352 13.3078 8.44602 12.9148C8.75852 12.517 8.91477 12.053 8.91477 11.5227C8.91477 11.0398 8.77983 10.6468 8.50994 10.3438C8.24006 10.0407 7.88494 9.79451 7.4446 9.60511C7.00426 9.41572 6.52841 9.25 6.01705 9.10795L4.22727 8.59659C3.09091 8.26989 2.19129 7.8035 1.52841 7.19744C0.86553 6.59138 0.534091 5.7983 0.534091 4.81818C0.534091 4.00379 0.754261 3.29356 1.1946 2.6875C1.63968 2.0767 2.23627 1.60322 2.98438 1.26705C3.73722 0.926136 4.57765 0.755681 5.50568 0.755681C6.44318 0.755681 7.27652 0.923768 8.00568 1.25994C8.73485 1.59138 9.3125 2.04593 9.73864 2.62358C10.1695 3.20123 10.3968 3.85701 10.4205 4.59091H8.71591Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    User Review Volume (URV)
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  // URV is always available, no need to lock
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics
                                        ? renderTrendIndicator(
                                          metrics.urv,
                                          trends?.urv,
                                          "number"
                                        )
                                        : "N/A"}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_91_5837)">
                                        <path
                                          d="M1 17H14V15.2222H1V17ZM7.5 1L2.85714 5.44444H5.64286V10.7778H9.35714V5.44444H12.1429L7.5 1Z"
                                          fill="#E8E8E8"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_91_5837">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(0 0.5)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    App Store Score (ASR)
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  // ASR is always available, no need to lock
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics
                                        ? renderTrendIndicator(
                                          metrics.asr,
                                          trends?.asr,
                                          "percentage"
                                        )
                                        : "N/A"}
                                    </td>
                                  )
                                })}
                              </tr>
                              <tr>
                                <td>
                                  <div className="backbg">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.6666 7.16699C13.197 7.16699 13.7057 7.37771 14.0808 7.75278C14.4559 8.12785 14.6666 8.63656 14.6666 9.16699V11.167C14.6666 11.6974 14.4559 12.2061 14.0808 12.5812C13.7057 12.9563 13.197 13.167 12.6666 13.167V13.811C12.6666 14.5177 11.8426 14.9037 11.2999 14.451L9.75858 13.167H7.99992C7.46949 13.167 6.96078 12.9563 6.5857 12.5812C6.21063 12.2061 5.99992 11.6974 5.99992 11.167V9.16699C5.99992 8.63656 6.21063 8.12785 6.5857 7.75278C6.96078 7.37771 7.46949 7.16699 7.99992 7.16699H12.6666ZM10.6666 3.16699C11.197 3.16699 11.7057 3.37771 12.0808 3.75278C12.4559 4.12785 12.6666 4.63656 12.6666 5.16699V5.83366H7.33325C6.62601 5.83366 5.94773 6.11461 5.44763 6.61471C4.94754 7.1148 4.66659 7.79308 4.66658 8.50033V11.167C4.66658 11.863 4.93325 12.4977 5.37058 12.9723L4.66658 13.5003C4.11725 13.9123 3.33325 13.5203 3.33325 12.8337V11.8337C2.80282 11.8337 2.29411 11.6229 1.91904 11.2479C1.54397 10.8728 1.33325 10.3641 1.33325 9.83366V5.16699C1.33325 4.63656 1.54397 4.12785 1.91904 3.75278C2.29411 3.37771 2.80282 3.16699 3.33325 3.16699H10.6666Z"
                                        fill="#E8E8E8"
                                      />
                                    </svg>{" "}
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                      <span>Revenue</span>
                                      <span
                                        title="Add-ons revenue included in total"
                                        style={{ display: "inline-flex", alignItems: "center" }}
                                      >
                                        <Info size={14} style={{ opacity: 0.8, cursor: "default" }} />
                                      </span>
                                    </span>
                                  </div>
                                </td>
                                {comparisonList.map(game => {
                                  const metrics = getLatestMetrics(
                                    game.game_details.item_id
                                  )
                                  const trends = getTrendData(
                                    game.game_details.item_id
                                  )
                                  const isLocked = isUpgradeRequired(metrics?.revenue)
                                  return (
                                    <td key={game.game_details.item_id}>
                                      {metrics ? (
                                        <UpgradeGatedContent
                                          value={renderTrendIndicator(
                                            metrics.revenue,
                                            trends?.revenue,
                                            "currency"
                                          )}
                                          isLocked={isLocked}
                                          onClick={() => openUpgradeModal()}
                                          title={
                                            metrics.revenue != null
                                              ? `${String(metrics.revenue)} (Add-ons revenue included in total)`
                                              : "Add-ons revenue included in total"
                                          }
                                        />
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>
                                  )
                                })}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                  </Tab>
                  <Tab eventKey="social" title="Social Media">
                    {/* Social Media Description */}
                    <div style={{ marginBottom: '20px', paddingTop: '12px' }}>
                      <p style={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: 0,
                        maxWidth: '600px'
                      }}>
                        Compare social media presence and links across all tracked apps and games.<br />
                        Track which platforms each app uses and their social media strategy.
                      </p>
                    </div>

                    <div className="apps_table_main">
                      {/* Export Options for Social Media Tab */}
                      {comparisonList.length > 0 && (
                        <div onClick={e => e.stopPropagation()} role="presentation" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <div>
                            {(lastSocialUpdated || lastUpdated) && (
                              <small className="text-muted" style={{ cursor: 'default', userSelect: 'none', pointerEvents: 'none' }}>
                                Updated on: {(lastSocialUpdated || lastUpdated).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })}, {(lastSocialUpdated || lastUpdated).toLocaleTimeString('en-US', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                })} (UTC+5:30)
                              </small>
                            )}
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span
                              style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '13px',
                                marginRight: '8px',
                                cursor: 'default',
                                userSelect: 'none',
                                pointerEvents: 'none'
                              }}
                              aria-hidden="true"
                            >
                              Export:
                            </span>

                            <button
                              onClick={() => exportSocialData('csv')}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontWeight: '500'
                              }}
                              title="Export as CSV"
                            >
                              CSV
                            </button>

                            <button
                              onClick={() => exportSocialData('xlsx')}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontWeight: '500'
                              }}
                              title="Export as Excel"
                            >
                              XLSX
                            </button>

                            <button
                              onClick={() => exportSocialData('pdf')}
                              style={{
                                padding: '4px 10px',
                                backgroundColor: '#F6255A',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontWeight: '500'
                              }}
                              title="Export as PDF"
                            >
                              PDF
                            </button>
                          </div>
                        </div>
                      )}

                      {comparisonList.length > 0 ? (
                        <div style={{ overflowX: 'auto' }}>
                          <Table bordered hover onClick={e => e.stopPropagation()}>
                            <thead>
                              <tr>
                                <th>
                                  <div className="backbg">
                                    <i className="fas fa-share-alt" style={{ marginRight: '6px', fontSize: '14px' }}></i>
                                    Social Platform
                                  </div>
                                </th>
                                {getSortedComparisonList().map(game => {
                                  const socialData = socialMediaData[game.game_details.item_id]
                                  const publisherName = socialData ? Object.values(socialData)[0]?.publisher_name : null
                                  
                                  return (
                                  <th key={game.game_details.item_id}>
                                    <div className="keysec1" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <img
                                        src={
                                          (game.game_details && (game.game_details.image_url || game.game_details.image)) ||
                                          game.image_url ||
                                          'https://via.placeholder.com/32'
                                        }
                                        alt={game.game_details?.name || 'app'}
                                        style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6 }}
                                      />
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                        <span
                                          style={{
                                            verticalAlign: 'middle',
                                            fontSize: '13px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: 'inline-block',
                                            maxWidth: 160,
                                          }}
                                          title={game.game_details?.name}
                                        >
                                          {game.game_details.name}
                                        </span>
                                        {publisherName && (
                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              // Navigate to publisher page - you may need to adjust this URL pattern
                                              window.open(`/publisher/${generateSlug(publisherName)}`, '_blank')
                                            }}
                                            style={{
                                              fontSize: '10px',
                                              color: 'rgba(255, 255, 255, 0.6)',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              display: 'inline-block',
                                              maxWidth: 160,
                                              cursor: 'pointer',
                                              textDecoration: 'none'
                                            }}
                                            title={`View ${publisherName} publisher page`}
                                            onMouseEnter={(e) => {
                                              e.target.style.color = '#F6255A'
                                              e.target.style.textDecoration = 'underline'
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.color = 'rgba(255, 255, 255, 0.6)'
                                              e.target.style.textDecoration = 'none'
                                            }}
                                          >
                                            {publisherName}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </th>
                                )})}
                              </tr>
                            </thead>
                            <tbody>
                              {['youtube', 'x', 'instagram', 'facebook', 'linkedin', 'tiktok', 'snapchat', 'discord', 'reddit', 'telegram', 'pinterest'].map(platform => {
                                const platformMeta = getPlatformMetadata(platform)
                                return (
                                  <tr key={platform}>
                                    <td>
                                      <div className="backbg">
                                        <i className={platformMeta.icon} style={{ 
                                          color: platformMeta.color, 
                                          marginRight: '8px', 
                                          fontSize: '14px',
                                          width: '16px',
                                          textAlign: 'center'
                                        }}></i>
                                        {platformMeta.displayName}
                                      </div>
                                    </td>
                                    {getSortedComparisonList().map(game => {
                                      const socialData = socialMediaData[game.game_details.item_id]
                                      const platformData = socialData?.[platformMeta.key]
                                      
                                      return (
                                        <td key={game.game_details.item_id}>
                                          {platformData ? (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                              {platformData.url ? (
                                                <a
                                                  href={platformData.url}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    color: '#F6255A',
                                                    textDecoration: 'none',
                                                    fontSize: '13px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                  }}
                                                  title={`Visit ${platformMeta.displayName} page`}
                                                >
                                                  <i className={platformMeta.icon} style={{ 
                                                    color: platformMeta.color, 
                                                    fontSize: '12px' 
                                                  }}></i>
                                                  {platformData.handle || 'Link'}
                                                </a>
                                              ) : (
                                                <div
                                                  style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '13px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                  }}
                                                  title={`${platformMeta.displayName} account`}
                                                >
                                                  <i className={platformMeta.icon} style={{ 
                                                    color: platformMeta.color, 
                                                    fontSize: '12px' 
                                                  }}></i>
                                                  {platformData.handle || 'No handle'}
                                                </div>
                                              )}
                                              {platformData.followers_display && (
                                                <span style={{
                                                  color: 'rgba(255, 255, 255, 0.6)',
                                                  fontSize: '11px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: '2px'
                                                }}>
                                                  <i className="fas fa-users" style={{ fontSize: '10px' }}></i>
                                                  {platformData.followers_display} {platformData.metric_label}
                                                </span>
                                              )}
                                            </div>
                                          ) : (
                                            <span style={{ 
                                              color: 'rgba(255, 255, 255, 0.4)', 
                                              fontSize: '13px' 
                                            }}>
                                              —
                                            </span>
                                          )}
                                        </td>
                                      )
                                    })}
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div style={{ textAlign: 'center', padding: '40px', color: 'rgba(255, 255, 255, 0.6)' }}>
                          <p style={{ fontSize: '16px', margin: 0 }}>No apps tracked yet</p>
                          <p style={{ fontSize: '14px', marginTop: '8px' }}>Add apps to compare their social media presence</p>
                        </div>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </div>

              {/* <div className="feature_btn">
              <button onClick={handleOpen}>Unlock more with Premium</button>

              <div className="select_grp_popup">
                <AppsTrackingPlanModal
                  show={showModal}
                  handleClose={handleClose}
                  title="My Modal"
                >
                  <p>This is the modal content.</p>
                </AppsTrackingPlanModal>
              </div>
            </div> */}

              {/* Upgrade Modal */}
              <AppsTrackingPlanModal
                show={showUpgradeModal}
                handleClose={() => {
                  setShowUpgradeModal(false)
                  // Reset to default title when modal closes
                  setUpgradeModalTitle(defaultModalTitle)
                }}
                title={upgradeModalTitle}
              />

              {/* Remove app confirmation modal (overlay) */}
              {showRemoveConfirm && pendingRemoveId && (
                <div
                  style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.55)",
                    zIndex: 12345,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => { setShowRemoveConfirm(false); setPendingRemoveId(null); setPendingRemoveName("") }}
                >
                  <div
                    role="dialog"
                    aria-modal="true"
                    onClick={e => e.stopPropagation()}
                    style={{
                      background: "#21222D",
                      color: "#fff",
                      borderRadius: 12,
                      padding: 20,
                      maxWidth: 380,
                      width: "90%",
                      textAlign: "center",
                      position: 'relative',
                      boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
                    }}
                  >
                    <button
                      onClick={() => { setShowRemoveConfirm(false); setPendingRemoveId(null); setPendingRemoveName("") }}
                      aria-label="Close remove dialog"
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        border: 'none',
                        background: 'transparent',
                        color: '#fff',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>
                      Remove "{pendingRemoveName}"?
                    </div>
                    <div style={{ color: "#A1ACB8", marginBottom: 20, textAlign: 'left' }}>
                      {activeGroup ? (
                        <>
                          <div style={{ marginBottom: 8 }}>
                            What would you like to do with "{pendingRemoveName}"?
                          </div>
                          <div style={{ fontSize: 13, lineHeight: '1.3' }}>
                            <div>
                              <strong>Remove</strong> — removes the app only from the group "{activeGroup}" but keeps it in your tracked list.
                            </div>
                            <div style={{ marginTop: 6 }}>
                              <strong>Untrack</strong> — untracks the app entirely across all groups and removes it from your tracked list.
                            </div>
                          </div>
                        </>
                      ) : (
                        "Are you sure you want to remove this app from tracking?"
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                      {activeGroup ? (
                        // When viewing an active group, offer two explicit choices:
                        // 1) Remove from group (leave app tracked)
                        // 2) Remove app (untrack entirely)
                        <>
                          <button
                            onClick={() => {
                              const id = pendingRemoveId
                              // close modal immediately
                              setShowRemoveConfirm(false)
                              if (!id) return
                              try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_REMOVED, { app_id: id, app_name: pendingRemoveName, scope: "group" }) } catch (e) { }

                              const prevGroups = Array.isArray(groups) ? JSON.parse(JSON.stringify(groups)) : groups
                              // Optimistically remove item from the active group's game_ids
                              try {
                                setGroups(prev => {
                                  if (!Array.isArray(prev)) return prev
                                  return prev.map(g => {
                                    if (g.name !== activeGroup) return g
                                    const existing = Array.isArray(g.game_ids) ? g.game_ids : []
                                    return { ...g, game_ids: existing.filter(x => x !== id) }
                                  })
                                })
                                try { setGamesInTagCall() } catch (err) { }
                              } catch (err) { }

                              ; (async () => {
                                try {
                                  await deleteGamefromTag(id, activeGroup)
                                  try { await getGameTags() } catch (err) { }
                                  try { setGamesInTagCall() } catch (err) { }
                                } catch (err) {
                                  console.error('Error removing app from group (background):', err)
                                  try { setGroups(prevGroups) } catch (e) { }
                                  try { setGamesInTagCall() } catch (e) { }
                                  try { triggerToast('Could not remove app from group. Try again.', 'error') } catch (e) { }
                                }
                              })()

                              setPendingRemoveId(null)
                              setPendingRemoveName("")
                            }}
                            style={{ padding: '8px 14px', background: '#171821', border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
                          >
                            Remove
                          </button>

                          <button
                            onClick={() => {
                              // Close first modal and open second confirmation modal
                              setShowRemoveConfirm(false)
                              if (!pendingRemoveId) return
                              setShowUntrackConfirm(true)
                            }}
                            style={{ padding: '8px 14px', background: '#171821', border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
                          >
                            Untrack
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => {
                            // Close modal immediately and apply optimistic UI update
                            setShowRemoveConfirm(false)
                            if (!pendingRemoveId) return
                            try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_REMOVED, { app_id: pendingRemoveId, app_name: pendingRemoveName, scope: activeGroup ? "group" : "all" }) } catch (e) { }

                            // Snapshot previous state for potential revert
                            const prevGroups = Array.isArray(groups) ? JSON.parse(JSON.stringify(groups)) : groups
                            const prevComparison = Array.isArray(comparisonList) ? JSON.parse(JSON.stringify(comparisonList)) : comparisonList

                            if (activeGroup) {
                              // Optimistically remove item from the active group's game_ids
                              try {
                                setGroups(prev => {
                                  if (!Array.isArray(prev)) return prev
                                  return prev.map(g => {
                                    if (g.name !== activeGroup) return g
                                    const existing = Array.isArray(g.game_ids) ? g.game_ids : []
                                    return { ...g, game_ids: existing.filter(id => id !== pendingRemoveId) }
                                  })
                                })
                                try { setGamesInTagCall() } catch (err) { }
                              } catch (err) {
                                // ignore optimistic error
                              }

                              // Fire API in background and revert on failure
                              ; (async () => {
                                try {
                                  await deleteGamefromTag(pendingRemoveId, activeGroup)
                                  // Refresh tags to ensure canonical state
                                  try { await getGameTags() } catch (err) { }
                                  try { setGamesInTagCall() } catch (err) { }
                                } catch (err) {
                                  console.error('Error removing app from group (background):', err)
                                  try { setGroups(prevGroups) } catch (e) { }
                                  try { setGamesInTagCall() } catch (e) { }
                                  try { triggerToast('Could not remove app from group. Try again.', 'error') } catch (e) { }
                                }
                              })()
                            } else {
                              // Untrack path: remove from comparisonList immediately so card disappears
                              try {
                                setRemovingAppId(pendingRemoveId)
                                setComparisonList(prev => {
                                  if (!Array.isArray(prev)) return prev
                                  const next = prev.filter(p => (p.game_details && p.game_details.item_id) !== pendingRemoveId)
                                  try { setSessionItem('comparisonBetween', next) } catch (err) { }
                                  try { setLocalItem('comparisonBetween', next) } catch (err) { }
                                  // also update trackedGames/filteredGames if they mirror comparisonList
                                  try { setTrackedGames(next) } catch (err) { }
                                  try { setFilteredGames(next) } catch (err) { }
                                  return next
                                })
                              } catch (err) {
                                // ignore optimistic error
                              }

                              ; (async () => {
                                try {
                                  await removeApp(pendingRemoveId)
                                  try { await callAppTrackapi() } catch (err) { }
                                } catch (err) {
                                  console.error('Error untracking app (background):', err)
                                  // Revert optimistic removal
                                  try { setComparisonList(prevComparison) } catch (e) { }
                                  try { setTrackedGames(prevComparison) } catch (e) { }
                                  try { setFilteredGames(prevComparison) } catch (e) { }
                                  try { setSessionItem('comparisonBetween', prevComparison) } catch (e) { }
                                  try { setLocalItem('comparisonBetween', prevComparison) } catch (e) { }
                                  try { triggerToast('Could not remove app. Try again.', 'error') } catch (e) { }
                                } finally {
                                  try { setRemovingAppId(null) } catch (e) { }
                                }
                              })()
                            }

                            // clear pending fields
                            setPendingRemoveId(null)
                            setPendingRemoveName("")
                          }}
                          style={{ padding: '8px 14px', background: '#F6255A', border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
                        >
                          {removingAppId === pendingRemoveId ? (
                            <div className="spinner-border spinner-border-sm text-light" role="status" style={{ width: '1rem', height: '1rem' }} />
                          ) : (
                            activeGroup ? 'Remove from group' : 'Remove'
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {showGroupDeleteModal && groupToDelete && (
                <div
                  style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.55)",
                    zIndex: 12345,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#21222D",
                      color: "#fff",
                      borderRadius: 16,
                      padding: 32,
                      maxWidth: 340,
                      width: "100%",
                      textAlign: "center",
                      boxShadow: "0 4px 32px #0007",
                    }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
                      Delete group "{groupToDelete}"?
                    </div>
                    <div style={{ color: "#A1ACB8", marginBottom: 24 }}>
                      Are you sure you want to remove this group? This action can’t be undone.
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
                      <button
                        style={{
                          background: "#171821",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8,
                          padding: "10px 22px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        onClick={() => setShowGroupDeleteModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        style={{
                          background: "#F6255A",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8,
                          padding: "10px 22px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          setShowGroupDeleteModal(false); // close modal
                          await handleRemoveGroup(groupToDelete); // call API
                          setGroupToDelete(null); // reset
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* Second confirmation modal for Untrack action */}
              {showUntrackConfirm && pendingRemoveId && (
                <div
                  style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.55)",
                    zIndex: 12346,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => { setShowUntrackConfirm(false); setShowRemoveConfirm(true) }}
                >
                  <div
                    role="dialog"
                    aria-modal="true"
                    onClick={e => e.stopPropagation()}
                    style={{
                      background: "#21222D",
                      color: "#fff",
                      borderRadius: 12,
                      padding: 20,
                      maxWidth: 420,
                      width: "90%",
                      textAlign: "center",
                      position: 'relative',
                      boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
                    }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>Confirm untrack "{pendingRemoveName}"</div>
                    <div style={{ color: "#A1ACB8", marginBottom: 20 }}>
                      This will untrack "{pendingRemoveName}" from your account and remove it from all groups. Do you really want to proceed?
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                      <button
                        onClick={() => { setShowUntrackConfirm(false); setShowRemoveConfirm(true) }}
                        style={{ padding: '8px 14px', background: 'transparent', border: '1px solid rgba(255,255,255,0.08)', color: '#fff', borderRadius: 8, cursor: 'pointer' }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={async () => {
                          // Perform the untrack operation (same optimistic behavior as before)
                          const id = pendingRemoveId
                          setShowUntrackConfirm(false)
                          if (!id) return
                          try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_REMOVED, { app_id: id, app_name: pendingRemoveName, scope: "all" }) } catch (e) { }

                          const prevComparison = Array.isArray(comparisonList) ? JSON.parse(JSON.stringify(comparisonList)) : comparisonList
                          try {
                            setRemovingAppId(id)
                            setComparisonList(prev => {
                              if (!Array.isArray(prev)) return prev
                              const next = prev.filter(p => (p.game_details && p.game_details.item_id) !== id)
                              try { setSessionItem('comparisonBetween', next) } catch (err) { }
                              try { setLocalItem('comparisonBetween', next) } catch (err) { }
                              try { setTrackedGames(next) } catch (err) { }
                              try { setFilteredGames(next) } catch (err) { }
                              return next
                            })
                          } catch (err) { }

                          ; (async () => {
                            try {
                              await removeApp(id)
                              try { await callAppTrackapi() } catch (err) { }
                            } catch (err) {
                              console.error('Error untracking app (background):', err)
                              try { setComparisonList(prevComparison) } catch (e) { }
                              try { setTrackedGames(prevComparison) } catch (e) { }
                              try { setFilteredGames(prevComparison) } catch (e) { }
                              try { setSessionItem('comparisonBetween', prevComparison) } catch (e) { }
                              try { setLocalItem('comparisonBetween', prevComparison) } catch (e) { }
                              try { triggerToast('Could not remove app. Try again.', 'error') } catch (e) { }
                            } finally {
                              try { setRemovingAppId(null) } catch (e) { }
                            }
                          })()

                          setPendingRemoveId(null)
                          setPendingRemoveName("")
                        }}
                        style={{ padding: '8px 14px', background: '#171821', border: 'none', color: '#fff', borderRadius: 8, cursor: 'pointer' }}
                      >
                        Yes, untrack
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {showCreateErrorModal && (
                <div
                  style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.55)",
                    zIndex: 12345,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => { setShowCreateErrorModal(false); setCreateErrorMsg("") }}
                >
                  <div
                    role="dialog"
                    aria-modal="true"
                    onClick={e => e.stopPropagation()}
                    style={{
                      background: "#21222D",
                      color: "#fff",
                      borderRadius: 12,
                      padding: 20,
                      maxWidth: 420,
                      width: "90%",
                      textAlign: "center",
                      boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
                    }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>
                      Could not create group
                    </div>
                    <div style={{ color: "#A1ACB8", marginBottom: 20 }}>
                      {createErrorMsg}
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                      <button
                        onClick={() => { setShowCreateErrorModal(false); setCreateErrorMsg("") }}
                        style={{ padding: '8px 14px', background: 'transparent', border: '1px solid rgba(255,255,255,0.08)', color: '#fff', borderRadius: 8, cursor: 'pointer' }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="key_track_search d-flex align-items-center flex-row gap-3 gap-sm-4"
              style={{ marginBottom: 16, marginTop: 8, position: 'relative' }}
            >

              <div className="key_track_search_inn searchField d-flex align-items-center">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input
                  type="text"
                  placeholder="Enter App or Game Name or URL"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      // replicate Add button behaviour
                      if (!searchTerm || !searchTerm.trim()) {
                        try { triggerInlineToast("Enter a keyword, then click Search to find apps/games") } catch (err) { triggerToast("Enter a keyword, then click Search to find apps/games", 'warning') }
                        return
                      }
                      handleSearch()
                      setModalSearchTerm(searchTerm)
                      setShowKeywordModal(true)
                    }
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', position: 'relative' }}>
                {showAppTrackingOnboarding && appTrackingOnboardingStep === 0 && (
                  <>
                    <div className="kt-backdrop-overlay"></div>
                    <div className="kt-highlight-box kt-highlight-box--apptrack-search"></div>
                  </>
                )}
                <button
                  ref={addButtonRef}
                  className={`searchBtn ${showAppTrackingOnboarding && appTrackingOnboardingStep === 0 ? 'kt-highlighted' : ''}`}
                  onClick={() => {
                    // If there's no search term, show a toast instructing the user
                    // to enter a keyword and perform search first.
                    if (!searchTerm || !searchTerm.trim()) {
                      // show inline toast under Add button if possible
                      try { triggerInlineToast("Enter a keyword, then click Search to find apps/games") } catch (err) { triggerToast("Enter a keyword, then click Search to find apps/games", 'warning') }
                      return
                    }
                    // Otherwise perform the search and open the keyword modal
                    handleSearch() // Call the API
                    setModalSearchTerm(searchTerm)
                    setShowKeywordModal(true) // Then show modal
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  style={addButtonStyle}
                >
                  Add
                </button>
                {showInlineToast && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '46px',
                      left: 0,
                      background: '#21222D',
                      color: '#fff',
                      padding: '6px 10px',
                      borderRadius: 6,
                      fontSize: 13,
                      boxShadow: '0 6px 18px rgba(0,0,0,0.35)'
                    }}
                  >
                    {inlineToastMsg}
                  </div>
                )}
                <div
                  ref={filterToggleRef}
                  className="platform-filter-toggle"
                  style={{ display: 'flex', gap: 12, alignItems: 'center', position: 'relative' }}
                >
                  <label className="pf-checkbox mb-0">
                    <input
                      type="checkbox"
                      checked={platformFilter === 'all'}
                      onChange={() => setPlatformFilter('all')}
                    />
                    <span className="pf-label">All</span>
                  </label>

                  <label className="pf-checkbox mb-0">
                    <input
                      type="checkbox"
                      checked={platformFilter === 'games'}
                      onChange={() => {
                        // Toggle games: if already selected, revert to 'all'
                        if (platformFilter === 'games') setPlatformFilter('all')
                        else setPlatformFilter('games')
                      }}
                    />
                    <span className="pf-label">Games</span>
                  </label>

                  <label className="pf-checkbox mb-0">
                    <input
                      type="checkbox"
                      checked={platformFilter === 'apps'}
                      onChange={() => {
                        // Toggle apps: if already selected, revert to 'all'
                        if (platformFilter === 'apps') setPlatformFilter('all')
                        else setPlatformFilter('apps')
                      }}
                    />
                    <span className="pf-label">Apps</span>
                  </label>
                </div>
              </div>

              {showAppTrackingOnboarding && appTrackingOnboardingStep === 0 && (
                <div className="kt-explanation-box kt-explanation-box--apptrack-search">
                  <button
                    type="button"
                    className="kt-skip-all-btn"
                    onClick={skipAllTutorials}
                  >
                    Skip All
                  </button>
                  <div className="kt-explanation-text">
                    Type a name and hit <strong>Add</strong> to track the app.
                  </div>
                  <div className="kt-explanation-arrow kt-arrow-to-apptrack-search"></div>
                  <div className="kt-explanation-nav">
                    <button
                      type="button"
                      className="kt-nav-btn kt-nav-btn--prev"
                      onClick={() => setAppTrackingOnboardingStep(1)}
                    >
                      Skip
                    </button>
                    <button
                      type="button"
                      className="kt-nav-btn kt-nav-btn--next"
                      onClick={() => setAppTrackingOnboardingStep(1)}
                    >
                      Next &gt;
                    </button>
                  </div>
                </div>
              )}

              {showAppTrackingOnboarding && appTrackingOnboardingStep === 1 && (
                <>
                  <div className="kt-backdrop-overlay"></div>
                  <div className="kt-highlight-box kt-highlight-box--apptrack-filter"></div>
                  <div className="kt-explanation-box kt-explanation-box--apptrack-filter">
                    <button
                      type="button"
                      className="kt-skip-all-btn"
                      onClick={skipAllTutorials}
                    >
                      Skip All
                    </button>
                    <div className="kt-explanation-text">
                      Toggles to filter <strong>apps</strong> and <strong>games</strong>.
                    </div>
                    <div className="kt-explanation-arrow kt-arrow-to-apptrack-filter"></div>
                    <div className="kt-explanation-nav">
                      <button
                        type="button"
                        className="kt-nav-btn kt-nav-btn--prev"
                        onClick={() => setAppTrackingOnboardingStep(0)}
                      >
                        &lt; Prev
                      </button>
                      <button
                        type="button"
                        className="kt-nav-btn kt-nav-btn--next"
                        onClick={() => setAppTrackingOnboardingStep(2)}
                      >
                        Next &gt;
                      </button>
                    </div>
                  </div>
                </>
              )}

            </div>
            <div className="custom_grp_sec pt-0 mb-3">
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 14 }}>
                <button
                  onClick={() => {
                    trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_GROUP_SWITCHED, { group_name: "all" })
                    setActiveGroup(null)
                    setFilteredGames(trackedGames)
                  }}
                  className={`keyword-add-btn all-games-btn ${!activeGroup ? 'active' : 'inactive'}`}
                  onMouseEnter={() => setIsAllGamesHovered(true)}
                  onMouseLeave={() => setIsAllGamesHovered(false)}
                  style={{
                    width: 'auto',
                    padding: '8px 12px',
                    borderRadius: 8,
                    cursor: 'pointer',
                    fontSize: 13,
                    fontWeight: 700,
                    // When a group is selected (`activeGroup` is set), show the neutral/transparent
                    // appearance so CSS `.all-games-btn.inactive` rules apply. When no group is
                    // selected, show the primary pink appearance (hover state still applies).
                    background: activeGroup ? 'transparent' : (isAllGamesHovered ? '#e11d4c' : '#F6255A'),
                    color: '#FFFFFF',
                    border: activeGroup ? '1px solid rgba(255,255,255,0.06)' : 'none',
                    boxShadow: activeGroup ? 'none' : (isAllGamesHovered ? '0 8px 24px rgba(246,37,90,0.16)' : '0 6px 20px rgba(246,37,90,0.12)'),
                    transition: 'background 0.18s ease, transform 0.12s ease'
                  }}
                  aria-label="Show all apps and games"
                >
                  <i className="fas fa-th-large" style={{ marginRight: 8, fontSize: 12 }} aria-hidden="true"></i>
                  All Apps and Games
                </button>
              </div>

              <h6 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>Custom Groups</span>
              </h6>
              <ul>

                {groups.map((group, idx) => (
                  <li
                    key={idx}
                    onDragOver={e => { e.preventDefault(); setDropHoverGroup(group.name); }}
                    onDragEnter={() => setDropHoverGroup(group.name)}
                    onDragLeave={() => setDropHoverGroup(null)}
                    onDrop={e => handleDropOnGroup(e, group.name)}
                  >
                    <a
                      className={activeGroup === group.name ? "active" : ""}
                      onClick={() => confirmDiscardThen(() => { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_GROUP_SWITCHED, { group_name: group.name }); setActiveGroup(group.name) })}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 10px",
                        cursor: "pointer",
                        textDecoration: "none",
                        background: dropHoverGroup === group.name ? '#F6255A' : undefined,
                        color: dropHoverGroup === group.name ? '#ffffff' : undefined,
                        borderRadius: 8,
                        transition: 'background 0.12s ease, transform 0.08s ease, box-shadow 0.12s ease',
                        ...(dropHoverGroup === group.name ? { boxShadow: '0 10px 30px rgba(246,37,90,0.28)', transform: 'translateY(-2px) scale(1.03)' } : {})
                      }}
                    >
                      <span>{group.name}</span>
                      <span
                        onClick={e => {
                          e.stopPropagation() // prevent group select
                          // open confirm modal instead of immediate delete
                          setGroupToDelete(group.name)
                          setShowGroupDeleteModal(true)
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 640 640"
                          width="12"
                          height="12"
                          fill="currentColor"
                        >
                          <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                        </svg>
                      </span>
                    </a>
                  </li>
                ))}

                <li>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="secondary"
                      className="createGroupBtn"
                      id="createGroup-abcz082458wer"
                    >
                      <i className="fa-solid fa-plus"></i> Create Group
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-0 border-0 m-0">
                      <div className="create_grp_popup">
                        <h6 className="mb-0">Create Group</h6>
                        <input
                          value={createTag}
                          onChange={e => {
                            const v = e.target.value
                            setCreateTag(v)
                            try { setCreateTagDirty(Boolean(v && v.trim())) } catch (err) { }
                          }}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.keyCode === 13) {
                              e.preventDefault()
                              if (createTag && createTag.trim()) {
                                // Create a group immediately (do not open keyword modal)
                                createGroup(createTag.trim())
                              }
                            }
                          }}
                          type="text"
                          placeholder="Enter Group Name"
                        />
                        <div className="create_grp_popup_btn">
                          <button
                            onClick={() => {
                              if (createTag && createTag.trim()) {
                                createGroup(createTag.trim())
                              }
                            }}
                            type="button"
                            className="active"
                            disabled={createGroupLoading}
                            aria-disabled={createGroupLoading}
                          >
                            {createGroupLoading ? (
                              <span className="spinner-border spinner-border-sm text-light" style={{ marginRight: 8 }} role="status" aria-hidden="true"></span>
                            ) : null}
                            Create
                          </button>
                          <button
                            onClick={() => {
                              // Cancel creating a group: clear input and close dropdown
                              try { setCreateTag(""); setCreateTagDirty(false) } catch (err) { }
                              try { document.getElementById("createGroup-abcz082458wer").click() } catch (err) { }
                            }}
                            type="button"
                            value="cancel"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </div>

            <div className="platform-filter-row">
              <Dropdown className="platform-select-dropdown">
                <Dropdown.Toggle as="button" type="button" className="platform-select-toggle" id="platform-select-toggle-apptracking">
                  <span className="platform-select-toggle-inner">
                    {selectedPlatform !== 'all' && <PlatformIcon platform={selectedPlatform} size={16} />}
                    <span>
                      {selectedPlatform === 'all'
                        ? 'All Platforms'
                        : (getActivePlatforms().find(p => p.id === selectedPlatform)?.display_name || 'Platform')}
                    </span>
                  </span>
                  <ChevronDown size={14} className="platform-select-chevron" aria-hidden="true" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="platform-select-menu">
                  <Dropdown.Item
                    className={`platform-select-item ${selectedPlatform === 'all' ? 'active' : ''}`}
                    onClick={() => { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_PLATFORM_FILTER_CHANGED, { platform: 'all' }); setSelectedPlatform('all') }}
                  >
                    All Platforms
                  </Dropdown.Item>
                  {getActivePlatforms().map(p => (
                    <Dropdown.Item
                      key={p.id}
                      className={`platform-select-item ${selectedPlatform === p.id ? 'active' : ''}`}
                      onClick={() => { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_PLATFORM_FILTER_CHANGED, { platform: p.id }); setSelectedPlatform(p.id) }}
                    >
                      <PlatformIcon platform={p.id} size={16} />
                      <span>{p.display_name}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* Discard-create-group confirmation modal */}
            <Modal show={showDiscardModal} onHide={handleDiscardCancel} centered>
              <Modal.Header closeButton>
                <Modal.Title>Discard changes?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                You have an unsaved group name. Do you want to discard it and continue?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleDiscardCancel}>
                  Stay
                </Button>
                <Button variant="danger" onClick={handleDiscardConfirm}>
                  Discard and Continue
                </Button>
              </Modal.Footer>
            </Modal>

            <div
              ref={cardsSectionRef}
              className="apps_game_inn gap-3"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                gap: 12,
                paddingRight: 8,
                overflowY: 'visible',
                maxHeight: 'none',
              }}
            >
              {showAppTrackingOnboarding && appTrackingOnboardingStep === 2 && (
                <>
                  <div className="kt-backdrop-overlay"></div>
                  <div className="kt-highlight-box kt-highlight-box--apptrack-trackmore"></div>
                </>
              )}
              {(displayedGames && displayedGames.length === 0 && (loading || isFetchingApps.current)) ? (
                // simple skeletons while apps are loading
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="apps_game_inn_box d-flex align-items-end" key={`skeleton-${idx}`}>
                    <div style={{ width: 96, height: 54, background: '#2a2a35', borderRadius: 8 }} />
                    <p style={{ width: 140 }}>
                      <span style={{ display: 'block', height: 12, background: '#2a2a35', marginTop: 8, borderRadius: 4 }}></span>
                    </p>
                    <div style={{ marginLeft: 'auto' }}>
                      <div className="spinner-border spinner-border-sm text-light" role="status" style={{ width: '1rem', height: '1rem' }} />
                    </div>
                  </div>
                ))
              ) : (
                (() => {
                  // Show paginated results: only show up to `visibleCount` apps and
                  // render a "Show More" control when more are available.
                  const visibleGames = displayedGames.slice(0, visibleCount)
                  return (
                    <>
                      {visibleGames.map((game, index) => {
                        // Blur and lock apps that are marked as locked in the API response
                        const isLockedApp = Boolean(game?.game_details?.is_locked)
                        const shouldBlur = isLockedApp
                        return (
                          <React.Fragment key={game.game_details.item_id}>
                            <div
                              className="apps_game_inn_box d-flex align-items-end"
                              draggable={!shouldBlur}
                              onDragStart={e => { if (!shouldBlur) handleDragStart(e, index) }}
                              onDragEnd={handleDragEnd}
                              onDragEnter={e => { if (!shouldBlur) handleDragEnter(e, index) }}
                              onDragOver={handleDragOver}
                              onDrop={handleDrop}
                              onClick={() => {
                                if (isLockedApp) {
                                  // For locked apps, open the subscription ended modal instead of navigating
                                  setUpgradeModalTitle(subscriptionEndedTitle)
                                  setShowUpgradeModal(true)
                                } else {
                                  navigate(
                                    `/xr/app/${generateSlug(game.game_details.name || '')}?id=${game.game_details.item_id}`,
                                    { state: { selected_tab: 2, data: game.game_details, source_surface: "app_tracking_list" } }
                                  )
                                }
                              }}
                              style={{
                                flex: '0 0 320px',
                                width: 320,
                                padding: 10,
                                boxSizing: 'border-box',
                                transition: 'transform 120ms ease, box-shadow 120ms ease',
                                cursor: shouldBlur ? 'pointer' : 'pointer',
                                position: 'relative',
                                ...(shouldBlur ? { filter: 'blur(4px)', opacity: 0.6 } : {}),
                                ...(draggingIndex === index ? { transform: 'scale(1.03)', boxShadow: '0 12px 30px rgba(246,37,90,0.18)', border: '1px solid rgba(246,37,90,0.14)', zIndex: 9998 } : {})
                              }}
                            >
                              {shouldBlur && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10,
                                    cursor: 'pointer',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    borderRadius: 'inherit'
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    // Locked app: always show the subscription ended title
                                    setUpgradeModalTitle(subscriptionEndedTitle)
                                    setShowUpgradeModal(true)
                                  }}
                                >
                                  <svg
                                    width="48"
                                    height="48"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ color: '#fff', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}
                                  >
                                    <path
                                      d="M12 1C8.96243 1 6.5 3.46243 6.5 6.5V9.5C5.67157 9.5 5 10.1716 5 11V19C5 19.8284 5.67157 20.5 6.5 20.5H17.5C18.3284 20.5 19 19.8284 19 19V11C19 10.1716 18.3284 9.5 17.5 9.5H16.5V6.5C16.5 3.46243 14.0376 1 11 1H12ZM8.5 6.5C8.5 4.567 10.067 3 12 3C13.933 3 15.5 4.567 15.5 6.5V9.5H8.5V6.5ZM12 13.5C12.8284 13.5 13.5 14.1716 13.5 15C13.5 15.8284 12.8284 16.5 12 16.5C11.1716 16.5 10.5 15.8284 10.5 15C10.5 14.1716 11.1716 13.5 12 13.5Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </div>
                              )}
                              <div style={{ position: 'relative', display: 'block', width: '100%', flex: '0 0 auto' }}>
                                <img
                                  src={game.game_details.image_url}
                                  alt={game.game_details.name}
                                // keep image sizing and positioning unchanged
                                />
                                <button
                                  onClick={e => { e.stopPropagation(); if (loading) return; setPendingRemoveId(game.game_details.item_id); setPendingRemoveName(game.game_details.name); setShowRemoveConfirm(true) }}
                                  title="Remove app"
                                  aria-label={`Remove ${game.game_details.name}`}
                                  style={{ position: 'absolute', top: 6, right: 6, background: '#222', color: '#fff', border: 'none', borderRadius: '50%', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                >
                                  &times;
                                </button>
                              </div>

                              {/* Central area: contains name on top and a two-column metrics row beneath it. */}
                              {(() => {
                                const metrics = getLatestMetrics(
                                  game.game_details.item_id
                                )

                                return (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 12,
                                      flex: 1,
                                      marginLeft: 12,
                                    }}
                                  >
                                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, marginBottom: 4 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                          <p
                                            title={game.game_details.name}
                                            style={{
                                              margin: 0,
                                              fontWeight: 600,
                                              color: '#fff',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              display: '-webkit-box',
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: 'vertical',
                                              maxHeight: 40,
                                            }}
                                          >
                                            {game.game_details.name}
                                          </p>
                                          <span
                                            style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
                                            onClick={e => openPlatformLink(e, game)}
                                            title={`Open ${game.game_details.platform || 'store'}`}
                                            onMouseDown={e => e.stopPropagation()}
                                          >
                                            <PlatformIcon platform={game.game_details.platform} size={16} />
                                          </span>
                                        </div>

                                        <div style={{ marginTop: 2, display: 'block' }} onClick={e => e.stopPropagation()}>
                                          <span style={{ color: '#fff', fontSize: 12, fontWeight: 600, display: 'inline-block', marginRight: 6 }}>Tracked On:</span>
                                          <span style={{ color: '#A1ACB8', fontSize: 12, fontWeight: 400 }}>
                                            {(() => {
                                              const raw = game.tracked_on || game.start_date || game.game_details?.start_date || game.game_details?.start_date || game.game_details?.start_date || game.game_details?.start_date || game.game_details?.start_date || null
                                              return raw ? formatPerformanceDate(raw) : '--'
                                            })()}
                                          </span>
                                        </div>
                                      </div>

                                      {metrics ? (
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                          {/* left column (stacked key:value) - flexible */}
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, color: '#bfbfbf', fontSize: 12, flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>KTR</strong>
                                              <UpgradeGatedContent
                                                value={formatCompactOption3(metrics.ktr)}
                                                isLocked={isUpgradeRequired(metrics?.ktr)}
                                                onClick={() => openUpgradeModal()}
                                                title={metrics.ktr != null ? String(metrics.ktr) : undefined}
                                                style={{ fontSize: 12 }}
                                              />
                                            </div>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>AUR</strong>
                                              <UpgradeGatedContent
                                                value={formatCompactOption3(metrics.aur)}
                                                isLocked={isUpgradeRequired(metrics?.aur)}
                                                onClick={() => openUpgradeModal()}
                                                title={metrics.aur != null ? String(metrics.aur) : undefined}
                                                style={{ fontSize: 12 }}
                                              />
                                            </div>
                                            <div style={{ display: 'flex', gap: 8 }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>ASR</strong>
                                              {(() => {
                                                const asrLocked = isUpgradeRequired(metrics?.asr)
                                                const display = asrLocked ? '--' : formatCompactOption3(metrics.asr)
                                                const title = (!asrLocked && metrics.asr != null) ? String(metrics.asr) : undefined
                                                return <span title={title}>{display}</span>
                                              })()}
                                            </div>
                                          </div>

                                          {/* right column (mirror left's key:value style) - auto sized */}
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, color: '#bfbfbf', fontSize: 12, flex: '0 0 auto' }}>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>KU</strong>
                                              <UpgradeGatedContent
                                                value={formatCompactOption3(metrics.ku)}
                                                isLocked={isUpgradeRequired(metrics?.ku)}
                                                onClick={() => openUpgradeModal()}
                                                title={metrics.ku != null ? String(metrics.ku) : undefined}
                                                style={{ fontSize: 12 }}
                                              />
                                            </div>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>DL</strong>
                                              <UpgradeGatedContent
                                                value={formatCompactOption3(metrics.d)}
                                                isLocked={isUpgradeRequired(metrics?.d)}
                                                onClick={() => openUpgradeModal()}
                                                title={metrics.d != null ? String(metrics.d) : undefined}
                                                style={{ fontSize: 12 }}
                                              />
                                            </div>
                                            <div style={{ display: 'flex', gap: 8 }}>
                                              <strong style={{ color: '#E8E8E8', minWidth: 28 }}>URV</strong>
                                              {(() => {
                                                const urvLocked = isUpgradeRequired(metrics?.urv)
                                                const display = urvLocked ? '--' : formatCompactOption3(metrics.urv)
                                                const title = (!urvLocked && metrics.urv != null) ? String(metrics.urv) : undefined
                                                return <span title={title}>{display}</span>
                                              })()}
                                            </div>
                                            {/* revenue hidden as requested */}
                                          </div>
                                        </div>
                                      ) : (
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                          {/* Loading skeleton */}
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
                                            {[1, 2, 3].map(i => (
                                              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                <div style={{ width: 28, height: 12, background: '#2a2a35', borderRadius: 4 }}></div>
                                                <div style={{ width: 40, height: 12, background: '#2a2a35', borderRadius: 4 }}></div>
                                              </div>
                                            ))}
                                          </div>
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: '0 0 auto' }}>
                                            {[1, 2, 3].map(i => (
                                              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                <div style={{ width: 28, height: 12, background: '#2a2a35', borderRadius: 4 }}></div>
                                                <div style={{ width: 50, height: 12, background: '#2a2a35', borderRadius: 4 }}></div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )
                              })()}
                              {
                                (() => {
                                  // Show two actions under the metrics row: View and Analytics.
                                  // Keep these small links right-aligned and stop propagation
                                  // so clicking them doesn't navigate the whole card.
                                  return (
                                    <div style={{ width: '100%', marginTop: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                      <a
                                        // href={`/gamedashboard?id=${game.game_details.item_id}`}
                                        // onClick={e => { e.preventDefault(); e.stopPropagation(); navigate(`/gamedashboard?id=${game.game_details.item_id}`, { state: { selected_tab: 0 } }) }}
                                        href={`/xr/app/${generateSlug(game.game_details.name || '')}?id=${game.game_details.item_id}`}
                                        onClick={e => { e.preventDefault(); e.stopPropagation(); navigate(`/xr/app/${generateSlug(game.game_details.name || '')}?id=${game.game_details.item_id}`, { state: { selected_tab: 0, data: game.game_details, source_surface: "app_tracking_list" } }) }}
                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F6255A'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(246,37,90,0.12)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#2a2a35'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                                        style={{ color: '#fff', textDecoration: 'none', padding: '6px 10px', borderRadius: 6, backgroundColor: '#2a2a35', border: '1px solid rgba(255,255,255,0.06)', fontWeight: 600, transition: 'all 0.12s ease' }}
                                        title={`View ${game.game_details.name}`}
                                        aria-label={`View ${game.game_details.name}`}
                                      >
                                        About
                                      </a>

                                      <a
                                        // href={`/gamedashboard?id=${game.game_details.item_id}`}
                                        // onClick={e => { e.preventDefault(); e.stopPropagation(); navigate(`/gamedashboard?id=${game.game_details.item_id}`, { state: { selected_tab: 2 } }) }}
                                        href={`/xr/app/${generateSlug(game.game_details.name || '')}?id=${game.game_details.item_id}`}
                                        onClick={e => { e.preventDefault(); e.stopPropagation(); navigate(`/xr/app/${generateSlug(game.game_details.name || '')}?id=${game.game_details.item_id}`, { state: { selected_tab: 2, data: game.game_details, source_surface: "app_tracking_list" } }) }}
                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F6255A'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(246,37,90,0.12)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#2a2a35'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                                        style={{ color: '#fff', textDecoration: 'none', padding: '6px 10px', borderRadius: 6, backgroundColor: '#2a2a35', border: '1px solid rgba(255,255,255,0.06)', fontWeight: 600, transition: 'all 0.12s ease' }}
                                        title={`Analytics ${game.game_details.name}`}
                                        aria-label={`Analytics ${game.game_details.name}`}
                                      >
                                        Analytics
                                      </a>
                                    </div>
                                  )
                                })()
                              }
                            </div>

                            {/* Insert Track More beside the last visible app; Show More/Less
                              is rendered below the cards for consistent placement. */}
                            {index === visibleGames.length - 1 && (
                              <div
                                key={`track-more-before-${visibleCount}`}
                                ref={trackMoreButtonRef}
                                className="apps_game_inn_box d-flex align-items-center add_game"
                                role="button"
                                tabIndex={0}
                                onClick={() => handleOpenKeywordModal(activeGroup || null)}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenKeywordModal(activeGroup || null) } }}
                                style={{ cursor: 'pointer', marginRight: 8 }}
                              >
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); handleOpenKeywordModal(activeGroup || null) }}
                                  className="keyword-add-btn"
                                >
                                  <i className="fa-solid fa-plus"></i> Track More
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                      {/* If the active group is selected but contains no apps, still show Track More */}
                      {(Array.isArray(displayedGames) && displayedGames.length === 0 && (activeGroup || (!activeGroup && comparisonList.length === 0))) && (
                        <div
                          ref={trackMoreButtonRef}
                          className="apps_game_inn_box d-flex align-items-center add_game"
                          role="button"
                          tabIndex={0}
                          onClick={() => handleOpenKeywordModal(activeGroup || null)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenKeywordModal(activeGroup || null) } }}
                          style={{ cursor: 'pointer', marginRight: 8 }}
                        >
                          <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); handleOpenKeywordModal(activeGroup || null) }}
                            className="keyword-add-btn"
                          >
                            <i className="fa-solid fa-plus"></i> Track More
                          </button>
                        </div>
                      )}
                    </>
                  )
                })()
              )}

              {/* Show More / Show Less control placed below the cards for consistent layout */}
              <div style={{ width: '100%', marginTop: 12, display: 'flex', justifyContent: 'center' }}>
                {displayedGames && displayedGames.length > visibleCount ? (
                  <button
                    type="button"
                    onClick={() => setVisibleCount(prev => prev + 10)}
                    className="keyword-add-btn"
                    disabled={loading}
                    aria-label={`Show more, ${displayedGames.length - visibleCount} more`}
                    style={{ ...showTileStyle, minWidth: 180, height: 40, padding: '8px 14px', borderRadius: 10, display: 'inline-flex', gap: 8 }}
                  >
                    <i className="fa-solid fa-chevron-down" style={{ fontSize: 12, opacity: 0.95 }} aria-hidden="true"></i>
                    <span style={{ fontSize: 13 }}>Show more</span>
                    <span style={{ opacity: 0.9, fontSize: 12, marginLeft: 8 }}>({displayedGames.length - visibleCount})</span>
                  </button>
                ) : visibleCount > 10 ? (
                  <button
                    type="button"
                    onClick={() => setVisibleCount(10)}
                    className="keyword-add-btn"
                    disabled={loading}
                    aria-label={`Show less`}
                    style={{ ...showTileStyle, minWidth: 140, height: 40, padding: '8px 14px', borderRadius: 10, display: 'inline-flex', gap: 8 }}
                  >
                    <i className="fa-solid fa-chevron-up" style={{ fontSize: 12, opacity: 0.95 }} aria-hidden="true"></i>
                    <span style={{ fontSize: 13 }}>Show less</span>
                  </button>
                ) : null}
              </div>

            </div>

            {showAppTrackingOnboarding && appTrackingOnboardingStep === 2 && (
              <div className="kt-explanation-box kt-explanation-box--apptrack-trackmore">
                <button
                  type="button"
                  className="kt-skip-all-btn"
                  onClick={skipAllTutorials}
                >
                  Skip All
                </button>
                <div className="kt-explanation-text">
                  Click <strong>Track More</strong> to add more apps to this list.
                </div>
                <div className="kt-explanation-arrow kt-arrow-to-apptrack-trackmore"></div>
                <div className="kt-explanation-nav">
                  <button
                    type="button"
                    className="kt-nav-btn kt-nav-btn--prev"
                    onClick={() => setAppTrackingOnboardingStep(1)}
                  >
                    &lt; Prev
                  </button>
                  <button
                    type="button"
                    className="kt-nav-btn kt-nav-btn--next"
                    onClick={completeAppTrackingOnboarding}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}

          </div>

        </div>
        <KeywordTrackingDetailsModal
          show={showKeywordModal}
          handleClose={() => {
            setCreateTag("")
            setShowKeywordModal(false)
          }}
          title={createTag ? "Select an App or Game to Create Group" : "Select an App or Game"}
          searchTerm={modalSearchTerm}
          onSearchChange={e => setModalSearchTerm(e.target.value)}
          results={searchResults}
          loading={loading}
          trackedIds={trackedIds}
          createTag={createTag}
          onRemoveFromTag={handleModalRemoveFromTag}
          tags={groups}
          onBulkAddToTag={handleBulkAddToTag}
          onAddToTag={handleAddSingleToTag}
          onOpenGroup={(groupName) => {
            try { setShowKeywordModal(false) } catch (e) { }
            try { setActiveGroup(groupName) } catch (e) { }
          }}
          // When modal-internal search detects an UPGRADE response, open Upgrade modal here
          onUpgrade={() => {
            openUpgradeModal()
            setShowKeywordModal(false)
            setSearchResults([])
          }}
          enableBulkActions={true}
          onSelectApp={async app => {
            try {
              // Guests can't be authorized to track apps. Two guest shapes
              // exist in this app (see api_helper.js's `isGuest` check):
              // (1) fully anonymous - no `authToken` at all, and
              // (2) "continue as guest" - a real `authToken` IS present, but
              // `authUser.data.is_guest`/`authUser.is_guest` is true.
              // Either way the backend would reject/short-track the request
              // in a shape that never matches `isUpgradeError`/
              // `isUpgradeResponse` below, so show the same "Upgrade your
              // plan" modal Basic-tier users see at the 5-app limit up front
              // instead of silently failing.
              const hasAuthToken = Boolean(localStorage.getItem('authToken'))
              const isGuestUser = (() => {
                try {
                  const authUser = JSON.parse(localStorage.getItem('authUser'))
                  return authUser?.data?.is_guest === true || authUser?.is_guest === true
                } catch (e) {
                  return false
                }
              })()
              if (!hasAuthToken || isGuestUser) {
                openUpgradeModal()
                setShowKeywordModal(false)
                setCreateTag(null)
                return
              }

              if (createTag) {
                // Create group mode
                // If the app is not currently tracked, track it first.
                const isTracked = Array.isArray(trackedIds) && trackedIds.includes(app.item_id)
                if (!isTracked) {
                  try {
                    const trackRes = await axios.post(`${api}/tracker/tracking/app/`, { item_id: app.item_id }, {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                      },
                    })

                    if (isUpgradeResponse(trackRes.data)) {
                      // Show upgrade modal and do NOT proceed to add tagging
                      openUpgradeModal()
                      setShowKeywordModal(false)
                      setCreateTag(null)
                      return
                    }

                    try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_ADDED, { app_id: app.item_id, app_name: app.game_details?.name || app.name }) } catch (e) { }

                    // Refresh tracked apps list after successful tracking
                    await callAppTrackapi()
                  } catch (err) {
                    console.error('Error tracking app before tagging:', err)
                    if (isUpgradeError(err)) {
                      openUpgradeModal()
                      setShowKeywordModal(false)
                      setCreateTag(null)
                      return
                    }
                    // If tracking failed for other reasons, rethrow so outer catch handles it
                    throw err
                  }
                }

                // Don't create the tag here — the modal's own flow will add the
                // tracked app to the requested tag (it calls the tag API when
                // `addToTagAfter` is supplied). We only need to ensure the app
                // is tracked; let the modal perform the add-to-tag and close itself.
              } else {
                // Track app mode
                const res = await axios.post(
                  `${api}/tracker/tracking/app/`,
                  { item_id: app.item_id },
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "authToken"
                      )}`,
                      Accept: "application/json, text/plain, */*",
                    },
                  }
                )

                if (isUpgradeResponse(res.data)) {
                  setShowUpgradeModal(true)
                  setShowKeywordModal(false)
                  return
                }

                localStorage.setItem("tracked_item_id", app.item_id)
                try { trackEvent(ANALYTICS_EVENTS.FEATURE.APP_TRACKING_APP_ADDED, { app_id: app.item_id, app_name: app.game_details?.name || app.name }) } catch (e) { }

                await callAppTrackapi()
                // Ensure the newly tracked app appears at the start of the comparison list
                setComparisonList(prev => {
                  try {
                    const idx = prev.findIndex(p => p.game_details && p.game_details.item_id === app.item_id)
                    if (idx === -1) return prev
                    const item = prev[idx]
                    const without = [...prev.slice(0, idx), ...prev.slice(idx + 1)]
                    const result = [item, ...without]
                    try { setSessionItem('comparisonBetween', result) } catch (err) { }
                    try { setLocalItem('comparisonBetween', result) } catch (err) { }
                    return result
                  } catch (err) {
                    return prev
                  }
                })
                // Force an immediate performance refresh after tracking
                try {
                  await refreshPerformanceData()
                } catch (err) {
                  console.error("Error refreshing performance data:", err)
                }

                setShowKeywordModal(false)
                // Notify user the app was tracked
                try { triggerToast(`Tracked "${app.game_details?.name || app.name}"`, 'success') } catch (e) { }

                setTimeout(() => {
                  navigate("/apptracking", { state: { item_id: app.item_id } })
                }, 100)
              }
            } catch (error) {
              console.error("Operation failed:", error)
              if (isUpgradeError(error)) {
                setShowUpgradeModal(true)
                setShowKeywordModal(false)
              }
            }
          }}
        />
      </div>

      {/* Onboarding tutorial styles for App & Game Tracking */}
      <style>{`
        .kt-backdrop-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
          /* Block interaction with everything under the backdrop */
          pointer-events: auto;
          /* No blur directly on the page content so the highlighted controls/tutorial stay crisp */
        }

        .kt-highlight-box {
          position: fixed;
          border: 2px solid rgba(246, 37, 90, 0.8);
          border-radius: 12px;
          pointer-events: none;
          z-index: 1000;
          box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
          animation: kt-pulse 2s ease-in-out infinite;
        }

        @keyframes kt-pulse {
          0%, 100% { border-color: rgba(246, 37, 90, 0.6); }
          50% { border-color: rgba(246, 37, 90, 1); }
        }

        .kt-highlighted {
          position: relative;
          z-index: 1001;
        }

        .kt-explanation-box {
          position: fixed;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 12px;
          padding: 20px 16px 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
          z-index: 1002;
          min-width: 280px;
          max-width: 320px;
          box-sizing: border-box;
        }

        .kt-explanation-box--apptrack-search {
          /* Positioned dynamically via JavaScript */
        }

        .kt-explanation-box--apptrack-filter {
          /* Positioned dynamically via JavaScript */
        }

        .kt-explanation-box--apptrack-trackmore {
          /* Positioned dynamically via JavaScript */
        }

        .kt-skip-all-btn {
          position: absolute;
          top: 8px;
          right: 8px;
          background: transparent;
          border: none;
          color: #999;
          font-size: 12px;
          cursor: pointer;
          padding: 6px 8px;
          min-height: 32px;
          min-width: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          z-index: 1003;
          transition: all 0.2s;
        }

        .kt-skip-all-btn:hover,
        .kt-skip-all-btn:focus {
          background: rgba(246, 37, 90, 0.1);
          color: #F6255A;
          outline: none;
        }

        .kt-skip-all-btn:active {
          transform: scale(0.95);
        }

        .kt-explanation-text {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
          margin-top: 15px;
          margin-bottom: 8px;
          word-wrap: break-word;
          white-space: normal;
          text-align: left;
        }

        .kt-explanation-text strong {
          color: #F6255A;
          font-weight: 600;
        }

        .kt-explanation-arrow {
          position: fixed;
          height: 3px;
          background: #F6255A;
          z-index: 1003;
          pointer-events: none;
        }

        .kt-arrow-to-apptrack-search,
        .kt-arrow-to-apptrack-filter,
        .kt-arrow-to-apptrack-trackmore {
          /* Positioned dynamically via JavaScript */
        }

        .kt-explanation-arrow::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 0;
          height: 0;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          transform: translateY(-50%);
        }

        /* Search/Add step: box on the right, arrow at left end pointing left towards the Add button */
        .kt-arrow-to-apptrack-search::after {
          left: 0; /* Arrowhead at the left end of the line */
          border-right: 10px solid #F6255A; /* Points left */
          border-left: none;
        }

        /* Filter step: box on the right, arrow at left end pointing left towards the filter toggles */
        .kt-arrow-to-apptrack-filter::after {
          left: 0; /* Arrowhead at the left end of the line */
          border-right: 10px solid #F6255A; /* Points left */
          border-left: none;
        }

        /* Track More step: box on the right, arrow at left end pointing left towards the Track More button */
        .kt-arrow-to-apptrack-trackmore::after {
          left: 0; /* Arrowhead at the left end of the line */
          border-right: 10px solid #F6255A; /* Points left */
          border-left: none;
        }

        .kt-explanation-nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
          padding-top: 10px;
          border-top: 1px solid #eee;
          gap: 8px;
        }

        .kt-nav-btn {
          background: transparent;
          border: none;
          color: #666;
          font-size: 14px;
          cursor: pointer;
          padding: 8px 12px;
          min-height: 44px;
          min-width: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          transition: all 0.2s;
          flex: 1;
          font-weight: 500;
        }

        .kt-nav-btn:hover,
        .kt-nav-btn:focus {
          color: #F6255A;
          background: rgba(246, 37, 90, 0.1);
          outline: none;
        }

        .kt-nav-btn:active {
          transform: scale(0.97);
        }

        .kt-nav-btn--next {
          font-weight: 600;
          color: #F6255A;
          background: rgba(246, 37, 90, 0.1);
        }

        .kt-nav-btn--next:hover,
        .kt-nav-btn--next:focus {
          background: rgba(246, 37, 90, 0.2);
        }

        /* Tablet styles (768px - 1024px) */
        @media (max-width: 1024px) and (min-width: 769px) {
          .kt-explanation-box {
            max-width: 300px;
            padding: 18px 14px 10px;
          }
          .kt-explanation-text {
            font-size: 13px;
          }
        }

        /* Mobile styles */
        @media (max-width: 768px) {
          .kt-explanation-box {
            min-width: calc(100vw - 32px);
            max-width: calc(100vw - 32px);
            width: calc(100vw - 32px);
            left: 16px !important;
            right: 16px !important;
            margin: 0 auto;
            border-radius: 16px;
            padding: 20px 16px 14px;
          }

          .kt-explanation-text {
            font-size: 15px;
            line-height: 1.6;
            text-align: left;
            margin-top: 12px;
            margin-bottom: 10px;
          }

          .kt-skip-all-btn {
            top: 10px;
            right: 10px;
            font-size: 13px;
            padding: 8px;
            min-height: 36px;
            min-width: 36px;
          }

          .kt-explanation-nav {
            margin-top: 12px;
            padding-top: 12px;
            gap: 10px;
          }

          .kt-nav-btn {
            font-size: 15px;
            padding: 10px 16px;
            min-height: 48px;
            border-radius: 8px;
          }

          /* Hide arrows on mobile for cleaner look */
          .kt-explanation-arrow {
            display: none;
          }

          /* Adjust backdrop for mobile */
          .kt-backdrop-overlay {
            background: rgba(0, 0, 0, 0.6);
          }
        }

        /* Small mobile styles */
        @media (max-width: 480px) {
          .kt-explanation-box {
            min-width: calc(100vw - 24px);
            max-width: calc(100vw - 24px);
            width: calc(100vw - 24px);
            left: 12px !important;
            right: 12px !important;
            padding: 18px 14px 12px;
          }

          .kt-explanation-text {
            font-size: 14px;
          }

          .kt-nav-btn {
            font-size: 14px;
            padding: 10px 14px;
          }
        }
      `}</style>
    </div>
  )
}
